// The id starts counting at 0.
export function getPuzzle(id: number) {
  return FENS[id]
}

// Deterministically select today's puzzle.
export function getPuzzleIdOfToday() {
  // Determine the number of days between today and 2025-09-26.
  const MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Note that months are 0-based.
  const puzzleDate0 = Date.UTC(2025, 8, 26);
  const now = new Date();
  const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));

  return mod(Math.floor((today.getTime() - puzzleDate0) / MS_PER_DAY), FENS.length);
}

export function previousPuzzleId(id: number) {
  return mod(id - 1, FENS.length)
}

export function nextPuzzleId(id: number) {
  return mod(id + 1, FENS.length)
}

export function totalNrOfPuzzles() {
  return FENS.length
}

// When doing "x % y", JavaScript doesn't guarantee that the final value is between 0 and y. It can be negative.
// That is annoying. So we use this method instead.
function mod(x: number, y: number) {
  return ((x % y) + y) % y;
}

const FENS = [
  "8/8/b2K4/kp2N3/p7/P1P5/8/8 w - - 0 1",
  "8/6b1/5p2/P1k5/8/7p/2N2K1P/8 w - - 0 1",
  "8/2p3pb/8/4kpK1/P7/2N2P2/8/8 w - - 0 1",
  "8/8/2k4b/P7/8/8/2N2PKp/8 w - - 0 1",
  "8/8/6p1/3Npk2/P6P/7P/4K3/1b6 w - - 0 1",
  "8/8/b4N2/p4P1P/p2k4/8/2P5/4K3 w - - 0 1",
  "8/8/8/PN2pk1P/8/4K3/b7/8 w - - 0 1",
  "8/8/N7/P4k1P/4p3/4K2b/8/8 w - - 0 1",
  "5k2/8/1p6/1pP3N1/1P6/8/1b6/3K4 w - - 0 1",
  "2k4b/2P5/8/6N1/8/P7/2K5/8 w - - 0 1",
  "b2kN3/8/5P2/8/p7/p7/P3K3/8 w - - 0 1",
  "b7/4kp2/6p1/1N2PP2/1p6/1P6/5K2/8 w - - 0 1",
  "7b/8/k1P5/4Np1p/5P2/K5P1/8/8 w - - 0 1",
  "8/kp6/8/3P4/3N4/1P6/8/1b1K4 w - - 0 1",
  "6b1/8/8/1P2k3/4p3/4N3/4P3/4K3 w - - 0 1",
  "8/7b/P1k2pp1/1N3P2/8/4pP2/8/2K5 w - - 0 1",
  "8/7p/1p2p2b/P2k4/3P4/3K2N1/7P/8 w - - 0 1",
  "8/5p2/5P2/4P1k1/8/p7/P7/2KN1b2 w - - 0 1",
  "8/5p2/2K5/p4p2/4k2P/8/P1N5/5b2 w - - 0 1",
  "8/p4b2/1p1p4/PPk4p/K6p/3PPNpP/6P1/8 w - - 0 1",
  "8/1p2N1K1/8/3P3p/5p1k/3b3P/5P2/8 w - - 0 1",
  "2k5/2P5/1p1p3N/8/1P5b/4PK2/8/8 w - - 0 1",
  "8/p7/P2p2K1/1Pkp4/5N1b/4P3/2P5/8 w - - 0 1",
  "2N5/8/P6K/5k1p/3p4/8/4P3/5b2 w - - 0 1",
  "4b3/p7/4NK2/5N2/8/P4k2/1P2p3/8 w - - 0 1",
  "8/8/p1p5/p4p1k/P2P2p1/3N2P1/3P2P1/1b1K4 w - - 0 1",
  "4k3/3p1N2/8/P1P4b/8/8/7K/8 w - - 0 1",
  "5b2/1p4p1/p7/k1P1N3/8/8/P1K3P1/8 w - - 0 1",
  "1k5b/p7/1P4K1/N7/3p4/3P4/8/8 w - - 0 1",
  "b1k2N2/8/1K6/8/4p3/8/4B3/8 w - - 0 1",
  "k7/6b1/B7/3p3K/1N6/8/8/8 w - - 0 1",
  "k7/6N1/2N5/3p3K/4B3/8/1b6/8 w - - 0 1",
  "8/7N/8/3p3b/3k4/3P4/2PK4/8 w - - 0 1",
  "8/8/N2b4/8/K2N4/pPk5/8/8 w - - 0 1",
  "3b4/8/6p1/6Pk/7P/8/5KP1/2N5 w - - 0 1",
  "8/8/2k5/5b2/P7/8/1P6/3K3N w - - 0 1",
  "8/2b2pp1/K2p4/p4P2/P7/6P1/8/2k3B1 w - - 0 1",
  "8/3p4/3P4/3p4/1B1k1K2/8/2PP4/4b3 w - - 0 1",
  "k7/P7/8/2PK4/3p4/3P1B2/7p/6b1 w - - 0 1",
  "1B4b1/2N5/7K/8/8/k7/2P5/8 w - - 0 1",
  "8/8/5pb1/2K5/5P2/B5k1/8/4N3 w - - 0 1",
  "4K3/8/1B1kp3/2N2p2/5P2/8/4b3/8 w - - 0 1",
  "2k5/8/1P1P4/8/7p/p1p1p2P/P1P1P2P/b1K5 w - - 0 1",
  "8/7p/5P1k/1p5P/5p2/2p1p3/P1P1P1P1/1K3Nb1 w - - 0 1",
  "1k4b1/5p2/5P2/4N3/8/5K2/8/8 w - - 0 1",
  "1nb1k3/3p4/p1pP1K2/P1P5/6N1/8/8/8 w - - 0 1",
  "1k6/1p6/PP6/7b/5K1N/8/8/7n w - - 0 1",
  "n7/1kp3b1/1p1p1p2/1PPP4/7K/6N1/8/8 w - - 0 1",
  "4K1nk/7p/8/7P/8/4N3/8/8 w - - 0 1",
  "4k3/8/8/4n3/4B2P/N1K5/7p/8 w - - 0 1",
  "5Bk1/4K2N/n7/8/5N2/8/5P2/b7 w - - 0 1",
  "4k3/3b4/3ppK2/4n3/2PN4/4P3/4B3/8 w - - 0 1",
  "8/8/4p3/3k1P2/3p4/8/2P5/Bn3K2 w - - 0 1",
  "8/1p5k/4pP2/6B1/8/1P6/8/1n4K1 w - - 0 1",
  "n6k/8/8/6P1/3K4/3B4/8/8 w - - 0 1",
  "6k1/4p3/n3K3/p3p3/8/PB4P1/8/8 w - - 0 1",
  "1R6/k1nK4/Np2n3/1P6/8/8/8/8 w - - 0 1",
  "kn3n2/8/1p1K4/1P6/8/7R/8/8 w - - 0 1",
  "8/7K/7P/1P6/2n4k/4n3/1P6/8 w - - 0 1",
  "2b5/2n2K1k/8/8/8/8/RP6/8 w - - 0 1",
  "7b/4K1kn/8/8/R4P2/8/8/8 w - - 0 1",
  "6n1/3p4/3P1k2/7R/7K/8/8/8 w - - 0 1",
  "8/2b5/8/4N3/8/4K3/8/3Bk1B1 w - - 0 1",
  "1b1r4/7k/8/2K5/1N2N3/3B4/8/8 w - - 0 1",
  "8/8/2pN4/k7/8/p2K1b2/P7/2B5 w - - 0 1",
  "5kNB/8/5N2/3K4/8/2p5/8/1b6 w - - 0 1",
  "8/8/1B5p/5N2/4BR2/4r3/4k1K1/2q3b1 w - - 0 1",
  "8/8/7p/3bN3/3N3b/3BP3/3k4/6K1 w - - 0 1",
  "8/8/8/4B3/4N1K1/8/7p/5k1b w - - 0 1",
  "8/1N6/7k/8/6B1/7N/4K1bP/2b5 w - - 0 1",
  "4N3/8/8/7b/4kB1b/8/B5K1/4N3 w - - 0 1",
  "8/5N2/8/4n3/3B4/5k1P/7b/5K2 w - - 0 1",
  "3k2qB/7R/4p3/K1P3N1/8/8/8/2b5 w - - 0 1",
  "8/6B1/8/8/3N4/4k3/8/2b1K3 w - - 0 1",
  "8/2p2p2/4NB2/8/8/b3k3/N1p5/4K3 w - - 0 1",
  "2N5/8/b2Kp2B/8/3k4/8/8/5N2 w - - 0 1",
  "8/8/6k1/4b3/4n2P/8/2K3N1/1B6 w - - 0 1",
  "8/8/7k/p1N5/7P/2p5/1P2K3/3B2b1 w - - 0 1",
  "8/8/3b2k1/8/2B1K3/6P1/2N3n1/8 w - - 0 1",
  "3K4/B3p3/8/7N/7n/8/6k1/3N1b2 w - - 0 1",
  "8/8/7k/8/7P/2p5/4KN2/3B2b1 w - - 0 1",
  "8/8/k7/N5B1/B1K1b3/b7/8/7N w - - 0 1",
  "6Bb/3p2k1/8/N3K3/7P/8/8/8 w - - 0 1",
  "1B6/8/1R6/2k5/n7/8/K3N3/3b4 w - - 0 1",
  "8/5nbB/1K6/B2N4/2k5/8/8/8 w - - 0 1",
  "8/8/6b1/k7/P7/6N1/1K5B/8 w - - 0 1",
  "8/2Pk4/4N3/8/8/5pB1/1K1b4/8 w - - 0 1",
  "7B/1p6/N1N5/8/8/1k6/4K3/6b1 w - - 0 1",
  "k1N5/8/8/bK2B3/4bp2/3N4/8/8 w - - 0 1",
  "4N3/3k4/8/8/bKn5/8/N7/7B w - - 0 1",
  "8/8/8/2k5/b5K1/1B6/5p1N/4N3 w - - 0 1",
  "5b2/8/2N5/2k5/8/P7/7B/K7 w - - 0 1",
  "1k6/2p5/B7/4Np2/8/8/6p1/6Kb w - - 0 1",
  "8/2K1p1p1/4b3/7P/6p1/2k5/6N1/6B1 w - - 0 1",
  "8/1B3p2/7K/4Pk2/8/5p2/3N1p1b/8 w - - 0 1",
  "N3b3/8/1B1k4/3P2Kp/8/8/8/8 w - - 0 1",
  "5kb1/3p4/N6K/3P4/2n5/8/5N2/6B1 w - - 0 1",
  "b6k/7p/2p5/8/8/2N5/3B4/1K6 w - - 0 1",
  "4KN2/B2n4/3k4/3p4/b3B3/8/8/2N5 w - - 0 1",
  "7k/3b3P/7N/8/4p2K/8/8/2B5 w - - 0 1",
  "Nk6/N6b/B5p1/8/8/8/8/6K1 w - - 0 1",
  "8/8/2p1p3/8/1N6/1k1K2B1/N1p5/6b1 w - - 0 1",
  "6bB/5p2/5K1k/8/8/6N1/8/8 w - - 0 1",
  "4K3/4b3/4k3/4p3/4p3/p3P3/4N3/1B6 w - - 0 1",
  "8/2B4N/8/1b6/2p5/2pP4/2K2k2/3B2b1 w - - 0 1",
  "2k2B2/2Np4/6KN/8/2b4P/8/6n1/8 w - - 0 1",
  "2b4k/3pK2N/8/1p6/8/8/3B4/8 w - - 0 1",
  "7k/4b3/6K1/7N/8/8/8/2B5 w - - 0 1",
  "7k/8/4K3/B1b4N/8/8/8/8 w - - 0 1",
  "8/8/5p2/3N3b/4B3/2K5/8/2k5 w - - 0 1",
  "5k2/2N5/7b/5K2/8/8/1B6/8 w - - 0 1",
  "6N1/5b2/8/4K2k/4B2N/8/8/8 w - - 0 1",
  "3N4/8/8/7N/4K1kb/8/8/2B5 w - - 0 1",
  "8/p4K2/1B5N/2N5/1p5k/8/8/6b1 w - - 0 1",
  "7N/7k/7B/1b6/4K3/8/8/1B6 w - - 0 1",
  "b3Nk2/8/3K4/8/8/p4P2/B7/8 w - - 0 1",
  "B1k2b1N/3n4/8/8/K7/4P3/2nN3B/8 w - - 0 1",
  "8/8/6B1/8/8/2K5/8/2kbN3 w - - 0 1",
  "1Bk1N3/8/2K2b2/8/8/8/8/8 w - - 0 1",
  "8/7B/1N6/1P4Nb/8/2BKp3/3p4/2k5 w - - 0 1",
  "8/4p2N/7B/7k/7b/4K2P/8/8 w - - 0 1",
  "8/8/4N3/1kP4b/1p1p4/1B4K1/8/8 w - - 0 1",
  "2B5/5b2/8/2pk1NK1/8/8/8/8 w - - 0 1",
  "5B2/8/2K5/N4pN1/5k2/8/8/4b3 w - - 0 1",
  "1N6/k1p2B2/8/8/n1K3b1/5N2/1B6/8 w - - 0 1",
  "8/2B1N1k1/8/8/1N6/8/2K1p3/4b3 w - - 0 1",
  "8/1B1N1k2/8/8/N7/8/1K1p4/3b4 w - - 0 1",
  "8/4n3/1K1N2P1/7B/b7/5n2/2N1k3/8 w - - 0 1",
  "6B1/6p1/b6p/1N3k2/5B1K/8/8/8 w - - 0 1",
  "8/7p/2P2K2/8/bk3b2/8/5B2/1N4N1 w - - 0 1",
  "2N5/1b6/6n1/n7/1k1K4/6BN/8/1B6 w - - 0 1",
  "8/8/1bNN3n/8/7B/3k1K2/8/8 w - - 0 1",
  "8/8/2K3B1/8/4N3/1b3n2/2k2N2/8 w - - 0 1",
  "8/8/1B2k3/3NPp2/8/3K4/8/4b3 w - - 0 1",
  "3N4/8/k1n3b1/1N6/8/1B3K2/8/8 w - - 0 1",
  "8/8/8/b1K4p/4k1P1/8/2N5/B7 w - - 0 1",
  "Bb6/6k1/2K5/6Bp/6N1/6N1/2b5/8 w - - 0 1",
  "2k5/5N2/8/8/8/1b2K3/6B1/3N4 w - - 0 1",
  "8/2K3N1/p6B/k7/p6b/8/8/8 w - - 0 1",
  "8/8/8/p1p4B/k7/7b/K3N3/8 w - - 0 1",
  "2K2b2/5p2/4Pk2/1N6/8/8/8/4B3 w - - 0 1",
  "1k6/3K1b2/8/8/1N6/8/4B3/8 w - - 0 1",
  "3K4/1k6/1p2b3/1N6/8/8/8/5B2 w - - 0 1",
  "5kN1/8/1B1K2p1/8/6N1/6p1/7P/4b3 w - - 0 1",
  "3B4/1p6/Nb6/8/K4N2/2k5/p1P5/8 w - - 0 1",
  "N5b1/2p5/3k2B1/8/5K2/7N/8/8 w - - 0 1",
  "8/8/8/7K/8/1N3N2/1p2B1b1/7k w - - 0 1",
  "8/b7/8/p7/2N5/3N4/kB4n1/3K4 w - - 0 1",
  "1k6/N4P1n/2K5/3P3b/8/5p2/8/3B4 w - - 0 1",
  "kN6/8/2p5/K1p5/2P5/3b2p1/8/7B w - - 0 1",
  "B7/P6b/k5p1/2K5/8/4N3/8/8 w - - 0 1",
  "1b2N3/8/8/5K1k/8/8/5B2/8 w - - 0 1",
  "8/8/b7/B1K5/1P5b/k1N5/8/6N1 w - - 0 1",
  "1b3N1k/8/1N4K1/8/6b1/8/8/6B1 w - - 0 1",
  "6N1/N3p3/k5b1/8/2K5/8/8/7B w - - 0 1",
  "8/8/n6N/5K1k/8/8/7b/4BN2 w - - 0 1",
  "7B/b4p1N/1p5k/4K3/4p3/7p/8/5N2 w - - 0 1",
  "8/2K5/6kP/1b4p1/4N3/8/8/3B4 w - - 0 1",
  "8/8/6Bk/7N/3N3K/3b4/8/8 w - - 0 1",
  "3N4/1n1B2B1/8/3k4/1K6/1p1bb3/8/2N5 w - - 0 1",
  "8/5b2/8/1K3N2/4B3/Pk6/8/8 w - - 0 1",
  "8/8/k7/P7/3B4/1KN5/8/2b5 w - - 0 1",
  "8/k5b1/4K3/2N5/8/8/8/6B1 w - - 0 1",
  "8/1p2B3/3p4/N7/3b2n1/7N/2B4k/5K2 w - - 0 1",
  "5K2/7k/B1N5/8/1pN5/6p1/8/3b4 w - - 0 1",
  "8/8/1K3b1B/8/1k6/5B2/bN6/1N6 w - - 0 1",
  "3b4/8/4K2B/8/7R/1N6/8/1kr5 w - - 0 1",
  "8/8/6k1/B7/2p4P/8/7b/1N2K3 w - - 0 1",
  "5b2/3p4/1K6/P3B3/Pk6/1N6/4p3/8 w - - 0 1",
  "n2k4/2p1N3/2K5/6pb/7p/7P/6N1/5B2 w - - 0 1",
  "K7/2b5/3p1p2/4k3/4P3/4N3/8/2B5 w - - 0 1",
  "2b5/K7/8/5p2/8/3B4/4N3/5k2 w - - 0 1",
  "2b5/K7/8/5p2/8/3B4/4N3/5k2 w - - 0 1",
  "2b5/K7/8/5p2/8/8/2B1Nk2/5N2 w - - 0 1",
  "2b5/K7/4p1p1/1p6/1B2B3/8/8/3k4 w - - 0 1",
  "8/5N1k/8/7b/1b5N/1K6/1B6/8 w - - 0 1",
  "8/4p3/B1K3b1/8/7B/4N3/7k/1N4b1 w - - 0 1",
  "5k2/b4n2/5p1N/2N5/8/7B/5BK1/3b4 w - - 0 1",
  "1N6/3pk3/5N2/8/8/7B/8/3b1Kb1 w - - 0 1",
  "5B2/2b5/4p1b1/5N2/1N6/k3K3/8/8 w - - 0 1",
  "8/3p4/4k1P1/2P5/1p2Np2/1P3P2/7K/5b2 w - - 0 1",
  "8/3Pk3/2p1p3/2p3N1/2P5/6P1/2b5/K7 w - - 0 1",
  "2k5/1pP4p/3p3P/3p1N2/1P3P2/8/5b2/7K w - - 0 1",
  "6kn/8/5K2/4N3/8/8/8/2B5 w - - 0 1",
  "8/4K2p/6kP/8/4N3/7B/8/n7 w - - 0 1",
  "8/b7/2P5/n3K3/2B5/p7/8/7k w - - 0 1",
  "4k3/4N3/4K3/4n3/8/8/4B3/8 w - - 0 1",
  "8/6p1/1k1B4/3P4/1p6/3K3n/6b1/3B1N2 w - - 0 1",
  "k7/8/2K5/8/2N5/8/6n1/3B4 w - - 0 1",
  "8/8/8/5K2/8/4N2n/7k/5B2 w - - 0 1",
  "8/8/4N1k1/8/5K2/8/B2n4/8 w - - 0 1",
  "8/8/3N4/8/kB6/3p4/K7/8 w - - 0 1",
  "8/8/3N4/8/kB6/3p4/K7/8 w - - 0 1",
  "4N3/8/4q1k1/1R6/8/4p3/4B2K/8 w - - 0 1",
  "2n5/8/3P3B/6N1/k2r4/3p4/K7/4R3 w - - 0 1",
  "7k/8/3NK3/8/1B6/1n6/8/8 w - - 0 1",
  "8/8/5k2/8/3N1K2/8/8/1Bn5 w - - 0 1",
  "8/8/8/4B3/1nb3K1/5N2/4PNk1/8 w - - 0 1",
  "5kBn/5pp1/2p5/1pK3p1/8/2N5/8/2B5 w - - 0 1",
  "k4BB1/q4N2/b1K5/2nN4/8/8/8/8 w - - 0 1",
  "3K4/5kpp/2Bn1p1P/8/8/6N1/8/8 w - - 0 1",
  "8/7N/5p2/5k2/2B4n/8/7K/8 w - - 0 1",
  "7b/7P/8/2n5/5K2/4N3/7B/1k6 w - - 0 1",
  "4B2k/6N1/8/6K1/6p1/4n3/7P/8 w - - 0 1",
  "4n3/7k/8/3PK3/8/7B/8/8 w - - 0 1",
  "8/7K/4b1N1/8/8/8/1k6/1N1Bn1B1 w - - 0 1",
  "3K2B1/8/6R1/P1n5/8/r7/N7/7k w - - 0 1",
  "8/8/B7/1p6/k5bn/N7/N3P2K/8 w - - 0 1",
  "6N1/8/8/b1p2np1/8/6BK/B7/7k w - - 0 1",
  "8/B7/1pNk4/8/2n5/8/8/3B1K2 w - - 0 1",
  "r7/8/1PpN1k2/3p4/pP6/2n5/1nK5/6B1 w - - 0 1",
  "4k1B1/8/3K4/8/1n3N2/8/8/8 w - - 0 1",
  "4b3/2N5/8/pR6/k3K2B/8/3p4/8 w - - 0 1",
  "7n/8/4b3/1K6/3N4/B7/4N3/3k4 w - - 0 1",
  "k7/8/2K3B1/3N1N2/8/8/7p/7n w - - 0 1",
  "b1k5/8/7n/3N4/2N5/1B4K1/8/8 w - - 0 1",
  "8/8/7B/1N1p4/2k2Kn1/8/8/8 w - - 0 1",
  "8/8/n7/8/3B4/7K/8/3N3k w - - 0 1",
  "2k1N3/1pb5/4K1N1/B2n4/8/8/8/8 w - - 0 1",
  "n4k2/1N6/K4p2/5p2/2B5/8/8/8 w - - 0 1",
  "k2B4/8/8/1p2p1K1/5P2/1P3Nb1/4n3/8 w - - 0 1",
  "8/B2N1n2/k2p4/2p5/4K3/2p5/2P5/8 w - - 0 1",
  "k2N4/8/n7/8/1R6/p4K2/1Pb5/8 w - - 0 1",
  "3B3k/6NB/8/1n6/2N3nP/1K3b2/8/8 w - - 0 1",
  "8/3b4/2N1p3/8/B7/2nP3n/1N3P2/k1B4K w - - 0 1",
  "4K1n1/8/B4p2/3N4/7b/8/8/k2N4 w - - 0 1",
  "7k/8/4B3/p1pN3n/8/4K3/8/8 w - - 0 1",
  "4N3/8/8/1B4K1/8/2k1n3/8/N7 w - - 0 1",
  "k2N1B2/8/8/4p1p1/1P2p3/4Kp2/8/2n5 w - - 0 1",
  "8/4N3/kP6/nN1K4/4pp2/8/6b1/5B2 w - - 0 1",
  "2N5/3k4/6N1/n2K4/4B3/8/6n1/8 w - - 0 1",
  "5B2/1b4PN/4K3/5P2/7n/3p3k/6n1/8 w - - 0 1",
  "5B2/1b4PN/4K3/5P2/7n/3p3k/6n1/8 w - - 0 1",
  "5B2/1b4PN/4K3/5P2/7n/3p3k/6n1/8 w - - 0 1",
  "1k4B1/8/8/n1K3N1/8/8/8/8 w - - 0 1",
  "8/8/8/8/5K2/4N3/7k/1B2n3 w - - 0 1",
  "7k/8/5NKB/8/3n4/8/8/8 b - - 0 1",
  "4n2k/8/8/4KN2/2B5/8/8/8 w - - 0 1",
  "2kn4/4K3/8/p7/3N4/1B6/8/8 w - - 0 1",
  "8/8/k5P1/3K4/8/5n2/5B2/7b w - - 0 1",
  "2B1k3/8/1N4n1/3K4/7P/8/8/8 w - - 0 1",
  "n7/2P4k/7p/3K4/8/8/8/5B2 w - - 0 1",
  "8/8/8/3K4/8/P5N1/8/1n1k1B2 w - - 0 1",
  "5B2/1n6/1k6/3K4/B7/8/8/8 w - - 0 1",
  "6n1/8/8/4k1K1/8/8/6B1/2B5 w - - 0 1",
  "k1K5/8/8/8/8/1BB5/1n6/b7 w - - 0 1",
  "2KB4/2n5/5Pk1/8/7b/8/4B3/8 w - - 0 1",
  "4BknK/7p/1B2p3/8/1p6/8/8/8 w - - 0 1",
  "6n1/2B1pk1K/8/8/1p6/3B4/8/8 w - - 0 1",
  "8/8/1B6/8/6Bk/8/3p1p1K/8 w - - 0 1",
  "8/8/8/2B5/6Bk/8/3p1p1K/8 w - - 0 1",
  "8/8/BB6/8/2K2p2/1p5N/4P3/4kb2 w - - 0 1",
  "8/8/8/BB6/2K5/1pp5/4k3/8 b - - 0 1",
  "4bB1k/8/8/6K1/4B3/8/8/8 w - - 0 1",
  "8/8/8/3N4/K3bB2/8/3p4/1k3B2 w - - 0 1",
  "8/4b3/3p4/B2K1kP1/8/8/B7/8 w - - 0 1",
  "B7/3k4/2N5/B7/5K2/8/6b1/6b1 w - - 0 1",
  "5b2/7b/4K1p1/7N/1k6/8/8/B2B4 w - - 0 1",
  "4B3/8/8/5n1P/K2p4/8/b7/2BkN3 w - - 0 1",
  "8/3k4/3P4/8/5K2/8/8/1B2B1b1 w - - 0 1",
  "n3k3/8/4P3/8/6K1/8/4B2B/1b6 w - - 0 1",
  "6b1/8/1K1k2B1/3P4/3p4/8/8/4B3 w - - 0 1",
  "1k3b2/8/1K4B1/2p5/5p2/8/1B6/8 w - - 0 1",
  "8/6p1/p3B1p1/p1B5/K1P5/8/bk6/8 w - - 0 1",
  "1N6/8/8/2pB4/1B1k2n1/1P6/3Kp3/5b2 w - - 0 1",
  "8/8/5k1p/7P/2N4b/8/4N2K/8 w - - 0 1",
  "8/1b2Kp2/8/5N1k/1N6/7P/8/8 w - - 0 1",
  "8/7p/3Pr3/6k1/8/1b1N3K/5N2/8 w - - 0 1",
  "5b2/4p3/N7/Pk2N3/8/8/K7/8 w - - 0 1",
  "k7/bp6/1p6/8/8/2N5/6K1/2N5 w - - 0 1",
  "6k1/6pb/N5p1/K5N1/8/8/8/8 w - - 0 1",
  "k3N3/bp6/1p6/8/8/1N3K2/8/8 w - - 0 1",
  "6k1/b4pPp/8/p3N3/3p4/N7/3P4/4K3 w - - 0 1",
  "3B4/3P3n/8/1Kp5/4N3/kb6/8/8 w - - 0 1",
  "5b2/4N3/5k2/n4p2/8/5K2/3BP3/8 w - - 0 1",
  "n6B/8/K1k5/8/8/8/P1N5/2b5 w - - 0 1",
  "k7/7B/8/8/1N1b4/K7/8/n7 w - - 0 1",
  "k7/nN6/1K3b2/8/8/8/8/7B w - - 0 1",
  "8/3Bp2p/7n/1N6/8/8/k5b1/2K5 w - - 0 1",
  "K7/b5p1/1k6/2N3p1/8/5B2/8/7n w - - 0 1",
  "1N6/6k1/1B2K3/8/1P2n3/1P6/b7/8 w - - 0 1",
  "8/b7/7P/5n2/p6p/k1B4K/4p3/2N5 w - - 0 1",
  "3n2k1/3N4/7P/6N1/8/K7/7P/4b3 w - - 0 1",
  "5kbK/8/8/8/6B1/6B1/8/6n1 w - - 0 1",
  "4kbK1/8/8/8/5B2/8/8/n2B4 w - - 0 1",
  "4kbK1/8/8/8/8/3B4/3B4/1n6 w - - 0 1",
  "2kbK3/7n/8/8/8/2B5/6B1/8 w - - 0 1",
  "7K/p6b/6k1/n2B4/7B/8/8/8 w - - 0 1",
  "8/Bp2p2K/P7/5k2/4n3/1B6/4b3/8 w - - 0 1",
  "k7/1r2BB2/4R3/5P2/1p3K2/4n3/pP6/3b4 w - - 0 1",
  "7n/8/8/8/4K3/k3N3/8/4B2n w - - 0 1",
  "n6k/4N3/3pBp2/7n/6K1/8/8/8 w - - 0 1",
  "6n1/3B4/8/6B1/8/8/3K1n2/1k6 w - - 0 1",
  "K1k5/8/8/8/1B6/8/8/nn1B4 w - - 0 1",
  "n7/8/2K5/4B2k/8/7B/4n3/8 w - - 0 1",
  "2k5/K2n4/8/8/8/3B4/8/1n2B3 w - - 0 1",
  "8/3n4/8/1k5B/5B2/2K5/8/5n2 w - - 0 1",
  "8/8/4k3/8/2nB4/8/4K3/1B1n4 w - - 0 1",
  "nB6/7p/2n4p/7K/8/7k/B7/8 w - - 0 1",
  "8/6K1/3P1B2/3B4/8/3n2n1/7p/4k3 w - - 0 1",
  "2b5/1kp5/3P2B1/8/N7/5P2/8/2b4K w - - 0 1",
  "2k1N3/4p2p/P7/8/B3P3/2b2K1P/8/5b2 w - - 0 1",
  "4b3/3p4/1P1k4/6p1/p7/5NP1/BP4K1/2b5 w - - 0 1",
  "1B3b2/5N2/8/8/4k3/8/6bP/4K3 w - - 0 1",
  "6b1/2N3b1/1p1pp3/4p1p1/1Pk5/P7/3K2P1/1B6 w - - 0 1",
  "5k2/1p1B1P2/1p1b3P/8/6N1/1PK4b/8/8 w - - 0 1",
  "2b5/N2k2p1/3p1P2/b7/6N1/5K2/8/8 w - - 0 1",
  "7b/3N4/k2Pp1p1/6P1/8/8/K5N1/3b4 w - - 0 1",
  "2k4b/2P5/4N3/8/1N2b3/P7/8/2K5 w - - 0 1",
  "k7/5Nb1/bP6/1N6/8/P7/2K5/8 w - - 0 1",
  "8/1N1b4/7p/5p1k/2N2P2/5PK1/8/2b5 w - - 0 1",
  "6b1/8/2p2p1p/2B2k2/7P/1P1K1P2/4B3/2b5 w - - 0 1",
  "6b1/8/B3p2p/B3Pp2/4kb1P/8/2K3PP/8 w - - 0 1",
  "2B5/4pp1p/8/B5b1/3kP1P1/3b4/3P1P2/4K3 w - - 0 1",
  "1B6/2K5/1p6/8/b3BkN1/8/8/8 w - - 0 1",
  "8/b7/2K5/1p2k3/8/4B3/p7/2N2N2 w - - 0 1",
  "6b1/p6N/B1N5/2k5/5p2/8/5p2/K7 w - - 0 1",
  "5N2/4n3/8/7k/7b/3NB2K/8/8 w - - 0 1",
  "4bn2/k7/8/5K2/2NN3B/8/8/8 w - - 0 1",
  "7k/2n5/7N/7K/1B6/8/5N1b/8 w - - 0 1",
  "nk6/8/5K2/4N3/7B/b2N4/8/8 w - - 0 1",
  "6b1/1k2K3/n7/8/NN6/7B/8/8 w - - 0 1",
  "5B2/7N/pK6/1B3b2/6k1/8/4N3/3n4 w - - 0 1",
  "2B5/2b3p1/5B2/7K/1N4p1/8/3k4/1n2N3 w - - 0 1",
  "1B6/8/4N3/4p3/8/b2n4/K1k5/3N4 w - - 0 1",
  "5b2/2NB4/8/6p1/8/2N3k1/5n2/6K1 w - - 0 1",
  "7n/8/3N4/2k5/8/8/4K2b/4BN2 w - - 0 1",
  "B7/2N5/6kb/3K2N1/5P2/8/n5pP/8 w - - 0 1",
  "1n2b2B/3p4/Pk6/5K2/3N4/N7/8/8 w - - 0 1",
  "k7/n7/8/B3N2B/8/1b6/8/K7 w - - 0 1",
  "k7/2pB2b1/4K3/2N5/2p5/8/8/1n4B1 w - - 0 1",
  "6b1/8/8/3N4/8/1B3knK/8/6B1 w - - 0 1",
  "3b4/8/2K5/7B/2N1k3/8/8/1nB5 w - - 0 1",
  "kB4b1/2K5/2n5/8/8/7B/3N4/8 w - - 0 1",
  "4n3/8/5p2/8/3k3B/1B1N3b/3K4/8 w - - 0 1",
  "nb5k/3BBp2/pp1pp3/6K1/3N4/8/8/8 w - - 0 1",
  "3B3b/3B4/8/4k3/4N2n/7K/8/8 w - - 0 1",
  "8/4N1n1/7k/2B5/8/4N2K/n7/8 w - - 0 1",
  "8/6n1/6N1/B5k1/1n4N1/7K/8/8 w - - 0 1",
  "KNk5/4n3/7n/8/2N5/6B1/8/8 w - - 0 1",
  "k7/8/2N5/3N4/8/b6K/6B1/3b4 w - - 0 1",
  "k4K2/8/5b2/2N5/N7/7b/5B2/8 w - - 0 1",
  "k1N5/8/5b1K/1bN5/8/4B3/8/8 w - - 0 1",
  "k7/8/5b1K/1n6/N3b3/3NB3/8/5B2 w - - 0 1",
  "1k1N4/8/1N4b1/8/8/4b3/6B1/7K w - - 0 1",
  "k2b1N2/5b2/8/1N6/8/8/8/5BK1 w - - 0 1",
  "b3B3/1k6/2N2b2/1K6/5B2/8/8/8 w - - 0 1",
  "1bB3b1/7k/K7/8/4N3/8/8/4B3 w - - 0 1",
  "8/b1K4N/4b1B1/4k3/8/8/8/4B3 w - - 0 1",
  "3N4/7n/k5K1/6b1/B7/7b/N7/6B1 w - - 0 1",
  "3kb3/8/8/8/3B4/3KN2B/8/4b3 w - - 0 1",
  "1B4b1/8/3N2B1/1K1k4/7b/8/8/8 w - - 0 1",
  "8/b7/4p1b1/4N3/2Bk4/8/3K3B/8 w - - 0 1",
  "bb6/3kp3/1Bp2p2/8/4N3/8/8/3B1K2 w - - 0 1",
  "8/8/8/3R4/2K5/b7/6n1/2B2k2 w - - 0 1",
  "1k3b2/4B2K/5r2/8/8/R7/8/8 w - - 0 1",
  "2R5/6pR/8/2K3b1/8/8/6p1/2B1k3 w - - 0 1",
  "7K/8/2b5/8/6kP/8/5R2/8 w - - 0 1",
  "1R6/7p/2kP4/3n3b/2p1K3/8/B7/8 w - - 0 1",
  "3b4/7k/4b2B/8/6R1/8/5K2/3N4 w - - 0 1",
  "1k1K4/8/8/r7/8/8/5b2/2R4R w - - 0 1",
  "8/7p/5n2/1k3K1b/8/RB6/8/8 w - - 0 1",
  "2kBb3/3R4/4K3/5P2/7b/8/8/8 w - - 0 1",
  "8/8/8/5K1R/8/4k3/5p2/3Rb3 w - - 0 1",
  "8/p6n/8/p4R2/N1k5/8/1K4b1/8 w - - 0 1",
  "7k/8/7r/7p/5B1N/5rb1/6K1/1R6 w - - 0 1",
  "8/1b6/8/p2k4/r4p2/1prPPR1R/8/1K1B4 w - - 0 1",
  "3k2b1/8/3K4/2R5/4p3/8/8/8 w - - 0 1",
  "6k1/8/4K3/R3p2p/8/8/3P3b/8 w - - 0 1",
  "6k1/8/4K3/3R4/3p4/8/7b/8 w - - 0 1",
  "6k1/b1K5/8/5R2/3p4/1n6/7N/8 w - - 0 1",
  "8/7p/6RR/4np2/5k2/8/5K1b/8 w - - 0 1",
  "8/Pk6/2R5/6p1/6pb/6p1/6Kp/8 w - - 0 1",
  "6kr/8/8/K3b3/3p4/8/5R2/2R5 w - - 0 1",
  "6k1/7b/2P5/3K4/R7/8/5b2/8 w - - 0 1",
  "1b5N/6p1/6B1/6k1/4n3/8/8/1bR2K2 w - - 0 1",
  "1b5N/7k/6R1/8/8/8/8/4K3 w - - 0 1",
  "8/b7/8/8/7K/1R6/2n5/N2k4 w - - 0 1",
  "8/r7/8/2B5/7K/8/1R6/N1k3b1 w - - 0 1",
  "6k1/8/5K2/8/4R3/7b/8/8 w - - 0 1",
  "6R1/7p/3b3P/2n4K/3p1N2/8/8/7k w - - 0 1",
  "R3K3/P7/8/k1b5/8/8/8/8 w - - 0 1",
  "8/4b3/4N3/5k2/8/3R1b2/3Kp3/8 w - - 0 1",
  "8/5R2/7P/8/b4K2/b7/7k/8 w - - 0 1",
  "8/R1K4k/R7/1bb5/8/8/8/8 w - - 0 1",
  "6b1/k4p2/2K5/5Rp1/8/8/8/8 w - - 0 1",
  "6k1/8/6K1/2p5/1b6/5R2/8/8 w - - 0 1",
  "8/8/8/k7/P1K5/2p5/2b5/5R2 w - - 0 1",
  "8/3B4/8/1p3K2/7p/5b1k/5b2/1R6 w - - 0 1",
  "8/1nK5/k7/8/8/8/6R1/8 w - - 0 1",
  "8/p2R4/p7/8/5K2/8/8/4k2n w - - 0 1",
  "8/k7/P4p2/1R6/4K3/8/2n5/8 w - - 0 1",
  "8/8/5R2/6n1/8/2k1K3/8/8 w - - 0 1",
  "1k1K3n/8/8/5p2/4p3/8/8/3R4 w - - 0 1",
  "n7/8/8/8/8/8/7k/3RK3 w - - 0 1",
  "3k4/8/2K5/2R5/8/8/4n3/8 w - - 0 1",
  "1n6/7k/8/b7/8/4R3/6P1/3K4 w - - 0 1",
  "8/7k/8/3K4/2P5/7b/R7/6n1 w - - 0 1",
  "5b2/8/8/1Kn5/3R4/8/P7/7k w - - 0 1",
  "6k1/8/8/4R3/5K2/8/1P2b3/2n5 w - - 0 1",
  "6n1/8/1b6/3K4/4R3/3P4/k7/8 w - - 0 1",
  "7n/3b4/8/2K5/5R2/8/5P2/1k6 w - - 0 1",
  "3k4/8/7n/8/5R2/Pb6/8/2K5 w - - 0 1",
  "7k/5b2/8/1pP3R1/8/8/n2K4/8 w - - 0 1",
  "7k/8/b7/8/8/4K3/6RP/2n5 w - - 0 1",
  "7n/1k6/8/2P5/8/1K4R1/8/5b2 w - - 0 1",
  "5k2/8/8/1b6/2R5/P1Kn4/8/8 w - - 0 1",
  "8/R4p2/P4P2/1k4n1/8/8/8/5b1K w - - 0 1",
  "8/8/3k1PR1/8/1K6/8/4b3/4n3 w - - 0 1",
  "5Rn1/7b/8/8/k5P1/8/3K4/8 w - - 0 1",
  "8/n6k/5R2/7b/8/4K3/7P/8 w - - 0 1",
  "8/1nK5/1P6/8/2b5/8/k7/1R6 w - - 0 1",
  "4k2b/1K6/8/3R4/8/8/2P5/5n2 w - - 0 1",
  "n3K3/P7/8/8/4k3/8/7b/6R1 w - - 0 1",
  "4b2K/8/1R6/1P6/4P3/6k1/8/2n5 w - - 0 1",
  "3bK2R/8/2n5/k7/8/8/7P/8 w - - 0 1",
  "2NR4/1n4n1/5K2/8/8/8/b5P1/6k1 w - - 0 1",
  "6n1/8/8/1k6/8/1P5n/1K6/3R4 w - - 0 1",
  "8/4n3/k7/6n1/8/PKR5/8/8 w - - 0 1",
  "5k2/n7/8/2R5/5P2/8/1n6/6K1 w - - 0 1",
  "1n6/8/8/7k/8/n7/5RP1/7K w - - 0 1",
  "1k6/8/K2R4/8/4nn2/1P4p1/8/3N4 w - - 0 1",
  "7k/b7/6b1/1RP5/8/K7/8/8 w - - 0 1",
  "1K6/8/2P5/6b1/bk6/8/8/4R3 w - - 0 1",
  "7k/8/1Pb4b/8/3R4/3K4/8/8 w - - 0 1",
  "1bb4k/8/8/8/8/8/3P4/2K3R1 w - - 0 1",
  "b7/2b5/8/1R6/6P1/7K/8/k7 w - - 0 1",
  "k4b2/8/1R6/8/8/8/3P4/2K2b2 w - - 0 1",
  "8/8/2R5/8/4P3/7b/3b1K2/k7 w - - 0 1",
  "7k/1b6/3b4/1K6/6R1/8/P7/8 w - - 0 1",
  "k7/8/b7/8/K3R3/2b3P1/8/8 w - - 0 1",
  "7k/8/2b5/8/3P4/4K1b1/8/R7 w - - 0 1",
  "7k/8/8/K7/7b/P3R3/6b1/8 w - - 0 1",
  "7b/1b6/8/6R1/2P5/4K3/8/3k4 w - - 0 1",
  "R7/5bb1/P7/1k6/4K3/8/8/8 w - - 0 1",
  "8/5b2/8/5P2/6R1/8/5K1p/b6k w - - 0 1",
  "2b5/3p4/4p3/7k/1b2P3/5K2/2P2P2/3R4 w - - 0 1",
  "5n2/1R4bk/2N5/5K2/8/8/8/8 w - - 0 1",
  "4n3/7k/b7/8/1K3N2/8/3R4/8 w - - 0 1",
  "8/6n1/4k1N1/8/1K6/6R1/8/5b2 w - - 0 1",
  "k1n5/8/8/3N3R/8/8/3b4/5K2 w - - 0 1",
  "1k4b1/2p1n2p/8/N1R5/8/8/8/K7 w - - 0 1",
  "8/8/7k/2N5/4R3/8/nb6/5K2 w - - 0 1",
  "7n/6b1/1k6/8/R7/4N3/2K5/8 w - - 0 1",
  "6n1/8/k3N3/8/8/K7/2b5/4R3 w - - 0 1",
  "8/2R1N2K/8/8/7k/b7/8/2n5 w - - 0 1",
  "3k4/8/8/K6R/8/5n2/8/3N2b1 w - - 0 1",
  "8/4K2p/b7/2R5/2N5/8/3n4/2k5 w - - 0 1",
  "6n1/8/6b1/1p6/k7/5N2/5R2/2K5 w - - 0 1",
  "k7/3nN2R/8/8/8/8/1b6/3K4 w - - 0 1",
  "n7/8/7k/1R6/p5K1/8/3N4/b7 w - - 0 1",
  "4k2K/8/8/8/4Nb2/8/3n3R/8 w - - 0 1",
  "8/4k3/4N3/n7/7b/4K3/8/R7 w - - 0 1",
  "8/8/7N/6k1/7b/8/1nK5/R7 w - - 0 1",
  "7K/4P3/4rPR1/8/8/b2N4/n7/7k w - - 0 1",
  "1K6/8/1b1N1p2/3R4/8/8/7k/n7 w - - 0 1",
  "b3N2n/8/8/8/8/8/1K1R4/7k w - - 0 1",
  "7k/8/4p3/7b/5n2/7N/6R1/7K w - - 0 1",
  "1b6/5N2/4R3/8/6k1/8/2n5/7K w - - 0 1",
  "8/n1R5/3N4/8/7k/8/1b5K/8 w - - 0 1",
  "KR6/4n2k/8/8/8/b5N1/8/8 w - - 0 1",
  "7n/8/3p4/1k6/6b1/2K5/4N3/2R5 w - - 0 1",
  "8/4K3/3n4/4b3/R7/N7/8/2k5 w - - 0 1",
  "8/2nN3R/4k3/8/p2K4/8/8/4b3 w - - 0 1",
  "8/p7/b4k2/p3R3/p1n5/B1N3p1/6K1/8 w - - 0 1",
  "8/8/8/8/p4R2/3n3N/8/Kb5k w - - 0 1",
  "8/5b2/8/6n1/k7/1R6/1KN5/8 w - - 0 1",
  "n7/3b4/8/1R6/1N6/5k2/8/7K w - - 0 1",
  "5bN1/p7/3Pk3/8/8/8/n3K3/6R1 w - - 0 1",
  "8/n4n1b/p7/5P2/k3N3/4R3/1K6/8 w - - 0 1",
  "5k2/3n4/3N4/8/8/7b/4R3/4K3 w - - 0 1",
  "8/3N1b2/1p6/Rp6/4B3/1p6/8/2Knk3 w - - 0 1",
  "4n2k/8/8/8/b5N1/2K5/5R2/8 w - - 0 1",
  "6kN/8/8/8/7b/3K4/4R3/3n4 w - - 0 1",
  "1n6/4k1b1/8/7R/5N2/7K/8/8 w - - 0 1",
  "1b3n2/7k/8/8/4R3/3N4/6K1/8 w - - 0 1",
  "2n5/3N2R1/b3p3/p7/7k/8/8/4K3 w - - 0 1",
  "8/1K2k3/8/8/4n3/8/6b1/1R1N1N2 w - - 0 1",
  "3K2bk/8/2p5/2N5/6n1/7B/3n4/1R6 w - - 0 1",
  "4k3/8/2N5/R7/2p5/8/n7/K6b w - - 0 1",
  "2k5/6R1/N7/8/8/6K1/7p/5b2 w - - 0 1",
  "8/8/4k3/8/8/Nb2K1R1/1n6/8 w - - 0 1",
  "2R5/4K2k/8/n3n3/3N4/8/8/8 w - - 0 1",
  "k7/3n4/5p2/8/1N6/2R5/1n6/7K w - - 0 1",
  "5n2/8/2k5/1R6/5K2/2N5/8/n7 w - - 0 1",
  "3k1n2/8/2K4n/4N1R1/8/8/8/8 w - - 0 1",
  "8/1R6/8/4K1p1/8/n5n1/3N2k1/8 w - - 0 1",
  "2n5/n7/5N2/8/8/7R/8/2k1K3 w - - 0 1",
  "3n4/5R2/5p2/2N5/7n/3K4/5k2/8 w - - 0 1",
  "7n/2n4N/8/8/8/8/2K4k/3R4 w - - 0 1",
  "8/8/6b1/R2KNkb1/8/8/8/8 w - - 0 1",
  "8/4k3/8/4N3/2R5/4b3/8/3b1K2 w - - 0 1",
  "8/6k1/b2N4/8/8/2R4K/5b2/8 w - - 0 1",
  "2b5/8/8/2N5/2R2K2/k7/8/b7 w - - 0 1",
  "5k2/7R/b7/8/1K3N2/8/1b6/8 w - - 0 1",
  "7k/8/8/8/3NR3/6b1/8/5b1K w - - 0 1",
  "5b2/8/2b5/Kp6/8/4N3/3R4/7k w - - 0 1",
  "k7/8/3N4/1p2R3/7K/5b2/8/2b5 w - - 0 1",
  "2b5/6kp/6N1/8/5K2/8/2R5/6b1 w - - 0 1",
  "5b2/2R5/1p6/1b6/1k6/2N5/2K5/8 w - - 0 1",
  "2K1k3/1p3N2/6b1/8/8/5R2/8/4b3 w - - 0 1",
  "5b2/8/8/7k/b3N3/7p/7K/6R1 w - - 0 1",
  "7k/8/8/1R6/3N4/8/6b1/4K1b1 w - - 0 1",
  "2b5/6k1/8/1N6/4R3/8/3b2K1/8 w - - 0 1",
  "4b3/7R/8/4N3/k7/8/K7/2b5 w - - 0 1",
  "6k1/8/6N1/8/6R1/K7/5b2/1b6 w - - 0 1",
  "7k/8/1b6/7N/6R1/6K1/2b5/8 w - - 0 1",
  "7k/3N4/8/8/8/4b2K/4b3/7R w - - 0 1",
  "8/7k/3R4/b1K5/7N/1b6/8/8 w - - 0 1",
  "5b2/1K6/7k/1b6/3R4/8/8/7N w - - 0 1",
  "2K1k3/8/4N3/7R/4b3/8/8/6b1 w - - 0 1",
  "2K1k3/8/1b2N3/6R1/4b3/8/8/8 w - - 0 1",
  "7b/1b6/8/2p5/8/K1RN3k/8/8 w - - 0 1",
  "7k/8/4R3/8/b7/5Nb1/8/7K w - - 0 1",
  "3k2K1/8/p7/8/3N4/8/3b2b1/1R6 w - - 0 1",
  "1b6/1p6/4K1b1/8/8/4N3/5R2/k7 w - - 0 1",
  "4b3/7p/7k/5K2/8/4N1b1/R7/8 w - - 0 1",
  "7k/5R2/K7/8/8/b6b/8/7N w - - 0 1",
  "4b3/R7/7b/1p6/2k4N/8/2K5/8 w - - 0 1",
  "3R3K/k7/5pN1/5p2/8/8/b7/4b3 w - - 0 1",
  "2b5/p5b1/8/7K/R4N2/8/8/4k3 w - - 0 1",
  "8/2k5/8/NK6/8/6R1/2bb4/8 w - - 0 1",
  "k7/8/b4N2/6b1/4R3/8/8/4K3 w - - 0 1",
  "2R5/8/8/8/k2N3b/8/8/3b3K w - - 0 1",
  "5k2/2pK4/8/2p3b1/2R5/8/4N1b1/8 w - - 0 1",
  "k7/8/b4b2/8/8/1KN5/3R4/8 w - - 0 1",
  "5k2/K3N3/6Rb/7p/8/8/8/3b4 w - - 0 1",
  "7b/8/8/4NBkp/8/8/b7/4K2R w K - 0 1",
  "2b2K2/8/8/8/N7/k7/1R6/4b2N w - - 0 1",
  "8/b7/8/5k2/7R/1b6/3KN3/8 w - - 0 1",
  "8/4k3/8/N5b1/8/3b1K1R/8/8 w - - 0 1",
  "1R6/8/8/1K6/8/5b2/2N3k1/2b5 w - - 0 1",
  "1b1B4/8/8/2K5/8/4P3/3Rbk2/N3r3 w - - 0 1",
  "7b/8/7k/8/b2N1R2/8/7p/7K w - - 0 1",
  "8/3k4/4N3/8/8/7b/1b5R/3K4 w - - 0 1",
  "4KR1n/6kP/8/8/3b4/8/8/1B6 w - - 0 1",
  "4K2n/6k1/6B1/1R6/8/b7/8/8 w - - 0 1",
  "8/3kb3/3n4/3K4/8/3B4/8/7R w - - 0 1",
  "B3k2b/R7/8/8/7n/8/8/1K6 w - - 0 1",
  "k7/8/3n4/8/7b/8/6R1/B5K1 w - - 0 1",
  "8/8/6pR/K6B/8/k6n/6b1/8 w - - 0 1",
  "b7/6n1/B7/2K5/8/5k2/R7/8 w - - 0 1",
  "R7/np6/2B2B2/3K4/8/1kb5/8/2n5 w - - 0 1",
  "7b/5n2/1k6/3R4/5B2/K7/8/8 w - - 0 1",
  "6R1/5n2/3k4/8/4K3/8/8/3Bb3 w - - 0 1",
  "8/8/5n2/1k6/8/6R1/2B5/2b1K3 w - - 0 1",
  "8/4R3/1k3B1n/8/8/8/2K2b2/8 w - - 0 1",
  "8/2B5/k7/8/2b2K2/5n2/8/7R w - - 0 1",
  "6k1/8/3K4/8/4b3/6nB/5R2/8 w - - 0 1",
  "8/5n2/1k6/6p1/8/2K1R3/8/1b2B3 w - - 0 1",
  "5K2/8/8/6n1/8/6b1/3R2Bk/8 w - - 0 1",
  "b7/2B2R2/k3p3/7K/8/7n/8/8 w - - 0 1",
  "4n3/2p5/6R1/2bk4/3p4/7B/3K4/8 w - - 0 1",
  "8/4n3/k2b4/8/1p2R3/8/6B1/2K5 w - - 0 1",
  "8/8/B7/p7/K7/R7/1k3b2/7n w - - 0 1",
  "3b3k/4n3/8/8/7B/8/8/5KR1 w - - 0 1",
  "2R5/1pN5/1Bk5/8/4N3/3K4/8/4q1b1 w - - 0 1",
  "3k4/8/1R6/3B4/8/8/nn6/7K b - - 0 1",
  "3R4/5b2/8/k2n4/8/K2B4/8/8 w - - 0 1",
  "k7/1R2p3/8/8/1p2b3/5n2/6B1/7K w - - 0 1",
  "4n3/2R2p2/4kp2/2K5/4B3/8/b7/8 w - - 0 1",
  "b2k4/1nR5/8/8/8/8/1K6/2B5 w - - 0 1",
  "1n6/2R5/5b2/4k3/6K1/8/8/2B5 w - - 0 1",
  "8/6R1/3n4/4k3/1B6/3K4/1b6/8 w - - 0 1",
  "5K1b/8/5n2/2R1B3/7k/8/8/8 w - - 0 1",
  "1B6/R6p/8/5n2/7p/5K2/8/2b2k2 w - - 0 1",
  "2R5/k2Bn3/1pP5/8/b7/2K5/8/8 w - - 0 1",
  "5n2/3R4/3p4/6b1/6B1/1K6/8/7k w - - 0 1",
  "b7/k1B5/8/6n1/KR6/1p6/8/8 w - - 0 1",
  "2k1B3/1pp4R/6n1/5b2/8/8/7K/8 w - - 0 1",
  "k7/p3p3/6p1/2Bb4/3p1n2/7B/8/4RK2 w - - 0 1",
  "8/6b1/8/8/1K3B2/8/3R4/4nk2 w - - 0 1",
  "2k5/5b2/8/4R2p/8/1n6/8/3B2K1 w - - 0 1",
  "8/4k3/8/B3n3/8/8/K2R4/4b3 w - - 0 1",
  "3k3K/8/1pbnB2R/p7/P7/8/8/8 w - - 0 1",
  "8/3bBR2/k7/5n2/8/8/1K6/8 w - - 0 1",
  "8/5K2/kB4p1/8/8/8/4n1R1/b7 w - - 0 1",
  "b4k2/8/n7/7B/8/8/8/1RK5 w - - 0 1",
  "8/1n5p/7p/7k/2R5/8/4b2K/1B6 w - - 0 1",
  "8/8/8/1n6/5k2/4N1Rb/5n1K/3B4 w - - 0 1",
  "R1B1n3/7p/6P1/p6k/8/8/8/1b2K3 w - - 0 1",
  "7b/8/8/1n1B3k/3p3p/8/6R1/5K2 w - - 0 1",
  "4B1k1/5p2/n7/6b1/8/8/2R5/7K w - - 0 1",
  "8/5k2/8/8/R7/8/K1n1b3/7B w - - 0 1",
  "6n1/3R4/8/2K5/8/1b6/8/1B4k1 w - - 0 1",
  "k5n1/p5n1/2b5/6N1/8/7B/6R1/6K1 w - - 0 1",
  "2b5/6p1/R2K4/8/8/3n4/8/1B4k1 w - - 0 1",
  "2n5/4pR2/p7/8/6k1/1B1b4/K7/8 w - - 0 1",
  "8/8/8/8/3nK3/4Bnk1/5R2/8 w - - 0 1",
  "8/R7/6n1/7k/8/3Bpn2/8/7K w - - 0 1",
  "8/2K5/7k/8/5R2/8/1p1p1B2/8 w - - 0 1",
  "B6n/8/4k3/1R6/8/8/2n5/7K w - - 0 1",
  "k4nn1/8/2R5/8/6B1/8/8/7K b - - 0 1",
  "3k4/1n1n4/4B1K1/7R/8/8/8/8 w - - 0 1",
  "1n6/7K/4k1B1/7R/8/n7/8/8 w - - 0 1",
  "8/k3B3/8/4n3/8/8/7R/n6K b - - 0 1",
  "8/6R1/4b3/8/7b/4K3/6Bk/8 w - - 0 1",
  "2b5/6b1/pB6/6K1/8/8/1k6/4R3 w - - 0 1",
  "1k6/6b1/4K3/8/R7/8/8/5bB1 w - - 0 1",
  "1k6/8/8/7R/8/4K3/2b3B1/4b3 w - - 0 1",
  "2b4b/7k/8/3p4/3p1K1p/8/4B3/4R3 w - - 0 1",
  "bk6/6R1/8/6B1/8/8/8/4b1K1 w - - 0 1",
  "2K2k2/1R6/8/8/5B2/2b2b2/8/8 w - - 0 1",
  "6b1/1k2B3/8/R7/8/6b1/2K5/8 w - - 0 1",
  "6b1/1R6/8/2b5/8/1p1k3B/8/1K6 w - - 0 1",
  "8/8/3b3k/8/2B5/3K4/6b1/2R5 w - - 0 1",
  "6b1/8/8/8/2k2K2/8/1RB2b2/8 w - - 0 1",
  "8/8/1p1R2B1/8/k7/8/6b1/2b1K3 w - - 0 1",
  "1b6/7k/8/R5K1/8/8/2b5/4B3 w - - 0 1",
  "1k6/8/8/b2p1K2/8/6R1/bB6/8 w - - 0 1",
  "4k3/8/3R4/4B3/8/8/2K5/6bb w - - 0 1",
  "4k3/2R5/K7/4B3/b7/4b3/8/8 w - - 0 1",
  "6k1/2b5/2b5/8/1K4B1/8/4R3/8 w - - 0 1",
  "8/7K/1k1B1b2/7b/4R3/8/8/8 w - - 0 1",
  "8/2b5/8/1pK2R2/8/8/b7/1k2B3 w - - 0 1",
  "6b1/8/3R4/6pB/8/2K1b3/8/7k w - - 0 1",
  "8/1k2B1b1/2p3P1/K6b/R7/8/8/8 w - - 0 1",
  "8/2K3k1/8/3B4/1R6/8/8/3b2b1 w - - 0 1",
  "8/2k1K3/4R3/8/8/2b4b/8/2B5 w - - 0 1",
  "k7/8/8/8/8/7b/1b3B2/3K2R1 w - - 0 1",
  "b5k1/2b5/7R/2K5/8/7B/8/8 w - - 0 1",
  "6k1/4R3/8/8/7K/5b2/8/1Bb5 w - - 0 1",
  "1b5k/3b4/8/8/4K2B/8/8/7R w - - 0 1",
  "1b2k3/8/8/2B5/8/5K1b/8/3R4 w - - 0 1",
  "8/1k6/7b/8/B2R4/8/8/3K1b2 w - - 0 1",
  "7k/8/8/R7/8/4b3/6bB/4K3 w - - 0 1",
  "4k3/8/3R4/5K2/7p/8/7B/2b2b2 w - - 0 1",
  "8/k7/7b/8/b1K2pR1/3B4/8/8 w - - 0 1",
  "1k6/8/8/3R1K2/7p/8/8/2b2bB1 w - - 0 1",
  "8/2p5/7K/2k2b2/7b/1B2R3/8/8 w - - 0 1",
  "6k1/7b/8/p7/2R5/B1K5/5b2/8 w - - 0 1",
  "1b5k/3b4/8/3K4/7B/2R5/8/8 w - - 0 1",
  "k6B/8/2R5/7p/7b/8/4K3/1b6 w - - 0 1",
  "k4b2/8/8/8/6b1/6B1/6R1/6K1 w - - 0 1",
  "k2b4/8/8/8/6b1/6B1/6R1/6K1 w - - 0 1",
  "8/6k1/4R3/8/b1K5/7B/8/6b1 w - - 0 1",
  "1b6/3b4/8/3B2R1/p7/5K2/8/k7 w - - 0 1",
  "1k6/7b/8/6R1/6p1/2b5/7K/2B5 w - - 0 1",
  "4k3/8/1K6/8/6R1/3b4/6B1/4b3 w - - 0 1",
  "2K2bb1/8/8/8/7k/3R4/6B1/8 w - - 0 1",
  "8/2p5/8/K7/8/8/4bb2/k4BR1 w - - 0 1",
  "7k/pR6/8/8/2K1p3/8/2b1B2b/8 w - - 0 1",
  "2k5/8/1K6/8/5R2/1bb5/8/5B2 w - - 0 1",
  "8/8/2p4b/2k1K3/1R6/5b2/8/2B5 w - - 0 1",
  "5B2/8/5b2/k4b2/2K5/6R1/8/8 w - - 0 1",
  "R3B3/8/p2p4/8/8/7K/1b6/1b5k w - - 0 1",
  "k7/8/8/4b3/8/1b3K2/5R2/7B w - - 0 1",
  "k7/pR1Bb3/8/8/b5p1/4N1p1/8/2K5 w - - 0 1",
  "6b1/2b1p3/8/8/5P2/3R4/7K/3B1k2 w - - 0 1",
  "7k/8/8/5B2/3R3K/5b2/8/2b5 w - - 0 1",
  "7k/8/3R2B1/8/8/8/6b1/2b1K3 w - - 0 1",
  "8/k3Bb2/p2p4/8/K7/8/6R1/4b3 w - - 0 1",
  "4B1b1/1R6/3p4/3P2b1/2k5/8/7K/8 w - - 0 1",
  "K7/2b5/p1B4p/k7/8/8/3R4/1b6 w - - 0 1",
  "k7/8/2bb4/8/8/8/1R2B3/3K4 w - - 0 1",
  "3k2K1/1p3p2/8/8/7b/3b4/RB6/8 w - - 0 1",
  "7R/8/5k2/8/1B6/1b1K4/8/6b1 w - - 0 1",
  "1b5k/p7/B7/8/b7/4K3/8/6R1 w - - 0 1",
  "7B/5p2/8/8/8/b1K5/2R5/4kb2 w - - 0 1",
  "4b3/5p2/3b4/R4K2/8/3k4/8/4B3 w - - 0 1",
  "5K2/1B4p1/1R6/8/2k4b/8/8/5b2 w - - 0 1",
  "b7/7k/4B3/7p/7K/b7/8/4R3 w - - 0 1",
  "8/2b1BR2/8/8/k7/3K4/8/7b w - - 0 1",
  "8/8/7R/3K4/6b1/8/k7/5Bb1 w - - 0 1",
  "3N2K1/8/1b6/1bk5/4B3/8/5R1n/8 w - - 0 1",
  "3b4/1p2p3/8/1B5b/8/8/k1K5/6R1 w - - 0 1",
  "k7/8/8/8/3R4/1b5K/8/bB6 w - - 0 1",
  "5b2/3P4/8/2k5/8/1b6/8/4K3 w - - 0 1",
  "8/6P1/7K/5b2/6k1/8/8/4b3 w - - 0 1",
  "b7/k7/8/8/8/bQ6/8/4K3 b - - 0 1",
  "2b5/2p5/7p/7K/2k3p1/2b5/8/1Q6 w - - 0 1",
  "K3b3/2P5/8/8/3bk3/8/8/8 w - - 0 1",
  "8/1K1b4/7Q/8/8/8/7b/4k2r w - - 0 1",
  "4k3/2P4b/8/b7/8/8/K7/8 w - - 0 1",
  "8/K2P4/3k2b1/8/8/6b1/8/8 w - - 0 1",
  "1b6/6P1/b7/4k3/8/8/8/4K3 w - - 0 1",
  "8/5P2/8/p6K/7b/8/b7/3k4 w - - 0 1",
  "3b4/3b4/1PP3p1/3P4/8/3k4/8/7K w - - 0 1",
  "8/8/8/8/8/8/3kb3/1K2b2Q w - - 0 1",
  "8/K2P4/8/6k1/4b3/8/7b/8 w - - 0 1",
  "8/1P2b3/8/8/2b2k2/8/8/1K6 w - - 0 1",
  "8/5p1k/6p1/5bK1/8/5Q2/6P1/b7 w - - 0 1",
  "4kr2/5p1K/3p1Q2/1p4P1/4P3/1PP5/7b/8 w - - 0 1",
  "r1rk4/1Kp1p3/8/2P5/8/8/4P3/5Q2 w - - 0 1",
  "1n2k1K1/4pp2/2P2P1P/5P2/2r5/2B5/6P1/8 w - - 0 1",
  "4k2r/2K2p2/6P1/2R2P2/8/8/7B/b7 w k - 0 1",
  "r3k3/8/p1PP4/P1P1K3/8/8/8/8 w q - 0 1",
  "r3k3/p7/P1PP4/2P1K3/8/8/8/8 w q - 0 1",
  "4k3/1p6/1r1p4/1p1P1B1P/1P6/2K5/8/8 w - - 0 1",
  "6n1/prp3k1/1p6/1P2K3/8/4N3/5R2/8 w - - 0 1",
  "4r3/5pp1/6p1/1P1k1PP1/6N1/5K2/8/8 w - - 0 1",
  "7k/1np5/1p6/P3p3/2P5/5K2/NP5r/8 w - - 0 1",
  "8/8/1p3P1k/1r6/4K3/P3N3/1P6/8 w - - 0 1",
  "8/p1k3p1/4P3/r7/Pp1K2P1/1p6/1P5P/2N5 w - - 0 1",
  "4N3/p3kp2/P3p1Pp/4Pr2/8/4P2P/2P4P/4K3 w - - 0 1",
  "r6N/pkpK4/p7/P1P5/8/8/8/8 w - - 0 1",
  "8/8/p7/1RpN4/2PPr3/b1pK4/8/k7 w - - 0 1",
  "6r1/3p3p/p3P2P/k7/1p1PN3/1P6/8/5K2 w - - 0 1",
  "8/8/3P1k2/N6p/8/8/P4KPr/8 w - - 0 1",
  "N7/8/P4p2/4kp2/2r5/5K2/3P1P2/8 w - - 0 1",
  "8/k6p/2P2p2/5N2/4r2P/1P6/7P/6K1 w - - 0 1",
  "8/1p4Np/8/8/1P1kr3/1P6/2PK1P2/8 w - - 0 1",
  "8/N7/1p1k4/6P1/1r6/1P3P1p/7P/K7 w - - 0 1",
  "8/N7/1p1k4/6P1/1r6/1P3P1p/7P/K7 w - - 0 1",
  "4k3/4p1p1/8/3P3P/1p6/5PPr/1P2N3/6K1 w - - 0 1",
  "1r6/1P3N2/8/2pkp2p/P1p3p1/4P3/2KP1P1P/8 w - - 0 1",
  "8/6r1/7N/5P2/k4P1p/2P4p/7K/8 w - - 0 1",
  "r5N1/3P4/8/6p1/2k2p2/8/5PP1/4K3 w - - 0 1",
  "8/1N5p/2P4k/6pP/3P1r2/7P/8/3bK3 w - - 0 1",
  "4k3/4r1p1/P7/6K1/p1pN4/P7/2P5/8 w - - 0 1",
  "8/1p1N4/8/4P3/8/1K2k3/1P6/1r6 w - - 0 1",
  "6N1/4P3/1Pk1r3/4p3/4P3/8/8/4K3 w - - 0 1",
  "3BN3/8/4p3/2p5/p1Pk4/P2PNK2/3p4/1r6 w - - 0 1",
  "N7/3p4/2pPp3/4p2P/1Pk5/7P/3P2r1/4K3 w - - 0 1",
  "8/P7/1kPK2N1/8/r7/8/8/8 w - - 0 1",
  "2N5/1p2p3/3Pk2P/8/P1rP4/8/8/3K4 w - - 0 1",
  "8/3P4/3r4/P1kP1K2/8/8/1N6/8 w - - 0 1",
  "8/8/3P1r2/2ppp3/3k4/P2P2N1/2P5/3K4 w - - 0 1",
  "4k3/4P3/4P3/8/p2N4/r7/P5P1/1K6 w - - 0 1",
  "5k2/p1p2P1p/N3p3/4P2P/2P5/3r3P/1P6/4K3 w - - 0 1",
  "6r1/3P3N/p1p5/k7/P7/K4p2/5P2/8 w - - 0 1",
  "8/k5p1/r1P5/p6P/p7/8/P7/K6R w - - 0 1",
  "8/Pp6/2pk3B/K4p2/5P2/2P5/8/2r5 w - - 0 1",
  "8/2N5/7p/3P2k1/4r3/4P3/6P1/7K w - - 0 1",
  "8/8/8/8/1bk5/2r5/1KP2B2/R7 w - - 0 1",
  "7k/1pB1p2p/1P2P2P/1p1r3p/1P5P/8/1P2P2P/4K3 w - - 0 1",
  "rk6/p2B4/1P6/PK6/8/8/8/8 w - - 0 1",
  "2r5/4k3/4P3/3R4/4P3/2PpK3/2p2BP1/8 w - - 0 1",
  "8/3p3p/2k3pP/5P2/8/1P2B3/4KPr1/8 w - - 0 1",
  "1BB3k1/8/7P/1p6/7P/5rp1/1P3p2/5K2 w - - 0 1",
  "8/2p5/6Pp/B3k3/7P/1r5P/8/3K4 w - - 0 1",
  "8/Pb1p4/3P2K1/BPP5/p7/8/7r/6k1 w - - 0 1",
  "2B3r1/2PK2P1/2p5/8/8/8/8/7k w - - 0 1",
  "3B4/Pk1P4/8/5pK1/2r5/8/8/8 w - - 0 1",
  "7k/3r3p/6P1/8/1BKR2N1/6r1/8/8 w - - 0 1",
  "k7/p7/N7/8/5p2/1P3K1B/8/1r6 w - - 0 1",
  "kB6/p2r3B/5p2/1N6/5K2/8/8/8 w - - 0 1",
  "k7/pr6/7R/3N4/5KB1/1r6/8/8 w - - 0 1",
  "6Nk/7p/2p5/8/2K5/6r1/5B2/8 w - - 0 1",
  "k7/8/2K5/8/1N2B3/8/8/5r2 w - - 0 1",
  "6rk/6N1/p7/8/R2K4/8/8/4B3 w - - 0 1",
  "k7/pN6/8/3B1r2/5B1K/8/8/8 w - - 0 1",
  "1k1N4/pn6/7B/8/8/7K/4r3/3B4 w - - 0 1",
  "6K1/5N2/p4P2/8/8/5r1B/1k6/8 w - - 0 1",
  "3K2B1/8/p2P4/8/6r1/3P1N2/6kB/3r4 w - - 0 1",
  "8/1B6/6K1/4P2p/8/rP6/4p3/Bk1N4 w - - 0 1",
  "7R/7p/3NPk1r/3r4/1B6/1K6/8/8 w - - 0 1",
  "8/2k2p2/6B1/8/5K2/2N5/1B1r4/8 w - - 0 1",
  "4k3/5p2/8/6P1/5N2/2B2Pr1/8/4K3 w - - 0 1",
  "4N3/4Pr2/2p5/8/p7/k7/8/1K2B3 w - - 0 1",
  "4k3/8/pN4P1/8/5r2/5p2/1P3B2/1K6 w - - 0 1",
  "8/8/B2P1k1p/8/4r2N/2P5/8/5K2 w - - 0 1",
  "2k5/1pN5/8/6B1/r7/8/5PP1/4K3 w - - 0 1",
  "1NB5/8/6P1/6r1/3k4/8/7P/7K w - - 0 1",
  "8/6pp/3N3k/8/B5r1/1K4P1/5P2/8 w - - 0 1",
  "8/4N3/8/4p3/B3p1rk/8/1P6/7K w - - 0 1",
  "8/8/P1k4p/5B2/7p/4r3/1N5P/3K4 w - - 0 1",
  "8/5N2/1p5p/1r1B3k/1P6/6P1/K5P1/8 w - - 0 1",
  "8/4r3/1p1p3p/1kP3NB/1P6/3K4/8/8 w - - 0 1",
  "k7/4p3/8/3P4/8/1N1B4/5K2/3r4 w - - 0 1",
  "8/5p2/5p1P/p6p/p2K3P/N1p5/8/B1k3r1 w - - 0 1",
  "8/1p2p3/2k5/P4prp/8/P7/B2N1K1P/8 w - - 0 1",
  "6k1/1p2p3/4pP1r/8/8/pPB5/5NP1/6K1 w - - 0 1",
  "8/2p3kp/4P3/4p3/1r3N1P/1P3B2/8/3K4 w - - 0 1",
  "7r/2P1k1p1/3p4/8/1N6/p1B5/6P1/6K1 w - - 0 1",
  "R7/3k1p2/b7/8/4Nrp1/2p5/2K5/4B3 w - - 0 1",
  "4k3/2p5/3P4/2p3rp/2N5/8/B6P/7K w - - 0 1",
  "5N2/1p6/3p1p2/BP6/3k3r/1K3P2/2P5/8 w - - 0 1",
  "8/8/8/8/B2p1p2/3rk3/6KN/8 w - - 0 1",
  "k1r5/B7/5p2/2p5/2p5/2K5/4B3/5N2 w - - 0 1",
  "4k3/1p1pP1pp/8/p1PB4/p2N3P/r7/P1P5/6K1 w - - 0 1",
  "8/1p6/1r1N2B1/1n6/1p2R3/3k4/8/1K6 w - - 0 1",
  "8/3rN3/6r1/8/5K1k/8/8/5B2 w - - 0 1",
  "1r6/5N2/1p5p/8/PPk5/5N2/1K6/8 w - - 0 1",
  "4N3/8/7p/4kr2/8/2P4K/3N2P1/8 w - - 0 1",
  "1N1N4/8/p3p3/2rp4/2k3P1/8/P2KP3/8 w - - 0 1",
  "8/4N3/1r6/4p3/2p1k3/8/2P1K3/3N4 w - - 0 1",
  "8/1pNp4/5r2/2P5/3k4/8/1KP2N2/8 w - - 0 1",
  "8/3N4/6r1/4p3/1P1k1p2/4N3/1P3K2/8 w - - 0 1",
  "6r1/2N5/7p/3Nkp1P/8/7P/5P2/7K w - - 0 1",
  "8/6N1/8/3r4/2N1k3/8/5PK1/8 w - - 0 1",
  "8/3N4/p5N1/K7/2p1kp2/8/P1P2Pr1/8 w - - 0 1",
  "8/1K6/8/p7/1kr2N1P/8/1P6/3N4 w - - 0 1",
  "6R1/pN6/p7/2p4k/3r4/2K1b3/8/7N w - - 0 1",
  "1N3R2/2p2p1B/4r3/8/4N3/k6K/8/1b6 w - - 0 1",
  "8/1N6/p7/5p2/3rk3/P7/4K1PN/8 w - - 0 1",
  "8/8/5N1r/1p6/3pN2p/Pp1k4/1P5P/3K4 w - - 0 1",
  "8/p1p3K1/r7/P3k3/8/6N1/1N4P1/8 w - - 0 1",
  "2N5/1p4N1/8/8/P2kr3/8/3K1P2/8 w - - 0 1",
  "8/1K4p1/4p3/N2rk3/6P1/5P2/4N3/8 w - - 0 1",
  "4N3/8/3Nr3/4k3/3p4/3P4/5K2/8 w - - 0 1",
  "2N5/p2r2k1/8/3p4/8/3N4/1P6/6K1 w - - 0 1",
  "2r5/8/1p4N1/p7/3k4/pP4N1/P2P4/3K4 w - - 0 1",
  "3r4/2N5/3P4/8/2k5/4P2N/2K5/8 w - - 0 1",
  "8/7p/1N1p2r1/4kp2/7P/3P3N/3K4/8 w - - 0 1",
  "8/1Np5/1P2k3/5Nr1/8/8/8/K7 w - - 0 1",
  "6k1/6p1/7P/2p2P2/2r3Bp/7N/4K3/8 w - - 0 1",
  "8/6K1/2p5/2Nr2k1/N5p1/6P1/6P1/8 w - - 0 1",
  "2K3N1/8/6P1/2k5/5r1N/8/8/8 w - - 0 1",
  "4K3/8/2P5/N7/1r4n1/2N5/8/k7 w - - 0 1",
  "5N2/p4p2/k3P3/8/K7/2N5/8/4r3 w - - 0 1",
  "8/3N4/5N2/3p1kP1/3p4/3r4/7P/2K5 w - - 0 1",
  "2K5/r2p4/1p6/8/3NkP2/8/1P2N3/8 w - - 0 1",
  "8/6K1/1p6/4P1N1/2P5/3k4/8/6Nr w - - 0 1",
  "r7/1k2N3/8/1K6/P1N5/8/8/8 w - - 0 1",
  "8/2K4B/8/k3P3/7B/7r/8/8 w - - 0 1",
  "8/5K2/8/3P3k/8/1B4r1/8/6B1 w - - 0 1",
  "5rB1/3R4/8/8/3K2kB/p7/8/8 w - - 0 1",
  "8/2B5/8/5B2/k7/P4n2/2Kp1rP1/8 w - - 0 1",
  "kr6/8/8/K4B2/8/2P5/8/4B3 b - - 0 1",
  "8/8/3B4/6rB/8/3K1P2/8/k7 w - - 0 1",
  "8/1r6/8/8/8/B4P2/B7/k1K5 w - - 0 1",
  "7R/K6p/7k/8/6r1/7p/6B1/6B1 w - - 0 1",
  "5B2/1pr5/2p5/7p/8/7B/8/k3K3 w - - 0 1",
  "8/8/3r3p/7k/5K1B/1B6/8/8 w - - 0 1",
  "8/4r3/3pP2p/4P2k/5K1b/1B6/5B2/8 w - - 0 1",
  "4K3/1B6/3P4/7k/3r3p/8/3B4/8 w - - 0 1",
  "3K4/1B6/6RB/7k/7p/4p3/8/1r6 w - - 0 1",
  "6k1/2B5/8/1pr5/8/8/2B5/1N5K w - - 0 1",
  "8/8/3B1R2/4r1r1/B7/2p5/7k/5K2 w - - 0 1",
  "6r1/8/7k/p2B3P/1B6/8/8/7K w - - 0 1",
  "7r/8/8/1B1n4/8/5P1k/5B2/5K2 w - - 0 1",
  "8/8/B7/3r4/5B2/1p6/8/3k1K2 w - - 0 1",
  "1k6/3r4/1K6/8/7B/8/8/5B2 w - - 0 1",
  "1K6/4p3/4P3/2B5/8/1k1B4/8/4r3 w - - 0 1",
  "1K6/4p3/8/1B1P4/8/1k4B1/3r4/8 w - - 0 1",
  "6B1/3p4/3K3p/4r3/5k2/B7/8/8 w - - 0 1",
  "3k4/3r4/1K6/8/8/1B6/8/4B3 w - - 0 1",
  "6K1/4k3/8/8/P4BBr/8/8/8 w - - 0 1",
  "8/8/8/BB4k1/7r/7p/8/6K1 w - - 0 1",
  "8/3R4/4B2B/4r2k/8/3p3K/8/8 w - - 0 1",
  "8/8/2B1n3/B1rR4/K6k/8/8/8 w - - 0 1",
  "8/8/8/1p4B1/8/4K3/8/1BkN3r w - - 0 1",
  "3R4/4k3/1r6/8/6p1/7B/5K2/4B3 w - - 0 1",
  "8/2r5/8/8/6B1/4B3/8/4k1K1 w - - 0 1",
  "3k1K2/8/8/5BR1/3b4/8/5B2/3r4 w - - 0 1",
  "3kN3/8/2r5/8/6Bp/8/3B2K1/8 w - - 0 1",
  "5k2/5p1p/6P1/6pK/2B5/8/2r4B/8 w - - 0 1",
  "1k6/p7/B4P1r/1Kp5/8/8/8/6B1 w - - 0 1",
  "8/8/8/pk2Br2/5p2/5BR1/2K5/8 w - - 0 1",
  "5rk1/4B3/6K1/1B6/8/8/8/8 w - - 0 1",
  "8/8/p2B3p/7P/4r2k/1B6/5K1P/8 w - - 0 1",
  "8/8/4r3/8/5B2/8/k1K5/5B2 w - - 0 1",
  "k7/8/2K1B3/8/2p1Nr1B/8/8/8 w - - 0 1",
  "8/1p6/8/1B6/8/k1K5/rr6/2B5 w - - 0 1",
  "8/1p1B4/8/8/8/k1K5/rr6/2B5 w - - 0 1",
  "B7/2N5/8/8/4rk2/5N2/5K2/8 w - - 0 1",
  "8/4k3/8/2r5/8/5N2/3B2N1/6K1 w - - 0 1",
  "8/8/6N1/8/2N5/5k2/5r2/1B4K1 w - - 0 1",
  "8/1N6/5k2/8/3r4/B7/2K2N2/8 w - - 0 1",
  "3N4/2N5/8/4r3/5k2/5B2/5K2/8 w - - 0 1",
  "8/8/8/8/2N3B1/3N2K1/8/1r4k1 w - - 0 1",
  "4N3/8/3N4/8/3B1rk1/8/6K1/8 w - - 0 1",
  "8/6N1/8/4N3/1r6/1B4k1/8/6K1 w - - 0 1",
  "K2k4/6N1/8/1B6/7r/6N1/8/8 w - - 0 1",
  "1k6/8/K3NNr1/8/6B1/8/8/8 w - - 0 1",
  "1kr5/8/1K6/4N1N1/8/8/7B/8 w - - 0 1",
  "1k6/1r6/1N6/8/1N6/3B4/6K1/8 w - - 0 1",
  "3N4/1B6/7r/3N4/6k1/8/6K1/8 w - - 0 1",
  "8/2BN4/8/5r2/6k1/8/3N2K1/8 w - - 0 1",
  "6k1/6r1/3N4/2B5/6N1/7K/8/8 w - - 0 1",
  "B7/8/8/2k2N2/8/4K3/3N4/3r4 w - - 0 1",
  "8/4B3/8/8/3Nk3/2K5/4N3/1r6 w - - 0 1",
  "2B5/8/8/2k2N2/8/1K6/8/5Nr1 w - - 0 1",
  "8/8/8/1k5K/8/7B/N7/r1N5 w - - 0 1",
  "8/8/5K2/3k4/8/3N3B/N7/r7 w - - 0 1",
  "8/6B1/8/3k4/2N5/N7/r7/6K1 w - - 0 1",
  "8/8/8/3k3B/8/8/N3N1K1/4r3 w - - 0 1",
  "8/8/8/5r2/1B1K1k2/2N5/7N/8 w - - 0 1",
  "2B5/8/N7/8/4rk2/5N2/5K2/8 w - - 0 1",
  "8/1N6/8/8/3rk1N1/8/4K3/2B5 w - - 0 1",
  "4B3/8/8/8/2rk1N2/3N4/5K2/8 w - - 0 1",
  "8/1B6/8/2N1N3/5r2/7k/8/6K1 w - - 0 1",
  "8/4N3/8/8/4kr2/1B6/4K3/4N3 w - - 0 1",
  "1k6/3B4/8/1N6/1N6/4r3/6K1/8 w - - 0 1",
  "1k6/8/8/1N6/1N4B1/4r3/6K1/8 w - - 0 1",
  "2k5/8/8/1NN5/8/5r2/3B4/6K1 w - - 0 1",
  "2N2k2/3r4/8/8/4N3/1B6/8/4K3 w - - 0 1",
  "8/3k4/6N1/5Nr1/8/5B2/5K2/8 w - - 0 1",
  "8/8/k7/8/8/N4B2/N2r4/6K1 w - - 0 1",
  "2N5/3N4/8/5r2/6k1/2B5/6K1/8 w - - 0 1",
  "8/6B1/2N5/3k4/6N1/1K6/3r4/8 w - - 0 1",
  "8/8/8/3rk3/3N4/2B1K3/5N2/8 w - - 0 1",
  "7B/8/1K6/2rk1N2/8/8/8/4N3 w - - 0 1",
  "8/2N5/8/4k1K1/3r4/8/1N2B3/8 w - - 0 1",
  "2N5/8/8/2kr2N1/8/2B5/8/2K5 w - - 0 1",
  "5B2/8/1k1N4/2r5/1N5K/8/8/8 w - - 0 1",
  "6K1/8/B3N3/3r4/4k3/8/1N6/8 w - - 0 1",
  "8/8/3k4/3r4/3N2N1/2B5/K7/8 w - - 0 1",
  "2k5/8/3r1N2/2N3B1/8/8/8/4K3 w - - 0 1",
  "8/4N3/3r4/8/4k3/3NB3/4K3/8 w - - 0 1",
  "8/2N5/8/8/4rk2/8/5K2/1N1B4 w - - 0 1",
  "5B2/5K2/3N4/2rk4/8/8/N7/8 w - - 0 1",
  "8/8/4N3/N2r3B/8/4k3/8/4K3 w - - 0 1",
  "8/4N3/8/3N4/4r3/5k2/5B2/5K2 w - - 0 1",
  "8/8/1N6/8/3r4/4k2N/4B3/4K3 w - - 0 1",
  "2N5/8/5N2/4r3/1B3k2/8/5K2/8 w - - 0 1",
  "8/N7/8/3rk3/N6K/8/2B5/8 w - - 0 1",
  "8/1B3N2/6k1/8/8/1N3K2/8/3r4 w - - 0 1",
  "8/5N1p/5pr1/7k/B2N1K2/8/8/8 w - - 0 1",
  "5B2/8/1r3N2/2p5/6p1/N2k4/8/5K2 w - - 0 1",
  "8/p4N1B/2k5/6p1/8/1N3K2/8/3r4 w - - 0 1",
  "8/1kp2Np1/8/5B2/8/1N3K2/8/3r4 w - - 0 1",
  "8/7r/5B2/1N4K1/1p2k1N1/8/8/8 w - - 0 1",
  "8/1N6/6pB/3r4/4k3/8/4K2N/8 w - - 0 1",
  "8/3B4/p7/3N2N1/8/8/1K1kr3/8 w - - 0 1",
  "5k1B/1N5K/2N1p3/8/8/r7/8/8 w - - 0 1",
  "n7/1N6/8/4r2p/7K/5kP1/3pNP2/3B4 w - - 0 1",
  "8/4k3/7R/P4p2/4pK2/8/8/4r3 w - - 0 1",
  "2k5/2P5/8/8/8/2R4P/Kp5r/8 w - - 0 1",
  "8/5k2/2RP4/P7/6p1/8/6K1/r7 w - - 0 1",
  "8/4Pk2/Pp2p3/2p1p2K/8/1P3P2/7R/3r4 w - - 0 1",
  "5k2/3rp2R/7P/3p4/3K4/B6p/8/8 w - - 0 1",
  "R7/8/2r1kp2/P5p1/3KP1Pp/8/8/8 w - - 0 1",
  "4k3/3rPn1P/1p1p4/8/2K5/8/8/6R1 w - - 0 1",
  "6R1/8/p7/8/1k5r/1Pp4p/P1K5/8 w - - 0 1",
  "8/5p1p/8/3k4/8/2PPp2r/8/R5K1 w - - 0 1",
  "R2K4/8/3k4/2R5/8/8/8/7r w - - 0 1",
  "R2K4/8/3k4/2R5/8/8/4r2r/8 w - - 0 1",
  "R2K4/2B5/8/8/3k4/8/R1r5/7r w - - 0 1",
  "B3K2R/8/k5n1/8/r7/6n1/8/7R w - - 0 1",
  "8/4p3/1pP5/p2P3R/3k1K2/8/5P2/4r3 w - - 0 1",
  "8/1P1p4/p7/k1P5/8/P7/1r6/2RK4 w - - 0 1",
  "4K2R/2p5/3k2r1/3P4/1P4p1/8/2P5/8 w - - 0 1",
  "R7/P7/8/8/7K/8/r6k/8 w - - 0 1",
  "7R/6p1/6rP/K7/8/k7/8/8 w - - 0 1",
  "7R/6pP/8/8/7r/K7/8/k7 b - - 0 1",
  "8/8/8/4kr1P/7K/8/8/7R w - - 0 1",
  "8/8/1k1P4/8/8/8/1r6/R3K3 w Q - 0 1",
  "1N6/8/8/1r1pk3/8/8/1P6/R3K3 w Q - 0 1",
  "4r2k/8/1p3p2/2p1P2K/4p3/8/8/5R2 w - - 0 1",
  "4r2k/8/5p2/3pP2K/4p3/8/8/5R2 w - - 0 1",
  "2k5/1p3p2/1p2p3/3p1p2/Pr6/1P2P3/1KP1P3/2R5 w - - 0 1",
  "4R3/3p4/1K6/4Pr2/1k6/8/8/8 w - - 0 1",
  "8/8/8/4k3/2r4B/1K2nP1R/8/8 w - - 0 1",
  "8/1r6/4p1k1/1n6/4K3/RB6/6PP/8 w - - 0 1",
  "4b3/8/1K2k1P1/3rp3/3pN3/8/8/R7 w - - 0 1",
  "7k/1p3p2/P3rP1p/3K4/1p6/8/1P6/5R2 w - - 0 1",
  "8/2rpp3/1pp2p2/3P4/5K1k/R1P4p/7P/8 w - - 0 1",
  "2r5/p1Pp1p2/2pp1p2/1P6/5K1k/7p/7P/6R1 w - - 0 1",
  "8/8/8/7p/4R2K/8/1NkB4/6r1 w - - 0 1",
  "8/7K/2p3rp/3P3k/6p1/6P1/7P/7R w - - 0 1",
  "8/8/8/8/P1p1k3/2P5/7r/R3K3 w Q - 0 1",
  "8/5kP1/p7/7r/P1p5/2P5/8/R3K3 w Q - 0 1",
  "R7/4p1p1/P2r4/k1K5/5P2/8/8/8 w - - 0 1",
  "1k6/rp6/p7/p5B1/K7/8/8/7R w - - 0 1",
  "4r3/2P1kpR1/7p/p4K2/P5B1/6bP/8/8 w - - 0 1",
  "r2k4/p6p/3K4/6P1/8/8/8/R7 w - - 0 1",
  "5k1r/8/7p/3RK3/8/8/8/8 w - - 0 1",
  "7r/R2N1k2/5p1p/8/6K1/8/8/8 w - - 0 1",
  "4kr2/R4p2/6p1/8/1K6/3B4/8/8 w - - 0 1",
  "5r2/2pPk3/R4p2/4BK2/8/8/8/8 w - - 0 1",
  "7r/4kp2/3R1p1p/3K1b2/8/8/R7/8 w - - 0 1",
  "R7/8/8/8/4K2p/8/8/3k1N1r w - - 0 1",
  "k7/B6r/8/3K4/8/2Rp4/B1p5/8 w - - 0 1",
  "k7/3K4/8/4q3/8/3Qp3/B2r4/2R5 w - - 0 1",
  "k1K5/5R2/6p1/2p2r2/8/5p2/B7/8 w - - 0 1",
  "8/8/6K1/7N/4r2N/7k/6R1/8 w - - 0 1",
  "5rr1/4p1k1/4p3/4KPB1/8/8/6R1/8 w - - 0 1",
  "5rr1/8/2K1k3/7R/8/8/8/3R4 w - - 0 1",
  "3r1r2/2k5/K7/7R/8/8/8/1R6 w - - 0 1",
  "r1k4r/6R1/3K4/8/8/8/8/3R4 w - - 0 1",
  "2r1k1r1/8/4K3/8/8/8/4R3/7R w - - 0 1",
  "1rk1r3/7R/R1K5/8/8/8/8/8 w - - 0 1",
  "1r2k1r1/7R/8/4K3/8/8/8/4R3 w - - 0 1",
  "1r2kr2/R7/R2K4/8/8/8/8/8 w - - 0 1",
  "1r1k1r2/R7/3K3R/8/8/8/8/8 w - - 0 1",
  "2rk3r/1K6/8/8/8/8/R4R2/8 w - - 0 1",
  "3r1k1r/R1R5/4K3/8/8/8/8/8 w - - 0 1",
  "1r5k/2R5/3R2K1/r7/8/8/8/8 w - - 0 1",
  "2r1k3/8/1R3K2/8/6r1/8/8/7R w - - 0 1",
  "6kr/R7/8/8/8/8/6r1/R3K3 w Q - 0 1",
  "r7/3k4/1r6/4K3/8/4R3/8/7R w - - 0 1",
  "R7/1K6/8/3kr3/5r2/8/8/6R1 w - - 0 1",
  "R6R/1r6/4k3/8/8/5K2/3r4/8 w - - 0 1",
  "3r4/8/8/R6R/1r6/2k5/8/2K5 w - - 0 1",
  "4r3/K7/6r1/8/3k4/R6R/8/8 w - - 0 1",
  "8/8/3k4/3r1r2/4K3/8/8/R6R w - - 0 1",
  "4r3/7r/8/8/6k1/2R5/5RK1/8 w - - 0 1",
  "8/8/6k1/8/1r6/R2R1K2/2r5/8 w - - 0 1",
  "4k3/R7/5K2/2r5/4r3/8/8/5R2 w - - 0 1",
  "4k3/R2R4/2r3r1/8/8/8/8/4K3 w - - 0 1",
  "2k4r/8/2K4P/5p2/1r6/3R4/R7/8 w - - 0 1",
  "3k4/7r/2K5/R4R2/8/8/8/1r6 w - - 0 1",
  "2k5/6r1/R7/2K5/2R5/4r3/8/8 w - - 0 1",
  "4rk2/2r5/8/R2K4/7R/8/8/8 w - - 0 1",
  "7r/8/k7/1R5R/K7/8/8/2r5 w - - 0 1",
  "4k1K1/R6R/8/8/8/8/3r4/2r5 w - - 0 1",
  "4k3/8/R6R/8/8/2K5/6r1/5r2 w - - 0 1",
  "5rk1/8/7K/8/8/7R/4R3/r7 w - - 0 1",
  "8/8/8/8/r7/p3R3/k2KR3/7r w - - 0 1",
  "1r3r2/6p1/8/8/8/R1R4K/8/5k2 w - - 0 1",
  "7r/6p1/8/r3k3/8/3R4/4K3/6R1 w - - 0 1",
  "8/3p4/5r2/8/8/K5R1/6R1/k6r w - - 0 1",
  "8/8/4p3/7R/6K1/5R2/8/1r1rk3 w - - 0 1",
  "4r3/4r3/4p3/8/R4R2/7k/8/3K4 w - - 0 1",
  "1r1kr3/5K1R/8/7p/8/8/8/R7 w - - 0 1",
  "2r1k3/1Rr5/2p5/4K3/8/8/7R/8 w - - 0 1",
  "8/3kr3/p5K1/r7/2R5/8/8/2R5 w - - 0 1",
  "8/7r/4p3/4p2r/5k2/8/4R3/4R1K1 w - - 0 1",
  "r5k1/8/1p5R/7K/8/r2p1p2/7R/8 w - - 0 1",
  "5r2/2p5/8/5k2/R2KR3/8/P1r5/8 w - - 0 1",
  "1k6/8/2p2r2/5p2/5K2/2r2p2/7R/R7 w - - 0 1",
  "1r2kr2/R7/3K2R1/8/8/7p/7P/8 w - - 0 1",
  "R5R1/2rkr2p/p7/2p1p2P/P3K3/8/8/8 w - - 0 1",
  "1k6/8/3pr1p1/4p3/1K2P3/3rP3/5R2/5R2 w - - 0 1",
  "6K1/6R1/2r3pr/5Pp1/6P1/B4P2/8/k7 w - - 0 1",
  "8/8/5P1k/8/2K5/pr2r3/4R3/2R5 w - - 0 1",
  "7k/4p3/K2p1P2/1r2r3/8/8/R7/3R4 w - - 0 1",
  "3k4/8/8/8/8/4R3/5r1r/4R1K1 w - - 0 1",
  "5rk1/3R4/RP3r2/8/5p2/8/6K1/8 w - - 0 1",
  "1r6/8/3K2p1/kP6/2p5/2R1N3/8/8 w - - 0 1",
  "8/2p5/2pr2p1/6p1/P7/3k1N2/8/K4R2 w - - 0 1",
  "4krN1/4p3/5P2/5p2/8/7R/7p/7K w - - 0 1",
  "2r2k1N/7R/1p6/1Kp5/8/8/8/8 w - - 0 1",
  "4k1r1/7R/8/5K2/5N2/8/8/8 w - - 0 1",
  "r7/4k2K/1R3p2/1N6/8/8/8/8 w - - 0 1",
  "2r5/p3K3/pP6/8/8/4N2R/4k3/8 w - - 0 1",
  "8/Pk6/8/6K1/3N2p1/4r2p/8/7R w - - 0 1",
  "1k6/NP2p3/8/8/4r2p/8/5K2/R7 w - - 0 1",
  "3r4/p5pK/Pk6/1p6/P2N2p1/8/8/2R5 w - - 0 1",
  "8/3k4/3p3p/3N4/8/1p5r/8/3R2K1 w - - 0 1",
  "1BkN4/8/5p2/2p5/8/5p1K/3r4/6R1 w - - 0 1",
  "5R2/r1p5/3N4/8/8/7K/1k6/N7 w - - 0 1",
  "8/3p4/4P3/3r4/k2N4/1R6/8/5K2 w - - 0 1",
  "8/2b1p3/2r4P/6RN/8/2kP4/4K3/8 w - - 0 1",
  "8/8/8/8/R3N3/4r3/6K1/4k3 w - - 0 1",
  "7R/8/8/1K1k4/8/4r3/8/4N3 w - - 0 1",
  "8/8/8/r7/k7/2K5/8/2N4R w - - 0 1",
  "4k3/1p2r2p/4N3/4K3/R7/8/8/8 w - - 0 1",
  "8/p7/P4N2/6r1/8/3k4/K7/7R w - - 0 1",
  "8/8/3r4/3N1K2/8/3k4/8/7R w - - 0 1",
  "8/8/8/3N1k2/p1r5/4K3/8/7R w - - 0 1",
  "6kN/8/5P1p/3b3N/2r4p/8/R7/3K4 w - - 0 1",
  "8/8/2k1p3/2P1K1p1/8/R7/8/1N3r2 w - - 0 1",
  "8/8/2K5/1r6/2k5/3N4/3R4/8 w - - 0 1",
  "8/4N3/7k/8/4r3/6K1/8/6R1 w - - 0 1",
  "3k4/8/2KN3r/8/1R6/8/8/8 w - - 0 1",
  "7R/1Kp1r3/2p1pp1P/8/6p1/6p1/6Pk/4N3 w - - 0 1",
  "4B3/8/2K5/8/r2pk3/p7/8/6R1 w - - 0 1",
  "3R4/6p1/2p3Bp/1kp3P1/6K1/8/5r2/8 w - - 0 1",
  "1k6/2p5/3r4/4p3/8/1K1P2R1/2Np2B1/8 w - - 0 1",
  "4B2q/P1k2p2/3p3R/4r3/8/4N2K/8/8 w - - 0 1",
  "5b1r/R2Pk3/4B3/8/3p4/3pp3/5R2/4K3 w - - 0 1",
  "r2k1B2/7R/p7/8/8/8/8/4K3 w - - 0 1",
  "3k3r/6R1/7p/5B2/8/8/8/3K4 w - - 0 1",
  "3kB3/R4P2/8/8/1p6/pp6/5r2/1K6 w - - 0 1",
  "5kr1/1R6/8/3K4/8/2p5/8/2B5 w - - 0 1",
  "4k1Br/pR6/2p5/K7/8/8/8/8 w k - 0 1",
  "2Bk1r1N/6R1/7p/8/8/8/3K4/8 w - - 0 1",
  "2B1k2r/R7/7p/7K/8/8/8/8 w k - 0 1",
  "8/8/8/8/6p1/Br6/2p3R1/1N1k2K1 w - - 0 1",
  "r1B5/B7/3k4/4R3/8/8/8/4K3 w - - 0 1",
  "1r1B4/1B6/4k3/5R2/8/8/8/5K2 w - - 0 1",
  "8/8/1k6/1pR5/1B6/4K3/1r3P2/8 w - - 0 1",
  "3k4/7R/2K5/5r1B/8/8/8/8 w - - 0 1",
  "7k/8/5r2/8/8/2R5/8/K1B5 w - - 0 1",
  "5K2/7k/8/8/6R1/p5Br/8/8 w - - 0 1",
  "k6r/1R6/8/7p/7p/7p/6Bp/7K w - - 0 1",
  "8/5b2/2Pr4/1p6/4p3/3P4/R7/1BK4k w - - 0 1",
  "8/p7/k7/2K2p2/2R3p1/8/2B1r3/8 w - - 0 1",
  "8/5p2/k1B4p/8/6K1/8/2r4N/5R2 w - - 0 1",
  "1knB4/8/7p/5R2/7K/8/3r4/7B w - - 0 1",
  "8/3R4/4k2p/7K/8/BrP5/8/6bN w - - 0 1",
  "8/8/p7/4kr2/B7/8/r3P3/1R1R3K w - - 0 1",
  "4K2k/2p2Rr1/4B3/8/8/8/8/8 w - - 0 1",
  "1K6/8/r7/B3r1p1/8/3B4/k7/5R2 w - - 0 1",
  "2Q5/8/8/8/8/2K5/8/r1kr4 w - - 0 1",
  "2r4r/7k/8/7K/7Q/8/8/8 w - - 0 1",
  "3r2kr/8/8/5K2/8/8/8/Q7 w - - 0 1",
  "8/8/8/8/Q7/K7/8/1k2r2r w - - 0 1",
  "r3r3/k7/8/4p3/1K6/8/8/2Q5 w - - 0 1",
  "2r1k1r1/8/4K3/8/4Q3/8/8/8 w - - 0 1",
  "8/8/k7/1r4p1/8/K4QP1/6Pr/8 w - - 0 1",
  "8/1Q1N1rk1/7r/6K1/8/8/8/8 w - - 0 1",
  "1k2N3/8/r3r3/8/8/2K5/8/2Q5 w - - 0 1",
  "5k2/2Q5/3r1r2/6K1/2B5/8/8/8 w - - 0 1",
  "8/7k/4r1rB/7K/8/8/8/1Q6 w - - 0 1",
  "8/K7/1r1r4/2kBQ3/8/8/8/8 w - - 0 1",
  "8/K2k1B2/3r4/8/1r6/8/5Q2/8 w - - 0 1",
  "8/kB2r3/8/8/3r4/K7/8/7Q w - - 0 1",
  "4k3/3rBr2/KQ6/8/8/8/8/8 w - - 0 1",
  "5kN1/3p1q2/5P2/5PP1/2pK4/1p1R4/1P6/8 w - - 0 1",
  "8/q1k5/1pP4p/pP1K3p/P1PB4/6pP/6P1/8 w - - 0 1",
  "4KBkr/7p/6PP/4P3/8/3P1p2/8/8 w - - 0 1",
  "1q2k3/1Pp1Pp1K/2P2B2/8/8/8/8/8 w - - 0 1",
  "7k/6R1/8/8/2P2P2/P7/pP6/3K3B w - - 0 1",
  "6q1/2K1kp2/1N4P1/5PPP/8/8/8/8 w - - 0 1",
  "7r/2P1B2p/2k3P1/6P1/7K/7p/8/8 w - - 0 1",
  "q1N2k2/Pp2p3/1p2P2K/1P6/8/1P6/8/B7 w - - 0 1",
  "7n/8/6nq/3K4/P2N2k1/6P1/6PP/6B1 w - - 0 1",
  "1q6/5K2/2pp3p/4k2p/1P5N/4PP2/1P2P2P/8 w - - 0 1",
  "4K1b1/P6r/1N6/2p5/4p2k/4P2P/6P1/8 w - - 0 1",
  "8/6p1/6P1/5KPk/7p/7p/2N5/8 w - - 0 1",
  "8/8/8/Bp3p2/1PP2k2/8/p1PPK3/8 w - - 0 1",
  "8/2p2K2/3p4/B4k2/3p4/p4PP1/2P1P3/8 w - - 0 1",
  "4B3/2p5/2K1k3/8/p1P1p3/1p2P3/5P2/2N5 w - - 0 1",
  "8/K7/4k3/8/3p4/B2P2p1/4P3/8 w - - 0 1",
  "7K/6p1/8/4k1p1/3p4/8/3PP3/2B5 w - - 0 1",
  "4K3/2p5/B4p2/4pk2/2P2pR1/6P1/1pPP2P1/8 w - - 0 1",
  "1q6/8/2P1p3/4k3/1B3p2/NK3P2/2P2P2/8 w - - 0 1",
  "8/4r1k1/6p1/3P1p2/p4N1B/p4K1P/5PP1/8 w - - 0 1",
  "3B4/1p6/1Pp1p3/4Ppn1/2KP1k1q/4p1pP/4P1P1/4N3 w - - 0 1",
  "4k3/pNqp2K1/P1p1p3/2p1P3/8/8/1P6/6B1 w - - 0 1",
  "5K2/5B2/5k2/2p2q1P/2Np1Pp1/3P2P1/2P5/8 w - - 0 1",
  "8/7p/6pq/2BN1p2/6kp/8/3PP1KP/8 w - - 0 1",
  "3k4/4NK2/2P2p2/4qP2/8/8/3B4/8 w - - 0 1",
  "4k1K1/1p2P3/pP1Pn3/5N1P/8/1q6/4B3/8 w - - 0 1",
  "8/5p2/4pP1k/p3P1p1/p5P1/P2N4/1P6/qBK5 w - - 0 1",
  "8/2p5/2p5/2P5/8/6NP/5BPq/1k3K2 w - - 0 1",
  "8/5p2/5p2/5N2/5P2/P7/pPK2k2/3B4 w - - 0 1",
  "qk6/3K4/P7/6B1/1N2p3/8/8/8 w - - 0 1",
  "1B6/1KN5/8/4p3/1P1p4/p7/8/1k6 w - - 0 1",
  "8/8/8/B5N1/7p/4k3/6Pp/4K3 w - - 0 1",
  "8/8/3Nk1b1/3n4/p4P2/p7/3P4/1BK5 w - - 0 1",
  "2B1qk2/3p2p1/3P2P1/p2N4/Pp1K3p/7P/P1P5/8 w - - 0 1",
  "4k3/1p6/7p/P2B4/4P1p1/2N3Pq/P6P/6K1 w - - 0 1",
  "8/2pB4/8/4p3/5kN1/2K4P/4PPp1/8 w - - 0 1",
  "k3N3/p3Bp1p/P6q/3p1P1p/5p1P/8/5P2/2K5 w - - 0 1",
  "6k1/7p/7b/p4Nq1/1B6/4R3/2P3P1/5K2 w - - 0 1",
  "1B5k/4q2p/8/4p3/p2p2N1/1P1P4/2P5/K7 w - - 0 1",
  "7k/p6p/P4q1N/8/2p4p/2p2PP1/P1P3P1/K1B5 w - - 0 1",
  "1k6/p6p/8/7P/1N6/1q5B/8/K7 w - - 0 1",
  "8/8/8/P1r5/Q6B/1Kp1q3/8/1Nk5 w - - 0 1",
  "8/8/8/1N6/7P/2K5/5p1B/k7 w - - 0 1",
  "3B4/p1N5/8/8/k7/8/1PK3p1/8 w - - 0 1",
  "5B2/p7/2K5/kN1Pp3/8/8/4p3/8 w - - 0 1",
  "2K5/8/pk3N2/1p2p3/1P1P4/8/3BP3/6q1 w - - 0 1",
  "K7/2N5/8/p7/p1k1P3/4p1B1/P1pPP3/8 w - - 0 1",
  "2K5/k7/8/4B3/5p2/7P/2Np4/8 w - - 0 1",
  "k1K5/3p2p1/8/7P/3N1P1q/6p1/6P1/2B5 w - - 0 1",
  "5K1k/1p1q4/7N/1p5P/1P3P2/3p4/3P4/5B2 w - - 0 1",
  "k7/3p4/K2B4/8/2P5/4p3/3P1P2/5N2 w - - 0 1",
  "2B2KN1/3p3k/8/8/1p6/1P2P3/1p6/8 w - - 0 1",
  "k7/2K5/6p1/8/1BpN2P1/7P/4Pp2/8 w - - 0 1",
  "8/8/p7/kqB5/6pK/1P1N4/P3P3/8 w - - 0 1",
  "6q1/5Npp/7P/2p1p1P1/2k1B3/P5P1/1P4K1/8 w - - 0 1",
  "8/p7/5N2/k1K5/4p1BP/2p5/8/8 w - - 0 1",
  "8/6p1/pPq5/2p1p1Pk/4P2P/PBP3P1/3Nn2K/8 w - - 0 1",
  "8/N2q4/5P2/2p3p1/p2k4/P3p3/3PB1PP/3K4 w - - 0 1",
  "4B3/8/qpP5/4p1p1/4k3/P3N3/1P3PK1/8 w - - 0 1",
  "8/4q3/5p2/B1N1b2p/7k/P6p/P4P2/4R2K w - - 0 1",
  "3N4/8/1p5q/3k3P/8/1P3P2/P1P1K2B/1n6 w - - 0 1",
  "2k2N2/4p3/2K5/8/2B1P3/8/7p/8 w - - 0 1",
  "2N5/1n6/6pP/5q2/1k1p4/1P1p1B2/PK6/8 w - - 0 1",
  "8/8/6pp/2N1k1q1/6P1/B1P4K/3P4/8 w - - 0 1",
  "8/4B2p/8/3p3P/8/3Pk1K1/p7/6N1 w - - 0 1",
  "4N3/8/2p5/2pk1p2/8/p1P5/4PK2/4B3 w - - 0 1",
  "3K3k/p7/7P/3N1P2/1B6/6q1/8/8 w - - 0 1",
  "2k1K3/p1p5/P7/2PN4/8/1q6/6B1/8 w - - 0 1",
  "1k1N2RK/1P6/6B1/2pq4/8/8/2P5/r7 w - - 0 1",
  "3qn3/2pk3p/5P1N/2P3P1/p5P1/3B4/8/K7 w - - 0 1",
  "5N2/6p1/7k/7p/1pP1P2B/p6K/8/8 w - - 0 1",
  "8/4p3/2N3q1/3P2p1/6P1/1k6/1P6/K4B2 w - - 0 1",
  "8/2k5/2P5/1P5p/8/p3N1q1/K2B2P1/8 w - - 0 1",
  "8/2K5/p7/8/k2Np3/7P/1P3p1P/1B6 w - - 0 1",
  "8/1N6/8/2p1p1K1/1P2k3/7B/q1P1PP2/8 w - - 0 1",
  "8/8/1K6/4p2B/q2k4/P3N1P1/P2PP3/8 w - - 0 1",
  "1B6/8/p6q/7p/4Pp1k/8/P5PK/4N3 w - - 0 1",
  "3N4/8/8/4kp2/8/1KP5/1B4p1/8 w - - 0 1",
  "8/4p3/4N3/5P2/3PkB1K/8/1p2P2P/8 w - - 0 1",
  "8/7p/8/PB2p1pk/2p5/4N3/1p1P3K/8 w - - 0 1",
  "8/5K2/8/P4pkp/3N4/5P1P/7B/4q3 w - - 0 1",
  "8/5N1p/6p1/1p1k4/1P6/2P3Pq/2B2P2/6K1 w - - 0 1",
  "7B/8/3p4/7p/4N2q/2K4P/5PP1/k7 w - - 0 1",
  "8/p2q4/3pp1p1/6B1/6kP/1P1N4/1P2P2P/3K4 w - - 0 1",
  "1N6/8/2p1p3/2k1P3/K6B/2PP4/6P1/5q2 w - - 0 1",
  "8/K2p4/8/1k6/1P4q1/1P6/3BNP2/8 w - - 0 1",
  "1B6/5K2/8/P7/3kp3/8/1N2pP2/8 w - - 0 1",
  "6K1/8/3pN2k/8/PB1p4/7P/5p2/8 w - - 0 1",
  "8/4p1p1/8/7k/2qN3B/4P1P1/2B4K/8 w - - 0 1",
  "8/1N6/3P3K/7p/2k5/2P4q/2BP4/8 w - - 0 1",
  "5k2/4p1N1/7K/2p1p1p1/8/1BPq4/5P1P/8 w - - 0 1",
  "8/1B6/4q2p/4p2P/1kpP4/1P2N3/KP6/8 w - - 0 1",
  "q7/8/2P5/1B1p3p/P4Pk1/3N4/5K2/8 w - - 0 1",
  "8/8/q1N5/8/B2p4/3P1kP1/n6P/5K2 w - - 0 1",
  "2B5/7N/1q4P1/1pk5/4P3/2P5/1KP5/8 w - - 0 1",
  "3N1q2/4p3/pk2p3/1p6/1B3P2/8/1P6/1K6 w - - 0 1",
  "8/B2N4/p7/1q6/1k1p4/3P4/1PP5/K7 w - - 0 1",
  "8/p5pq/8/p2N3p/k2P3P/8/KP3PB1/8 w - - 0 1",
  "3B4/1p6/4p1p1/2P1k1P1/2P5/6N1/2KP1P2/4q3 w - - 0 1",
  "q7/B3p3/2p1N3/p5p1/1k1P4/3P2P1/PK6/8 w - - 0 1",
  "8/p7/p7/k2P4/3B1P2/K3p1q1/3NP3/8 w - - 0 1",
  "8/B4p2/8/3P2pP/4pkN1/q6P/4K3/8 w - - 0 1",
  "8/2p1q3/p3P3/2P4p/1PBP2kP/2N3P1/7K/8 w - - 0 1",
  "3q4/8/p2N4/1ppP4/2P2B2/P1k1p2p/P3P2P/1K6 w - - 0 1",
  "5N2/4pp1K/5k2/3p2p1/1B3qPP/8/2P3P1/8 w - - 0 1",
  "7q/Pp2N3/k7/Bp6/1KP5/P7/8/8 w - - 0 1",
  "1k6/p1p1N2K/P7/2P4p/p7/Pq1PPB2/6P1/8 w - - 0 1",
  "3B4/pp2N3/8/P1pK4/1k3p1P/5p2/1P5P/8 w - - 0 1",
  "8/6qp/pB6/3k2PP/3N4/3K4/2P5/8 w - - 0 1",
  "8/q7/p7/4p3/p1p1P3/k5P1/P2B4/K2N4 w - - 0 1",
  "6q1/1NB3p1/8/1p1p4/1k3PP1/8/1PK2P2/8 w - - 0 1",
  "7N/2p5/2p1p1K1/PpP1k3/4p1p1/1P2B1P1/p2P2P1/8 w - - 0 1",
  "8/2B5/2KN3p/2p4p/P6k/8/2p4P/8 w - - 0 1",
  "N7/1p1kqP2/8/3P4/KP6/4B3/8/8 w - - 0 1",
  "2N5/p7/q1p2p2/kp6/3P4/PP3K2/5P2/2B5 w - - 0 1",
  "1N6/4n2p/4pk1P/1P3P1P/1p2PK2/3q1N2/1P6/3B4 w - - 0 1",
  "8/5K1N/1ppp4/5kp1/2P1p2p/1P2P1P1/q1P2PP1/2B5 w - - 0 1",
  "8/8/8/3B2N1/5K2/8/2p3P1/7k w - - 0 1",
  "3K4/8/3k4/N1p5/2P1p3/4P1p1/3P4/3B4 w - - 0 1",
  "3NK3/2p5/3k4/P7/2P1p1B1/4P3/5Pp1/8 w - - 0 1",
  "4q3/3N4/3P4/8/P2kp3/pp2p3/1PP1P3/1K3B2 w - - 0 1",
  "7q/1pB5/1p4N1/1P1k1p2/1P6/1P3K2/2P1p1P1/8 w - - 0 1",
  "6K1/8/8/1b3PNk/7p/3p4/5pBP/8 w - - 0 1",
  "8/2K1p3/8/2k1Np2/q7/4P3/8/5B2 w - - 0 1",
  "2B5/p3p3/4p3/3P2N1/8/p5K1/P3PP2/3qk3 w - - 0 1",
  "5K2/8/8/4kP2/1p1N3P/2p5/Pp6/3B4 w - - 0 1",
  "8/8/2B1N3/k2K4/8/8/pP6/8 w - - 0 1",
  "8/2p1p3/pp1NP3/k7/3KP1q1/1PP5/5PB1/8 w - - 0 1",
  "8/2K4p/p4p1P/2Pk4/BP4qP/2P5/5P2/4N3 w - - 0 1",
  "8/1q3Np1/2p1p1P1/P3P3/1p1k1K2/7B/1PP5/8 w - - 0 1",
  "5KB1/2p5/2p3kp/2P1p2N/1P2q1pP/4P1P1/8/8 w - - 0 1",
  "8/5q2/5p2/3Pp1pP/5k2/7p/2BNPK2/8 w - - 0 1",
  "8/6n1/3Kp3/B4pq1/P2kp3/8/1P2PP2/3N4 w - - 0 1",
  "2q3B1/2p3p1/7p/4K1kp/P7/8/3N1PP1/8 w - - 0 1",
  "8/5N2/3p1p2/pPp2K1B/q2k4/3p4/2PP4/8 w - - 0 1",
  "8/3K1ppq/8/3kp3/P7/1P1NP3/B5P1/8 w - - 0 1",
  "6N1/p2qp3/6B1/4P1p1/P1p1P1P1/2Pk4/3P4/4K3 w - - 0 1",
  "2K2B2/P7/1kpN4/8/qP6/8/2P5/8 w - - 0 1",
  "3B4/p2p4/4Np2/5Pp1/2k5/2P5/P1KP1Pp1/8 w - - 0 1",
  "8/8/1K6/B7/k2p3P/3B4/P1P3p1/5N2 w - - 0 1",
  "8/5q2/1P4p1/3k4/6p1/1N4Bp/2P5/6K1 w - - 0 1",
  "8/1p3pp1/3k2p1/7P/pq3P2/3B3P/P1PN2P1/3K4 w - - 0 1",
  "4N2k/7q/6p1/K3R3/4P2n/p4p2/P2B1P1P/8 w - - 0 1",
  "6q1/p1n1B3/8/1p2kPp1/1P6/P3N1P1/3K4/8 w - - 0 1",
  "1q6/1pkp1Kpp/1N6/1P6/6P1/4B3/1P6/8 w - - 0 1",
  "4N3/p4p2/P1qp2p1/3kP3/1Pp5/2P2KpB/8/8 w - - 0 1",
  "4B3/6N1/3k1K2/2p5/8/1p1pp3/2P1P3/8 w - - 0 1",
  "8/p1N3q1/5p1p/3p2pP/2p1k1p1/B1P5/P1P3P1/5K2 w - - 0 1",
  "8/2N5/6P1/2Bp1P2/q3k3/4P3/2P5/6K1 w - - 0 1",
  "3k4/p2Np2p/q7/P5P1/2p1P1B1/2P5/8/6K1 w - - 0 1",
  "2B5/8/8/4N2P/8/6K1/p7/5k2 w - - 0 1",
  "1q6/2pk4/6N1/p1P5/4K3/Pp3B2/1P6/8 w - - 0 1",
  "8/n6p/4B3/p1P3q1/kp1P3p/3K4/P2P3P/1N6 w - - 0 1",
  "8/q7/p6P/B2p1p1p/3N3k/p1PP4/P4K1P/8 w - - 0 1",
  "8/5p2/2p5/4P1KN/4k3/3p1p2/p2P1BP1/8 w - - 0 1",
  "8/p7/k1pp4/8/1P2KNB1/2p2P2/2Pp4/8 w - - 0 1",
  "8/5N2/8/7q/1P5k/7p/B5PK/8 w - - 0 1",
  "7B/6N1/6p1/8/5P2/3K4/6p1/5k2 w - - 0 1",
  "8/1p6/1K6/p1B1qP1N/2k5/1p6/PPP2P2/8 w - - 0 1",
  "k7/8/7p/3N4/4q3/6P1/4P2K/5B2 w - - 0 1",
  "4N3/3p4/B3p3/1pP2kPK/5p2/2P5/4P1q1/8 w - - 0 1",
  "4B1q1/1p6/bP4N1/P5P1/2Pk4/7K/2PPP3/8 w - - 0 1",
  "8/3q2p1/1KN1p3/6k1/6P1/B1P3P1/5P2/8 w - - 0 1",
  "8/p2p1p2/p7/2p5/2k4B/KN5P/1PPP3p/8 w - - 0 1",
  "5K2/1p6/6k1/3N3q/1P3P2/8/6P1/5B2 w - - 0 1",
  "8/5K2/8/3p1k1B/8/6PP/p2P4/6N1 w - - 0 1",
  "6K1/8/8/2N2k2/7P/2P1P1P1/3p4/B7 w - - 0 1",
  "8/4KBp1/1pp3p1/4k1P1/PP3p1N/P2p4/3P1pPP/8 w - - 0 1",
  "8/k7/8/P2q4/3p4/NP1B4/KP1P4/8 w - - 0 1",
  "8/1p6/2p5/1PPkqP1N/pK6/2P5/P1B5/8 w - - 0 1",
  "8/4p3/q7/1NB2p2/4k2P/6p1/2PP1PK1/8 w - - 0 1",
  "4q3/pp2p3/7p/5p2/PB1N1k1P/5Pp1/1P1P2K1/8 w - - 0 1",
  "7K/8/6kp/1B1b1N1N/8/7p/8/8 w - - 0 1",
  "8/8/1p2N2B/8/1p4Pk/1p2p3/3P2PK/8 w - - 0 1",
  "8/2q5/8/3N1K1k/8/7n/5B2/8 w - - 0 1",
  "k7/1qP5/pP6/8/5K2/1p6/8/3B4 w - - 0 1",
  "8/p5B1/2K3P1/kn4N1/3p4/8/4p3/8 w - - 0 1",
  "8/p5B1/2K3P1/kn4N1/3p4/8/4p3/8 w - - 0 1",
  "2q3k1/2p1K3/6Pp/8/4B1N1/8/8/8 w - - 0 1",
  "8/p7/8/k3N3/P6B/8/pP2P2K/8 w - - 0 1",
  "2b4K/4p3/5kN1/3P1P2/1q1NP2P/8/1B6/8 w - - 0 1",
  "8/1p1Rpkp1/p7/P2nPP2/1BpN4/K7/5P1p/8 w - - 0 1",
  "1q5k/1Pp5/2Pp3K/6N1/7N/8/8/8 w - - 0 1",
  "n4N2/2pK4/Bp4N1/1P6/P3q1k1/1P6/5P2/8 w - - 0 1",
  "3NK2n/6pk/4pq2/4p1p1/6P1/4PpN1/5P2/6R1 w - - 0 1",
  "3NK2k/6p1/p4q2/P1N1p3/6Pp/4P3/5PP1/8 w - - 0 1",
  "Q3rk2/1p1qp2K/1P6/1P1NP1Np/3P3P/8/6P1/8 w - - 0 1",
  "8/8/p7/q1kbN3/P3P3/2N5/PPK5/8 w - - 0 1",
  "8/2N5/4pp2/3pqk2/5N1K/2PP2P1/7P/8 w - - 0 1",
  "6q1/1p3p2/5P1k/2P4P/4N2K/5N2/8/8 w - - 0 1",
  "q2nN3/3N4/2p1p3/1pPkp2K/1P6/2P1p1P1/8/8 w - - 0 1",
  "8/2p2N2/6p1/1q4Np/pP1k1P1P/8/K1PP4/8 w - - 0 1",
  "8/3pPp2/3p1k1K/5p2/1b1P3N/2P5/5p2/8 w - - 0 1",
  "5q2/4N3/p5p1/2pp4/p3k1PN/P7/2PP1P2/2K5 w - - 0 1",
  "1N6/p4N2/4q1p1/6p1/P1k1Pp2/8/1PP2P1K/8 w - - 0 1",
  "1N2q3/6pK/7p/2p1N3/pk3PP1/8/PP6/8 w - - 0 1",
  "q3N3/8/3p1N1p/p1kP4/5p1P/p4p2/P1PP1P2/3K4 w - - 0 1",
  "8/4P2p/2p5/2P1k3/3N2K1/3q4/8/8 w - - 0 1",
  "3N1N2/5p2/8/6pp/1Pp4k/2Pp4/8/7K w - - 0 1",
  "4N3/7q/1Pp2pkp/7p/K7/3P2PP/2P1N2P/5n2 w - - 0 1",
  "8/4N3/1q6/3pp3/2n1k1PP/8/4P1PK/3N4 w - - 0 1",
  "8/k1KN4/5p2/2p5/1P6/N2p4/pPpP4/8 w - - 0 1",
  "5N2/N7/2P2p1p/2qp1kpP/8/3PP2P/8/3K4 w - - 0 1",
  "8/NK3p2/8/k2N4/1p5P/8/p1P5/8 w - - 0 1",
  "8/4p3/2p1p1pN/2P1k1P1/p2q3p/P1NP3P/2K2PP1/8 w - - 0 1",
  "8/8/1q1k4/2NP4/PP3K2/1P4N1/8/8 w - - 0 1",
  "kNK5/8/1P6/1p6/1P6/3q4/8/8 w - - 0 1",
  "2K5/2N1p3/1p6/3Pk2N/8/6PP/1P1p4/8 w - - 0 1",
  "8/1N3q2/3p4/pPp1k3/8/K2PN1P1/1P2P3/8 w - - 0 1",
  "6N1/2p3K1/6N1/5kp1/3P4/1P4P1/4pP2/8 w - - 0 1",
  "4N1K1/6p1/4kN2/8/6P1/Pp4P1/1p3P2/8 w - - 0 1",
  "8/p7/2Npp3/6P1/KPk5/8/N1P2P1p/8 w - - 0 1",
  "6q1/2p1p1N1/7P/4N1k1/P5P1/6K1/8/8 w - - 0 1",
  "8/3N4/2pq3p/4N3/1kP5/1P2P2P/1P2K3/8 w - - 0 1",
  "q7/8/3pp1p1/1P1N2P1/1N1k4/3P3P/4P1P1/n5K1 w - - 0 1",
  "8/2q3N1/4p1K1/8/1N1pk3/8/4PP2/8 w - - 0 1",
  "n7/4p3/1q1Pp1p1/1p4P1/1N2k1P1/4PpBK/1P3P1P/8 w - - 0 1",
  "8/p1p5/K1N4p/1PkqP1N1/6p1/P3P3/1P4P1/8 w - - 0 1",
  "1N1N4/p5p1/3p2P1/3q4/P2k4/3P4/1PK2PP1/8 w - - 0 1",
  "N7/3q4/1KN1p3/6p1/5kP1/8/3P1PP1/8 w - - 0 1",
  "6N1/3p4/4p3/1q2Pk2/2p2P1K/8/1P4P1/3N4 w - - 0 1",
  "2N5/8/2q4p/3N3P/1pk5/4P2P/K2P4/8 w - - 0 1",
  "6K1/8/4Npk1/2p4q/5P2/8/2P3P1/5N2 w - - 0 1",
  "8/p4K2/2N1p3/2P2kp1/4p3/q1N3pP/3P2P1/8 w - - 0 1",
  "8/2N3K1/8/5k1q/4pPpP/8/4PPN1/8 w - - 0 1",
  "6N1/5p1N/8/4p1P1/7k/Pp6/5PK1/8 w - - 0 1",
  "N7/p2p4/2p4K/4Pp2/5P1k/pP5P/2P2P2/6N1 w - - 0 1",
  "8/6p1/p7/P7/2NK4/8/p1P2NP1/1k6 w - - 0 1",
  "5KN1/8/2p5/6pk/4P2P/N5p1/3P4/8 w - - 0 1",
  "4k3/3qP2p/4N2K/N2PP3/p7/P7/8/8 w - - 0 1",
  "8/NN3P2/7p/1p6/1qkp4/5K2/1PP1P3/8 w - - 0 1",
  "5N2/3N4/8/4pq1p/5pk1/P3P1p1/3KP1P1/8 w - - 0 1",
  "4k3/3pPp2/4pP2/4p1Pq/4P2P/3BP3/3KPB2/8 w - - 0 1",
  "8/2B5/1p2p1B1/1P6/2K5/8/2p1pP2/2k5 w - - 0 1",
  "8/6K1/8/2p5/6pk/7B/1BPp3P/8 w - - 0 1",
  "5q2/1p1kp3/1P4p1/4B3/3N3K/1B6/5P2/8 w - - 0 1",
  "B7/P4p2/k3p3/1p4P1/5q1p/6p1/1P3PK1/6B1 w - - 0 1",
  "5K2/q6p/2p4p/7k/4P2P/1P1B2p1/2P2P2/6B1 w - - 0 1",
  "8/5B2/p7/q5B1/k7/3K4/1P6/8 w - - 0 1",
  "3k2B1/p7/1p2K3/8/6P1/2P1p2p/1B6/8 w - - 0 1",
  "3B4/p5Kp/B7/2pqk3/3p3P/1P6/3PP2P/8 w - - 0 1",
  "8/6p1/BK2p2p/5k2/7B/1P2PP2/p7/8 w - - 0 1",
  "8/8/2p5/1p6/1q1k4/8/4KN2/1BB5 w - - 0 1",
  "1q6/8/8/Bp1p1p2/8/3k4/N7/3K3B w - - 0 1",
  "8/8/2BN1p1B/2p5/3k4/6K1/q7/8 w - - 0 1",
  "1B6/4K3/2q5/4p2B/2k5/8/N7/8 w - - 0 1",
  "KB6/3B4/8/p1k5/1q6/6P1/2PN4/8 w - - 0 1",
  "6k1/6q1/8/6N1/2K1B3/8/8/2B5 w - - 0 1",
  "2b5/2b5/3k4/8/8/7n/6QK/8 b - - 0 1",
  "5N2/B2Pk3/6B1/pq6/1p6/1Kp5/8/8 w - - 0 1",
  "2n5/3N4/7p/1BB4k/7P/3p2Pq/3P4/6K1 w - - 0 1",
  "8/2p3N1/5pqp/1BBp4/6kP/6P1/8/2K5 w - - 0 1",
  "n7/3B4/1p1p1N2/2k1q1P1/7B/1P6/1P6/1K6 w - - 0 1",
  "q7/6p1/6B1/2p2pBP/2N1kp2/2Kp2P1/P2P1P2/8 w - - 0 1",
  "8/2Np4/6pp/6k1/8/2B2PK1/q6P/3B4 w - - 0 1",
  "8/2N3p1/6Bq/B2p3P/2pk4/1p6/1P3P2/K7 w - - 0 1",
  "5N2/2p1B2p/2p2p2/2P2kpB/1P6/2P2K2/2q4P/8 w - - 0 1",
  "k6B/8/2N5/8/8/5B2/K7/6q1 w - - 0 1",
  "3B4/8/3q4/3N4/k7/3B4/8/1K6 w - - 0 1",
  "1B6/8/5q2/1B6/6k1/6N1/6K1/8 w - - 0 1",
  "8/8/B4K2/3q4/4k3/7N/3B4/8 w - - 0 1",
  "4B3/2q5/4kp1K/3p4/5P2/2NpB2p/5P1P/8 w - - 0 1",
  "4q3/5N2/B7/8/3k3B/8/1K6/8 w - - 0 1",
  "5k2/3qp3/7p/1p3p1P/1B3N2/1B1P4/P3P2K/8 w - - 0 1",
  "8/6p1/2Nq1k1n/B2P3B/8/3K4/1P3P2/8 w - - 0 1",
  "8/p7/kq1B4/8/8/2KN4/4B3/8 w - - 0 1",
  "8/6B1/6P1/4p3/1p1k2q1/1B4N1/5P2/4K3 w - - 0 1",
  "1qn4k/3B4/K4N2/8/3B4/4P3/8/8 w - - 0 1",
  "8/B7/3N3k/7p/4B3/1p6/1q6/4K3 w - - 0 1",
  "4B3/N1q3p1/5p2/6k1/4p3/7K/8/6B1 w - - 0 1",
  "8/1p6/pK6/Pp2qP1N/1p1k3p/1P5p/1P5P/1B2B3 w - - 0 1",
  "8/3K4/8/8/5NB1/2B5/5k1p/8 w - - 0 1",
  "3B4/8/8/2K5/8/8/kp4N1/7B w - - 0 1",
  "8/8/5K2/2p5/5NB1/2B5/5k1p/8 w - - 0 1",
  "8/1B1p4/3B4/3N4/8/8/K5k1/6q1 w - - 0 1",
  "1B5q/8/8/8/B3N1pk/8/5K2/8 w - - 0 1",
  "8/1N1B4/2p1K3/6p1/6k1/2B5/5p2/8 w - - 0 1",
  "5K2/N1pp1B2/3p3B/4k2p/P2ppp1P/8/2p1P3/8 w - - 0 1",
  "4B2k/6q1/5N2/8/3B4/8/8/1K6 w - - 0 1",
  "8/8/6Kp/1Bp1B3/8/q1N5/8/k7 w - - 0 1",
  "5N2/8/7B/8/2K5/1p1B4/p7/k7 w - - 0 1",
  "q2k4/8/3K4/4N2B/3B4/6p1/8/8 w - - 0 1",
  "8/1B1k1pq1/6p1/3N2B1/8/1p6/8/1K6 w - - 0 1",
  "8/3B4/8/4N2k/5B2/8/7K/q7 w - - 0 1",
  "1k6/8/6B1/4N3/5B1q/8/6K1/8 w - - 0 1",
  "k7/8/2N5/3B4/3p3p/7q/7B/7K w - - 0 1",
  "8/7p/6k1/6P1/P1p4K/5B2/pN6/2B5 w - - 0 1",
  "8/1p2B3/8/4k3/7N/2pB3p/6b1/3K4 w - - 0 1",
  "8/2K2p2/8/B4Pp1/3kp3/6PB/3P2Np/8 w - - 0 1",
  "8/3B4/8/3q4/2N1kp2/2P2p1N/2K2P2/8 w - - 0 1",
  "8/1p6/pP2kq1N/4N3/8/3B4/5PK1/8 w - - 0 1",
  "7q/B4pN1/8/1N1p4/5p1k/3P3P/7K/8 w - - 0 1",
  "N3B3/8/3pp3/2pk2NP/4p3/1PP3K1/2q5/8 w - - 0 1",
  "8/8/Bp3K2/8/3k3p/4N2q/1P5P/4N3 w - - 0 1",
  "8/8/7p/3N2kq/pB5p/8/3N1K2/8 w - - 0 1",
  "4B3/8/3p1p2/2k2q2/3p1P1K/6P1/1NN5/8 w - - 0 1",
  "5n2/8/Bp4qN/p2k4/1P4NP/6P1/4P3/K7 w - - 0 1",
  "8/Nq4p1/1p2k1B1/1N4P1/1P4p1/8/8/4K3 w - - 0 1",
  "3B4/6Nn/5p2/3pq2P/K2k2P1/7P/3Pp3/4N3 w - - 0 1",
  "8/p5N1/P6p/2k2N2/P7/8/2q2P1K/4B3 w - - 0 1",
  "8/7p/N4p1p/2B5/4k3/7N/p6K/8 w - - 0 1",
  "2N5/2p2p2/1p4p1/pq2p3/4N1kP/Pp2P1P1/1P5K/1B6 w - - 0 1",
  "3N4/4p3/q3Bpp1/1N2k3/P6P/6P1/3K4/8 w - - 0 1",
  "8/p1Bp4/7q/1Ppk4/6P1/1p1P3N/6N1/1K6 w - - 0 1",
  "8/1p6/7p/1B1pN2k/3P1qN1/7P/1P1P3P/K7 w - - 0 1",
  "8/Kp6/1pB4p/4Nq1P/P4kN1/8/7P/8 w - - 0 1",
  "8/3qp3/2Np4/3k4/3N4/P5P1/3P4/3B3K w - - 0 1",
  "8/2p3N1/3k4/4p3/2P2p2/3N1q2/2P2P2/2K2B2 w - - 0 1",
  "q4k2/p5N1/P7/1pN5/1P6/8/4p3/1B2K3 w - - 0 1",
  "8/5N1p/2q5/5kPB/8/4p2P/N3P2K/8 w - - 0 1",
  "3k2q1/8/6p1/6N1/1P6/2N5/4p1B1/4K3 w - - 0 1",
  "8/8/2N3q1/8/2Bp1k2/8/4PN1P/2K5 w - - 0 1",
  "8/p7/K7/Np1q2N1/pk4p1/6P1/PB1P2P1/8 w - - 0 1",
  "8/q5p1/5kN1/B5NK/8/8/8/8 w - - 0 1",
  "7n/8/8/1B2N3/1P1k2N1/1P6/1K6/7q w - - 0 1",
  "8/8/pkpq4/1p6/2P4P/N1N5/1P6/K1B5 w - - 0 1",
  "7q/3N3N/2p4p/2P2p2/1B1p1k1p/5P2/3P1K2/8 w - - 0 1",
  "5k2/B3pP2/3q4/2N4p/K1PN4/8/8/8 w - - 0 1",
  "8/8/6K1/2B1k1N1/8/4N1q1/8/8 w - - 0 1",
  "8/1p6/4N3/1q6/2N1k3/1K6/8/5B2 w - - 0 1",
  "5Bb1/1P1p3N/6n1/3p1k2/2P1pP2/1q4P1/6NK/8 w - - 0 1",
  "4B3/p3PN2/Pq6/3kp1K1/4p3/6b1/8/3N4 w - - 0 1",
  "8/8/p7/q3N3/k1B5/P6N/K1P5/8 w - - 0 1",
  "1B6/8/6Pk/6q1/K7/4N3/6N1/8 w - - 0 1",
  "8/5N2/2q5/5p2/3p1k2/8/2N1BK2/8 w - - 0 1",
  "8/B7/8/8/6N1/4K3/2p5/4kN2 w - - 0 1",
  "8/1N6/8/8/3KB3/4N3/1p6/2k5 w - - 0 1",
  "8/8/7N/5K2/4N3/8/2B3kp/8 w - - 0 1",
  "8/N3N3/4K3/8/7B/4k3/3p4/8 w - - 0 1",
  "4NN2/8/8/1q6/5k2/8/5B2/6K1 w - - 0 1",
  "8/3N3q/8/2N5/5k2/B7/5K2/8 w - - 0 1",
  "5K2/5N2/4q3/5k2/8/8/5N2/5B2 w - - 0 1",
  "8/8/8/q7/1k2N3/2N5/2K5/4B3 w - - 0 1",
  "8/8/8/1k1qN3/8/2K2N2/6B1/8 w - - 0 1",
  "8/5q2/B7/8/3KNk2/4N3/8/8 w - - 0 1",
  "5q2/1B3N2/8/4N3/8/7k/8/6K1 w - - 0 1",
  "7k/8/5K2/8/6N1/2B5/4N3/7q w - - 0 1",
  "k7/8/2K5/3N4/2N5/8/5B2/3q4 w - - 0 1",
  "3k4/8/2K2N2/3N4/1B6/8/5q2/8 w - - 0 1",
  "8/6K1/6N1/5q1k/8/1B6/7N/8 w - - 0 1",
  "8/3k4/7N/8/K5N1/2q4B/8/8 w - - 0 1",
  "8/8/1q6/2N5/1p1k4/1K1N4/7B/8 w - - 0 1",
  "8/2q2N1p/4K3/8/pN1k3B/8/8/8 w - - 0 1",
  "8/7p/2pN4/3kq3/pB6/6P1/K5N1/8 w - - 0 1",
  "8/6pK/8/4qk1B/8/2N1P2p/4N2P/8 w - - 0 1",
  "2B5/1p6/1K1k3p/4q3/1p5N/1P3PN1/1P6/8 w - - 0 1",
  "2B3b1/2p5/8/KNpkqP1N/1p6/1P3P2/1P6/8 w - - 0 1",
  "1n1k4/1K3p1N/4P1N1/6P1/1P5P/q7/8/8 w - - 0 1",
  "4q3/p5p1/k5P1/8/1PN4K/8/1N2B3/8 w - - 0 1",
  "8/5p1K/5k2/4q2p/3N3p/2N4P/1BP5/8 w - - 0 1",
  "8/7B/8/4NN2/8/3K4/1p6/2k5 w - - 0 1",
  "1K6/8/q2N4/8/k1N5/8/4B3/8 w - - 0 1",
  "7k/3N1K2/8/8/7q/2N5/8/B7 w - - 0 1",
  "8/8/3K4/8/qk1N4/2p1N3/8/5B2 w - - 0 1",
  "8/kq4p1/8/8/NN6/6p1/6B1/K7 w - - 0 1",
  "8/3N3p/1B1p3q/3p1P1k/4N3/4P3/7K/8 w - - 0 1",
  "8/3p1p2/N3k1p1/p7/5B2/2qNK1P1/8/8 w - - 0 1",
  "K7/8/2k4p/3N4/8/B4N2/8/nB5q w - - 0 1",
  "8/8/6p1/6p1/1K2p3/8/3N2Np/k3B3 w - - 0 1",
  "8/2N5/8/7p/4N1p1/2K4k/6p1/4B3 w - - 0 1",
  "8/p1pB4/8/6q1/2k2N1p/8/K6P/1N6 w - - 0 1",
  "8/8/8/2N3pk/Pp5N/1P2B2p/p1KP4/8 w - - 0 1",
  "8/3p4/8/2P5/8/2pK4/p6R/1k6 w - - 0 1",
  "8/1p5R/8/2Kp4/p7/8/1k6/8 w - - 0 1",
  "7R/8/3pK1p1/8/p7/8/2k5/8 w - - 0 1",
  "8/8/1Kp5/8/p1Bp4/8/Rp1k4/8 w - - 0 1",
  "7K/6p1/8/7p/8/8/R7/6k1 w - - 0 1",
  "8/p7/8/8/1K6/p2P3p/1k3P2/5R2 w - - 0 1",
  "8/8/2p5/8/p7/8/2R5/1k2K3 w - - 0 1",
  "R2K4/P6p/1p5P/qp6/p5k1/PP6/6P1/8 w - - 0 1",
  "4K2k/8/2R5/1p4P1/1B1pp3/3P2P1/2P2P2/1q1b4 w - - 0 1",
  "q7/8/8/8/5R2/4k3/7R/4K3 w - - 0 1",
  "4KR2/7R/4k3/p4n2/8/8/p6P/8 w - - 0 1",
  "8/8/8/8/7k/6pq/R1R5/4K3 w - - 0 1",
  "R1RK4/8/8/8/8/6k1/7q/8 w - - 0 1",
  "k7/8/8/q2p1R1R/6K1/8/8/8 w - - 0 1",
  "k7/8/8/q2p1R1R/8/8/8/3K4 w - - 0 1",
  "5R1R/8/2k5/q7/2K5/8/8/8 w - - 0 1",
  "3k4/q7/1p6/pP6/8/8/R7/R3Kn2 w Q - 0 1",
  "8/6K1/k4p2/8/8/8/2Rn3q/2R5 w - - 0 1",
  "8/4k3/7q/8/8/8/R7/2RK4 w - - 0 1",
  "5R2/7K/5Rp1/6p1/8/8/3k4/4q3 w - - 0 1",
  "8/R7/6q1/8/8/7k/8/2KR4 w - - 0 1",
  "8/8/k7/3q4/KR6/8/8/R7 w - - 0 1",
  "6R1/4K3/8/1k6/5q2/8/8/R7 w - - 0 1",
  "3k4/2q5/8/8/8/6R1/7K/R7 w - - 0 1",
  "4k2K/5R1R/8/8/8/2pp4/1p2b3/1qb5 w - - 0 1",
  "5q1k/1RR5/8/8/8/8/4K3/8 w - - 0 1",
  "5q2/2R5/8/8/2p2p2/7R/8/k2K4 w - - 0 1",
  "8/8/7R/6kP/6n1/8/1K1R3p/8 w - - 0 1",
  "8/q7/2RKp3/1R6/8/k7/8/8 w - - 0 1",
  "4k1q1/5R1R/8/7K/8/8/8/8 w - - 0 1",
  "8/7K/8/8/2p5/8/R4R2/6qk w - - 0 1",
  "8/5pq1/1R6/8/8/8/1R5K/k7 w - - 0 1",
  "k7/8/7q/1RR3p1/6p1/6Pp/8/6K1 w - - 0 1",
  "5qk1/R3R3/8/8/8/8/8/6K1 w - - 0 1",
  "4q3/4k3/6R1/8/5K1R/8/8/8 w - - 0 1",
  "2R5/5K1p/5p1p/7R/8/8/6q1/1k6 w - - 0 1",
  "7k/8/8/8/8/8/KR4R1/2q5 w - - 0 1",
  "5k2/8/8/8/8/8/1K1R3R/4q3 w - - 0 1",
  "2q5/R2R2K1/5p2/7p/8/8/Pk6/8 w - - 0 1",
  "5q1k/8/6K1/8/8/6R1/8/n5R1 w - - 0 1",
  "4q1k1/8/5K2/8/8/8/R7/5R2 w - - 0 1",
  "7k/6pP/8/4p1P1/R7/1Kb5/pp2P3/Rn6 w - - 0 1",
  "Q7/8/8/8/8/8/6rr/K5k1 b - - 0 1",
  "q6k/8/5R1K/8/8/8/8/1R6 w - - 0 1",
  "k6q/8/K1R5/8/8/8/8/6R1 w - - 0 1",
  "k6q/8/K1R5/8/8/7p/8/6R1 w - - 0 1",
  "8/8/p5p1/6Pk/4p3/2q5/P5RK/5R2 w - - 0 1",
  "2k5/8/3R4/8/8/q7/3R4/1K6 w - - 0 1",
  "1k6/2R3p1/1K6/R3p2P/8/8/6q1/8 w - - 0 1",
  "q5k1/8/2p3K1/2p5/7p/4R3/3R4/8 w - - 0 1",
  "4k3/1q6/6P1/8/3p2Rn/3K4/8/R7 w - - 0 1",
  "8/1qk5/8/R7/3Rp3/4K3/8/8 w - - 0 1",
  "8/q7/1k6/8/8/2K1R2R/8/8 w - - 0 1",
  "2R5/7q/7k/8/8/8/R4K2/8 w - - 0 1",
  "8/1k3K2/8/8/2R1R3/q6p/8/8 w - - 0 1",
  "3RK2k/8/5R2/8/8/8/q7/8 w - - 0 1",
  "5qk1/2pR4/1p4K1/8/8/8/8/6R1 w - - 0 1",
  "k7/8/7q/K7/8/3R4/3R4/8 w - - 0 1",
  "5q2/8/5p2/8/2pR4/2R5/8/k1K5 w - - 0 1",
  "1q2k2K/7R/8/8/8/8/8/R7 w - - 0 1",
  "4kq2/8/2K3R1/7R/8/8/8/8 w - - 0 1",
  "7R/3k4/8/1R6/8/7K/2p4p/8 w - - 0 1",
  "q2k4/5p1K/8/8/8/8/5R2/5R2 w - - 0 1",
  "2k4K/q1p5/2Pp4/1R6/8/8/8/1R6 w - - 0 1",
  "3R4/R7/8/8/8/3p1K2/8/1k4q1 w - - 0 1",
  "2K5/k3q3/6pR/6p1/6Pp/7P/8/3R4 w - - 0 1",
  "3q3k/R7/8/3p4/8/8/3R4/7K w - - 0 1",
  "R7/8/8/3q4/6k1/4p3/8/4K2R w K - 0 1",
  "4k3/1q1p2K1/R1RP4/8/8/8/8/8 w - - 0 1",
  "4q3/7K/8/8/7k/2R5/8/1Rn5 w - - 0 1",
  "8/8/8/8/7k/1RpK2pq/R7/1n6 w - - 0 1",
  "8/8/8/k7/8/2R4R/1p1p3K/8 w - - 0 1",
  "k7/2pR4/1p6/4q3/1NP5/1P3K2/8/8 w - - 0 1",
  "5q2/3p1p2/1p6/2R4N/4kPp1/P7/1PP2K2/8 w - - 0 1",
  "5b2/1k1p1P2/p1R5/8/8/1NP5/K1P4p/8 w - - 0 1",
  "4k3/2R5/1p6/1P2p3/4NP1q/P3P3/3K4/7n w - - 0 1",
  "8/1qp5/p1p1pn1P/4k3/5pP1/1N5K/PR3P2/8 w - - 0 1",
  "4k3/2R5/6p1/1pK1p1q1/8/2N3P1/3P4/8 w - - 0 1",
  "8/2p1k3/p7/1q2N1p1/p1RPP3/8/P2P4/4K3 w - - 0 1",
  "8/2p1k3/p7/1q2N1p1/p1RPP3/8/P2P4/4K3 w - - 0 1",
  "8/1p4R1/2kp4/2p1P3/2P2Npq/3P3p/4K1PP/8 w - - 0 1",
  "2q5/2p4p/P7/5p1N/4k3/2K3R1/P5P1/8 w - - 0 1",
  "5q2/6p1/5p2/k3N3/3R1PK1/1P6/7P/8 w - - 0 1",
  "3k4/p7/7P/3p4/2pN3P/2p5/K1P1R3/7q w - - 0 1",
  "8/2R1N2q/7k/7p/4p3/2P1K3/8/8 w - - 0 1",
  "8/1qp1k3/p4p2/3PN3/3RP3/8/PP3Pn1/6K1 w - - 0 1",
  "7q/2R2p1p/2p1p3/2P1k1P1/8/2K1N1PP/8/8 w - - 0 1",
  "3q2k1/p2pR3/1p6/4PN2/4PK2/8/5P2/8 w - - 0 1",
  "1q6/p2R1Np1/4p3/8/2k1Pp2/2P2K2/1P6/8 w - - 0 1",
  "4N3/q7/3p4/p7/k7/4P3/1K1P4/5R2 w - - 0 1",
  "3k4/p2P4/2Rp4/q4P1P/Pp1N4/8/8/4K3 w - - 0 1",
  "3q4/8/3p4/3N3P/7P/1k6/8/K1R5 w - - 0 1",
  "7q/p7/k7/6pp/P2P4/1NP5/5RP1/2K5 w - - 0 1",
  "q4NR1/1p6/2kp4/6p1/P1pP4/2P4P/4P1K1/8 w - - 0 1",
  "2q5/1ppk4/5R2/1P1p4/4PN2/7P/P7/2K5 w - - 0 1",
  "7q/p1k4p/1p6/p4R2/P3pN2/1P1P4/K3P3/8 w - - 0 1",
  "5q2/2R5/5p2/1k3N2/2p1P3/2P5/2K5/8 w - - 0 1",
  "q4N2/p1p5/2pR4/2kpP3/8/8/3P4/3K4 w - - 0 1",
  "1Nq5/p1p5/2p1pR2/p1k1P3/5P2/KP2P3/8/8 w - - 0 1",
  "5q2/2Rp2p1/6p1/4Pk2/1pN5/3KPP2/8/8 w - - 0 1",
  "3q4/1p6/k7/3N4/3K2pP/6P1/2P5/4R3 w - - 0 1",
  "7k/1p1N4/p1P5/P7/P2R4/1K6/3P1q2/8 w - - 0 1",
  "4k3/3p2q1/p4R2/2P1p3/4N3/5PP1/1K2P3/8 w - - 0 1",
  "4k3/8/2p5/p3q1P1/3pN3/5PP1/PR3P2/5K2 w - - 0 1",
  "2Nk2q1/K7/4P1PR/2p5/8/8/1P6/8 w - - 0 1",
  "3N4/2p5/8/3q4/3k4/8/3PKP2/R7 w - - 0 1",
  "3N4/2p5/8/3q4/3k4/8/3PKP2/R7 w - - 0 1",
  "1q6/4k3/2P5/P5pR/1n4PN/8/P1P5/1K6 w - - 0 1",
  "8/2p1p3/R4p2/1Pq3Np/7P/3Pk3/2P3P1/5K2 w - - 0 1",
  "R7/3p3p/8/3P2P1/3k4/1p5p/1P1NKP1P/7q w - - 0 1",
  "3R4/8/4N1K1/2PpkP2/8/n7/3p4/8 w - - 0 1",
  "7R/7p/1K3pp1/3p1k1N/P7/8/3pP3/8 w - - 0 1",
  "3N3R/8/8/2k1p1pK/8/8/3Pp2P/8 w - - 0 1",
  "8/3p4/1Kp1R3/3k4/1P4N1/1PP5/3q4/8 w - - 0 1",
  "8/5p2/1N1R4/8/5k1K/8/4p1P1/8 w - - 0 1",
  "5n2/2K2p2/6p1/P2pk2N/8/2P2P2/1R3P2/4q3 w - - 0 1",
  "8/1p2Rp1p/2N3kP/1P3q2/4pP2/6K1/P7/8 w - - 0 1",
  "8/3N3p/7k/P2p4/pR6/3Pn3/K1P1p3/8 w - - 0 1",
  "5K2/3p2p1/R2p1k1p/6p1/8/3P4/P1p2N2/8 w - - 0 1",
  "8/8/1K2p1p1/1pN1k1p1/1q4P1/1P1R4/3P4/8 w - - 0 1",
  "6R1/2p2pN1/p7/4p3/3k2p1/3P4/p2K3P/8 w - - 0 1",
  "6qk/3R4/2p5/6p1/2P1K1N1/6P1/8/8 w - - 0 1",
  "8/4p1q1/3p4/5k2/2K5/1R6/P3N1P1/8 w - - 0 1",
  "8/3K4/pk6/8/3N4/3RP3/P7/2q5 w - - 0 1",
  "3k4/R6p/2p1p1pq/8/4N2p/4PP2/4K2P/8 w - - 0 1",
  "2N5/5p1p/2p4q/2P2k1P/2p5/8/P2R2P1/3K4 w - - 0 1",
  "8/5p2/8/kpN2P2/8/2R2K2/3pP3/2n5 w - - 0 1",
  "3k4/1p4pP/4Rp2/3p3q/3N4/8/K2PP1PP/8 w - - 0 1",
  "8/2q5/3p4/4kp2/5N2/3RPK2/3P4/8 w - - 0 1",
  "k1N4K/2R5/8/8/8/8/1p5P/8 w - - 0 1",
  "8/2K5/4P2p/P7/8/N1k5/1q6/6R1 w - - 0 1",
  "3k4/1p1P1p2/2pN3p/P7/P7/3K1Pq1/6P1/3R4 w - - 0 1",
  "8/1R1p4/8/4kp2/1NPp1p2/K7/5Pp1/8 w - - 0 1",
  "8/8/3R2K1/1q2kN2/8/8/1PP5/8 w - - 0 1",
  "3k4/1p6/3K1P1N/3P4/8/7R/6q1/8 w - - 0 1",
  "8/6B1/7p/N1k5/8/4K2p/R4pP1/7n w - - 0 1",
  "1R6/8/8/7K/N7/4pkP1/3p4/8 w - - 0 1",
  "2k5/1pNq1p2/8/P3P3/2R5/8/3P4/3K4 w - - 0 1",
  "8/2k2N2/4p1p1/4P3/2q3P1/8/P2P1PK1/1R6 w - - 0 1",
  "8/5N2/K1p5/2q4p/1pP1k2P/1PpR4/2P1P3/8 w - - 0 1",
  "8/1p1p4/3q4/P5kp/8/1R5K/1NP3P1/8 w - - 0 1",
  "8/1p6/8/7q/1Pk5/K5R1/1P3PN1/8 w - - 0 1",
  "R7/1p4p1/2q4p/1N6/4kP2/6P1/2PPp3/4K3 w - - 0 1",
  "3R4/q6p/1p3p1P/5k2/7P/1N4P1/1P2P1K1/8 w - - 0 1",
  "8/3p4/qk1p3p/2R5/1P2P3/P3N2p/7P/4K3 w - - 0 1",
  "8/1p6/p2R4/P3k1N1/2P2q2/p7/P2P1pP1/5K2 w - - 0 1",
  "1k6/1N6/2p2qp1/5p2/1R1P2P1/8/P6P/7K w - - 0 1",
  "8/7p/2p4q/2P2k1P/4N3/5K2/3P4/6R1 w - - 0 1",
  "1N3q2/3P2R1/2p2p2/1k6/1p2P3/8/1P1PKP2/8 w - - 0 1",
  "q7/N3k3/5p2/2RP1p2/1Pp5/6P1/2P2K2/8 w - - 0 1",
  "3R4/2N1p3/8/2P2p2/8/K3p3/3p4/2k5 w - - 0 1",
  "8/8/1K1p2p1/3k4/1R1N4/8/PP5p/8 w - - 0 1",
  "8/2K4p/8/4N2k/2P4q/4P3/8/5R2 w - - 0 1",
  "1K6/1p6/1k6/7P/q4N2/8/2R5/8 w - - 0 1",
  "8/6N1/3k2pP/8/R7/1P3n2/KP1q4/8 w - - 0 1",
  "q4k2/p2pp2K/8/2R1P3/4N3/3P4/P7/8 w - - 0 1",
  "8/8/1p6/3R2N1/3p1P2/K1k5/3p4/8 w - - 0 1",
  "2R5/2K5/3N4/8/2pk4/8/2pP4/8 w - - 0 1",
  "1N1k4/8/3P4/1K6/8/Rn6/3p4/8 w - - 0 1",
  "7q/k6p/3RN1pP/Pppp2P1/p7/4P3/2PK3P/8 w - - 0 1",
  "7q/k7/3RN1K1/Pp1p4/7p/7P/P2P4/8 w - - 0 1",
  "1R6/2ppq2p/4p3/8/3N4/k7/2K4B/8 w - - 0 1",
  "5R1K/2p5/3p2k1/P7/5p2/5N2/2p1P1P1/8 w - - 0 1",
  "8/R2p4/1p6/7p/1p6/1k1Ppp2/1P4P1/1K5N w - - 0 1",
  "2R5/8/1p6/kp6/3p2p1/NP6/1K2Pp2/8 w - - 0 1",
  "R7/P3p3/4n3/7P/1Kp5/2p3P1/7p/2N1k3 w - - 0 1",
  "8/8/8/p3p2N/4P3/7R/pPPpkPK1/8 w - - 0 1",
  "8/8/1R6/b7/7n/2P5/1K1pP2R/3rNk2 w - - 0 1",
  "8/2R5/8/8/8/8/k2K4/q2N4 w - - 0 1",
  "8/8/8/8/5R2/7p/7p/N4K1k w - - 0 1",
  "Q7/1K1k4/2n5/8/8/8/7r/8 b - - 0 1",
  "8/8/8/8/6q1/K2N4/3R4/k7 w - - 0 1",
  "7k/4R2N/4K3/8/8/7p/8/8 b - - 0 1",
  "8/8/4N2R/8/8/8/kp1K4/8 w - - 0 1",
  "k7/N7/R1K5/8/8/8/8/5q2 w - - 0 1",
  "k7/2KN1q2/8/8/8/8/1R6/8 w - - 0 1",
  "R7/3p3p/4Pp2/4q3/1Pk5/8/2P2KNP/8 w - - 0 1",
  "7k/2pK2pn/5P2/5p2/8/R4Pp1/3n4/8 w - - 0 1",
  "4q3/3Nnp2/6P1/8/7R/1P1k4/8/3K4 w - - 0 1",
  "8/1p6/q7/1N3k1K/8/3P4/8/4R3 w - - 0 1",
  "R7/p7/5p2/2N5/1K5p/1p5p/3k4/8 w - - 0 1",
  "8/p7/3K4/1p6/1k6/4N3/qP5P/5R2 w - - 0 1",
  "7R/7N/8/q7/4k3/7P/1PP2K2/8 w - - 0 1",
  "8/8/8/q3p1R1/6N1/3kP3/1P6/3K4 w - - 0 1",
  "4K2R/5N2/2k5/7p/8/8/p7/8 w - - 0 1",
  "R7/8/4k3/2p4K/4N3/1P2q3/8/8 w - - 0 1",
  "8/qN2k3/1p6/p2P4/4p3/8/2K2R2/8 w - - 0 1",
  "4q3/1K6/1p4R1/7k/3p2p1/1P1P4/6NP/8 w - - 0 1",
  "8/1p5N/1p1pp3/1P1q4/K1k3P1/4P2R/1P6/8 w - - 0 1",
  "8/q7/1ppN4/k1P3R1/2K5/4p2p/8/8 w - - 0 1",
  "k7/Bp6/2p5/q1p3N1/1pP3K1/1P6/8/3R4 w - - 0 1",
  "7k/P1b5/P1N5/3q4/8/5p1P/8/2R4K w - - 0 1",
  "8/8/8/3K4/8/6pP/6Pq/1k1N2R1 w - - 0 1",
  "q1Nk4/1p2p3/p1P5/8/KP6/8/4P3/7R w - - 0 1",
  "8/pp1q4/3p4/3k4/R7/2P4P/PP1K4/3B4 w - - 0 1",
  "8/1p5q/1p6/5R2/4k1B1/2P4P/2K2P2/8 w - - 0 1",
  "2B3q1/8/4Rp2/2k5/8/2K5/1P5P/8 w - - 0 1",
  "7q/3p4/3pk3/6Bp/2P2RpP/5PK1/4P3/8 w - - 0 1",
  "1k6/p5R1/q1p3B1/P2Pp1p1/1P6/2P1pP1p/7P/4K3 w - - 0 1",
  "8/2Kp2p1/6PB/k7/p2RP3/q7/P7/8 w - - 0 1",
  "4R3/8/1p5p/1Pk5/8/1K4B1/2P5/2q5 w - - 0 1",
  "1B6/8/7q/1P5p/3kp3/8/4K3/2R5 w - - 0 1",
  "8/1q1p4/p2k3B/8/R1P1P2P/3K4/8/8 w - - 0 1",
  "6q1/5p2/5k1p/3R4/6Pp/3P3K/2P2B2/8 w - - 0 1",
  "8/1p2pK2/q7/2k3B1/8/1R1P4/1P5P/8 w - - 0 1",
  "7R/3p4/1p1p1p2/5p1B/q2k4/6P1/2PK2P1/8 w - - 0 1",
  "8/1K6/8/4q1B1/p1k5/5R2/2PP4/8 w - - 0 1",
  "8/8/R3B3/8/5k1P/1p3p1K/1p3P2/8 w - - 0 1",
  "6B1/8/5k2/q1p1p2K/5pP1/2PRP3/8/8 w - - 0 1",
  "6q1/6p1/2k4p/R6B/p7/8/2P3P1/2K5 w - - 0 1",
  "q7/p1pk4/1p4R1/2P5/5p2/1P1B4/P2P2p1/6K1 w - - 0 1",
  "8/p1p5/4k3/1q6/1P6/1K4R1/3P2P1/3B4 w - - 0 1",
  "2R5/2p5/B7/1K2k3/7p/8/P5p1/8 w - - 0 1",
  "6q1/3p4/4pp2/2P2k2/7K/3PP3/2R5/1B6 w - - 0 1",
  "6q1/p7/P3p1p1/4k3/2P1p1K1/4P3/8/1R2B3 w - - 0 1",
  "8/8/1p1k4/4p2R/8/3P3p/pPK5/3B4 w - - 0 1",
  "1qn5/8/p1p5/2k5/4P2B/R2P4/1P5P/K7 w - - 0 1",
  "8/8/R3p3/7B/P3p3/2k1K3/7p/8 w - - 0 1",
  "6k1/5p2/3K2b1/3P4/8/7P/5Pp1/1R2B3 w - - 0 1",
  "2K5/p6p/4p3/k7/2B4q/1RP5/P4P1P/8 w - - 0 1",
  "2k5/2p2p2/5p2/8/8/1p3BpP/2p3K1/2R5 w - - 0 1",
  "8/k7/3p4/K4R1n/8/8/4ppB1/8 w - - 0 1",
  "8/2p1p3/1p2R3/1B4pk/8/1P5q/2P4P/4K3 w - - 0 1",
  "5k2/2p2p1p/5p2/8/2P1R3/2p3K1/2Pq2P1/6B1 w - - 0 1",
  "4k3/3p1p1p/1Ppp1p2/8/2P1K3/3P4/qB2R2P/8 w - - 0 1",
  "4k3/p3p3/2p1K3/4p2p/R7/P3B3/p7/8 w - - 0 1",
  "3q3k/1B1p4/3P2pK/8/5R2/6P1/8/8 w - - 0 1",
  "k7/6R1/3p4/K7/2p5/5p1q/1PB5/8 w - - 0 1",
  "7k/1R6/8/6B1/4p2K/1p6/7p/8 w - - 0 1",
  "k2B4/1R6/K7/8/7P/1p6/pn6/8 w - - 0 1",
  "1RK5/k7/8/1B6/8/8/3q4/8 w - - 0 1",
  "k7/2KB2R1/8/7q/8/8/8/8 w - - 0 1",
  "6R1/8/8/2B5/8/5K2/7p/7k w - - 0 1",
  "8/8/8/8/2B4R/1p6/p2K4/1k6 w - - 0 1",
  "8/8/8/8/3B4/4p2p/4RPbp/3K3k w - - 0 1",
  "8/8/8/8/1B1R1K2/8/4kp1p/8 w - - 0 1",
  "7b/8/8/5p2/3B4/R3K2p/8/6k1 w - - 0 1",
  "3B2B1/4R3/8/4K3/4p3/4p2p/3n4/5k2 w - - 0 1",
  "5R2/8/8/2p5/4PK2/8/5p1p/B6k w - - 0 1",
  "8/8/8/2R5/1B5K/5p2/8/6k1 b - - 0 1",
  "3k4/B7/p7/Pp4p1/qP4P1/7R/1K6/8 w - - 0 1",
  "B2k4/1R6/1K2p1q1/4PpP1/5P2/8/8/8 w - - 0 1",
  "6k1/3R4/8/1pK5/pp6/P2B4/p7/8 w - - 0 1",
  "qk1B4/p2R4/3K4/P7/8/8/8/8 w - - 0 1",
  "2B5/2kPp3/4p1Kp/5p2/5P2/8/1R4Pp/4b3 w - - 0 1",
  "7k/p3R3/2K3p1/P7/4p3/p7/P6p/2B5 w - - 0 1",
  "K4k2/2p5/7R/2P5/8/p4B2/p6P/8 w - - 0 1",
  "8/1p2k1K1/1P3p2/2R5/8/2P5/2B1p3/8 w - - 0 1",
  "8/q7/n2pk3/8/3P4/1K6/5P1R/1B4B1 w - - 0 1",
  "7R/q7/4k3/1p5p/1p6/4P3/2P2PK1/6B1 w - - 0 1",
  "5R2/8/2p1qP2/3p4/k7/8/3Pp3/2K1B3 w - - 0 1",
  "8/qkp5/3p4/8/2P3B1/2PK4/7R/8 w - - 0 1",
  "2B4k/5pp1/3R1P1P/8/6P1/3b3q/1P6/6K1 w - - 0 1",
  "8/2p2p1q/4p3/8/4P2k/5P2/3P1K2/R2B4 w - - 0 1",
  "8/8/1p2pBp1/6P1/Pp3k2/qP3p2/4PR2/4K3 w - - 0 1",
  "B7/3K2pk/8/5p2/P3P1P1/4p3/1q3PR1/8 w - - 0 1",
  "1B6/p7/5pp1/kP4q1/2Kp4/3P3p/1P4PR/8 w - - 0 1",
  "8/4pK2/6p1/8/3q2pk/B2P4/4PPR1/8 w - - 0 1",
  "4b3/3R2p1/p3pp2/2p5/2P3k1/p2KB3/4PP2/1n6 w - - 0 1",
  "8/3pK3/5p2/1P5p/3qk3/B7/3PPPR1/8 w - - 0 1",
  "8/2K5/4kpq1/8/B4P1R/3p4/1P3P2/8 w - - 0 1",
  "1b6/q1p5/2P5/4B3/8/3K4/1R6/k7 w - - 0 1",
  "8/pqp2p2/2k2P2/2P5/2P5/P4RK1/8/5B2 w - - 0 1",
  "6R1/8/2pB3k/2P4p/5p1q/5P2/4P1K1/8 w - - 0 1",
  "3q4/8/3ppN2/8/8/7k/3B2R1/7K w - - 0 1",
  "5B2/p1p2Kn1/qb6/pk6/8/8/1P2R1B1/8 w - - 0 1",
  "7R/3p4/5B2/1Pp5/6kP/8/3p2K1/8 w - - 0 1",
  "3k4/3p4/5R2/p5BK/7p/6q1/8/8 w - - 0 1",
  "8/1R4pk/3p3p/8/2P4K/q1BP4/2n3P1/8 w - - 0 1",
  "6k1/7p/p4q2/Kp6/3P4/2P1R3/6PB/8 w - - 0 1",
  "7k/6R1/8/8/p2K4/B2P4/P6p/8 w - - 0 1",
  "4K2k/2B1R3/2p3pp/6q1/8/8/8/8 w - - 0 1",
  "7k/p6p/3p4/7P/8/q6p/2R2P1K/4B3 w - - 0 1",
  "k7/1R5p/8/3Bq3/p7/8/7P/5K2 w - - 0 1",
  "K7/5p2/2p1p3/k7/4RP1B/P4P2/q1P5/8 w - - 0 1",
  "K7/8/k3B3/p3ppq1/8/P5P1/8/7R w - - 0 1",
  "8/3p1p2/3k1P2/3p1p2/8/7K/p2P2R1/b3B3 w - - 0 1",
  "1qk5/3p1p1p/8/8/P6R/2B4K/2P5/8 w - - 0 1",
  "8/7q/7k/p6p/3p3p/3P4/PP3RBP/7K w - - 0 1",
  "1K3BR1/1pp2k2/8/5pp1/8/2P2P2/3p4/8 w - - 0 1",
  "2R5/3K4/B2p4/3k4/4p3/4Pp2/1p1P3p/6n1 w - - 0 1",
  "5B2/7K/2pRp3/8/7k/2p5/3p4/8 w - - 0 1",
  "7q/K2kp3/1R6/4p3/8/4b1P1/P1B5/6R1 w - - 0 1",
  "1RB4k/1p6/5Kpp/8/8/8/6p1/1q6 w - - 0 1",
  "8/1p6/k1p5/4p3/2K3p1/3R4/4Pp2/B7 w - - 0 1",
  "2B2R2/2p5/2k5/2p1p2K/6P1/1pP4p/1P4p1/8 w - - 0 1",
  "5q2/6p1/6k1/5pPp/1P2BR2/8/6P1/7K w - - 0 1",
  "8/8/5p2/6pp/Bqn3k1/6P1/1P3P1P/4R1K1 w - - 0 1",
  "2K5/5p2/p2kpP2/qppp4/4PP2/8/P2P4/2R1B3 w - - 0 1",
  "2k5/4pqp1/Ppp1p3/4PP2/B7/4K3/5R2/8 w - - 0 1",
  "8/5p2/K2R1Pp1/4P3/1p2k3/p7/P2P1p2/2B5 w - - 0 1",
  "5qk1/8/1B2R1K1/6N1/8/8/8/8 w - - 0 1",
  "1q6/8/8/8/2N4R/1k2B3/8/2K5 w - - 0 1",
  "2B3q1/2k5/1N6/8/8/3R4/1K6/8 w - - 0 1",
  "8/3k4/6q1/8/2KN4/8/3R4/7B w - - 0 1",
  "3R4/8/2N3qB/8/8/k7/8/2K5 w - - 0 1",
  "8/2B5/3N4/8/3q4/7k/8/1R3K2 w - - 0 1",
  "1B6/8/8/q7/4N2k/8/2R3K1/8 w - - 0 1",
  "8/3N4/7k/3q4/B7/8/5R2/K7 w - - 0 1",
  "7k/4N3/5q2/8/6K1/3B4/8/2R5 w - - 0 1",
  "8/3B1R2/8/8/7k/2q5/7K/6N1 w - - 0 1",
  "4R3/B7/3q4/8/2k5/2N5/1K6/8 w - - 0 1",
  "4R3/3q4/8/8/2Nk4/1K6/8/7B w - - 0 1",
  "2q5/2N5/3B4/8/5R2/1k6/8/1K6 w - - 0 1",
  "6R1/3K4/8/4k3/8/2N1B3/1q6/8 w - - 0 1",
  "8/q5B1/1R6/8/8/2N5/5K2/k7 w - - 0 1",
  "k7/8/q3B3/N7/K7/8/8/4R3 w - - 0 1",
  "8/k7/8/N7/K7/4qBR1/8/8 w - - 0 1",
  "k7/1q5B/2N5/8/K7/8/8/7R w - - 0 1",
  "1k6/8/1N6/8/8/q1B5/2K5/7R w - - 0 1",
  "k7/8/8/8/N2B2K1/q7/8/2R5 w - - 0 1",
  "5k2/q7/2K5/4B3/6N1/8/8/4R3 w - - 0 1",
  "8/4k3/8/3BN3/8/4q3/K7/5R2 w - - 0 1",
  "8/8/8/4K3/1kq5/2N2R2/6B1/8 w - - 0 1",
  "8/4BN2/kq6/2R5/K7/8/8/8 w - - 0 1",
  "2q1k3/8/3B4/8/4NK2/5R2/8/8 w - - 0 1",
  "8/8/B7/3R4/5k1N/2q5/8/6K1 w - - 0 1",
  "8/6q1/N7/4R3/k7/8/8/1K5B w - - 0 1",
  "8/3q4/6B1/8/1R6/k7/3N4/1K6 w - - 0 1",
  "2R5/8/qk4pK/4B3/8/2N5/8/8 w - - 0 1",
  "q7/8/N2k4/8/5p2/8/8/1BK1R3 w - - 0 1",
  "8/8/2p5/2R5/1q2NB2/8/1k2K3/8 w - - 0 1",
  "4R3/8/8/1K1k4/p4Bq1/8/N7/8 w - - 0 1",
  "8/6B1/8/qp2R3/N7/8/3k4/1K6 w - - 0 1",
  "8/8/2p5/2B5/8/N1R5/3q4/4k1K1 w - - 0 1",
  "8/8/q4N2/1pk4B/8/8/3K4/4R3 w - - 0 1",
  "4q3/3R4/1p6/1Nk5/6B1/2K5/8/8 w - - 0 1",
  "k7/7B/N7/8/7R/1PK5/4q3/8 w - - 0 1",
  "4k3/8/4K3/p4N2/1p6/2p2B2/3q4/R7 w - - 0 1",
  "7q/5K1N/7p/2k4P/3R4/6B1/8/8 w - - 0 1",
  "8/1N6/2p1p3/5p1p/Pp2k2q/1P5b/3B1P2/3RK3 w - - 0 1",
  "2B5/6pq/6p1/1n6/3Pk1N1/2P5/3K2P1/R7 w - - 0 1",
  "3b2k1/6p1/1p1p2B1/1R5N/4K2p/1P3P1p/3P4/8 w - - 0 1",
  "2K5/1Np2R2/8/3pk3/7B/8/3q4/8 w - - 0 1",
  "3B4/qp2N1k1/p1R5/8/8/8/8/7K w - - 0 1",
  "8/1p6/1k3B2/8/5qNR/5p2/5K2/8 w - - 0 1",
  "2R5/3k4/2p2K2/4p3/4B3/1q6/8/1N6 w - - 0 1",
  "5k2/1p6/6K1/5p2/5B2/2q5/8/2NR4 w - - 0 1",
  "3k4/3p1p2/4p2q/8/8/R3N1B1/8/4K3 w - - 0 1",
  "R4B2/2Np4/6p1/8/4k3/2q3pK/8/8 w - - 0 1",
  "7B/p3k3/6K1/4p2p/4N3/8/6R1/3q4 w - - 0 1",
  "3q4/3p2R1/8/1N1p3p/8/3k4/8/3K2B1 w - - 0 1",
  "8/4pp2/1N5p/4k2K/1q6/3R4/8/6B1 w - - 0 1",
  "8/8/1R2p2p/3k4/1K6/8/7q/3NB3 w - - 0 1",
  "5B1R/q1p2k2/3p3K/8/B7/1N6/8/8 w - - 0 1",
  "5n2/5p2/1p2P3/1P6/1P1q1k1N/B7/R3P1K1/8 w - - 0 1",
  "8/6p1/4p3/2k2q2/1R3N2/B7/K7/8 w - - 0 1",
  "2K2B2/3pN3/1p1k4/1p6/8/8/3q4/4R3 w - - 0 1",
  "6q1/2Bp4/1p4pR/1Pkp2N1/K6P/3P4/4P3/8 w - - 0 1",
  "K7/8/8/8/1B6/6n1/R2N3p/n2k4 w - - 0 1",
  "8/p2N1k2/5p2/p7/P7/P4B1q/1K6/4R3 w - - 0 1",
  "6R1/8/5K2/6p1/3NpkqB/8/8/8 w - - 0 1",
  "8/8/4q1p1/2k3P1/1R1p4/1p2P1P1/2N3P1/1B2K3 w - - 0 1",
  "7k/B1R5/7p/7p/4Pp2/1P2N1p1/K7/6q1 w - - 0 1",
  "1k3q2/8/K2R4/8/6B1/B7/8/8 w - - 0 1",
  "2q2k2/7B/4R2K/8/8/8/3B4/8 w - - 0 1",
  "8/3q4/8/B3k2B/8/8/5R2/4K3 w - - 0 1",
  "8/3R2B1/k1B5/8/7q/1K6/8/8 w - - 0 1",
  "q7/8/8/8/1B5R/7B/7k/3K4 w - - 0 1",
  "4q3/8/8/8/8/2R4B/1B3K1k/8 w - - 0 1",
  "3k4/1q6/8/7B/R4K2/8/3B4/8 w - - 0 1",
  "1q6/8/8/3R4/7k/2B5/B3K3/8 w - - 0 1",
  "3B4/6q1/8/3BR3/8/k7/8/1K6 w - - 0 1",
  "q7/8/8/6R1/k5B1/8/2K4B/8 w - - 0 1",
  "8/3R4/7K/3Bk3/q7/8/8/6B1 w - - 0 1",
  "8/3R4/7K/3B1k2/5B2/q7/8/8 w - - 0 1",
  "8/4R3/8/7q/B6k/8/1B5K/8 w - - 0 1",
  "8/8/8/2B5/8/1qk2B2/5R2/2K5 w - - 0 1",
  "k7/5B2/8/2R5/3B4/8/7q/3K4 w - - 0 1",
  "4B3/k7/8/8/6q1/3K4/4R2B/8 w - - 0 1",
  "4q3/4B2K/8/5k2/8/6R1/8/3B4 w - - 0 1",
  "8/8/1k6/7q/2R4B/8/6B1/4K3 w - - 0 1",
  "8/5B2/7q/1k6/3R4/1K4B1/8/8 w - - 0 1",
  "5B2/8/8/7q/2k5/3R4/1K4B1/8 w - - 0 1",
  "8/8/8/2R5/k7/3B2B1/2K5/q7 w - - 0 1",
  "8/8/2R3B1/q7/k6B/8/8/3K4 w - - 0 1",
  "2BB4/8/8/8/q7/8/2R5/k2K4 w - - 0 1",
  "8/7K/3p4/B6k/2R5/1B6/1q6/8 w - - 0 1",
  "7B/2q5/2p2R2/8/4k3/7B/8/3K4 w - - 0 1",
  "K3k3/2R1B3/3p4/3B4/8/8/8/1q6 w - - 0 1",
  "K3k3/8/2Rp1B2/3B4/3p4/8/7q/6b1 w - - 0 1",
  "q7/8/p2R4/1k6/p7/2K3BB/8/8 w - - 0 1",
  "1q6/p7/7p/7R/k6B/7B/3K4/8 w - - 0 1",
  "8/q2B4/1p6/p6R/8/3k4/3B4/3K4 w - - 0 1",
  "8/6B1/3R3p/2k4q/7p/7B/8/1K6 w - - 0 1",
  "8/1kp3p1/q4pB1/8/5Rp1/4B3/8/4K3 w - - 0 1",
  "2K2B1k/6pp/6B1/8/8/1pR5/p7/8 w - - 0 1",
  "8/q1b5/8/8/3k4/p3R2p/P5Bp/6BK w - - 0 1",
  "5BBR/1p6/kp6/8/5p2/6p1/K5p1/8 w - - 0 1",
  "4q3/8/8/8/3N1N2/3K2R1/7k/8 w - - 0 1",
  "8/8/3k2q1/3N4/3K4/2N5/8/7R w - - 0 1",
  "8/2q5/8/8/R7/N2k3N/8/4K3 w - - 0 1",
  "8/8/7q/2N1N3/1K1k4/8/8/4R3 w - - 0 1",
  "8/R6N/6k1/8/6N1/6K1/2q5/8 w - - 0 1",
  "8/k3N2R/8/8/2N5/3K4/8/4q3 w - - 0 1",
  "4k3/7R/2q5/5N2/4N3/8/8/4K3 w - - 0 1",
  "q7/1N4R1/8/8/4N3/8/k1K5/8 w - - 0 1",
  "4K2k/4N3/8/q7/6N1/8/1R6/8 w - - 0 1",
  "4q3/R2N4/8/8/8/3kN3/8/3K4 w - - 0 1",
  "2q5/3N4/8/8/8/2Nk4/7R/2K5 w - - 0 1",
  "1N6/8/4q3/8/3k4/R3N3/3K4/8 w - - 0 1",
  "5N2/5q2/8/1N6/8/3k4/7R/4K3 w - - 0 1",
  "8/7N/3q1R2/3k4/3N4/3K4/8/8 w - - 0 1",
  "8/2N5/3K2R1/4N3/4qk2/8/8/8 w - - 0 1",
  "8/1q6/3k4/8/6K1/3N2N1/8/2R5 w - - 0 1",
  "1N6/5q2/3k2NR/8/8/2K5/8/8 w - - 0 1",
  "8/2K5/8/1k2N3/4Nq2/8/8/7R w - - 0 1",
  "4q3/1N6/8/8/1k6/N7/3K4/R7 w - - 0 1",
  "4q3/1N4R1/8/3N4/8/8/k1K5/8 w - - 0 1",
  "5q2/8/8/7R/4k2N/3N4/2K5/8 w - - 0 1",
  "6R1/8/4K3/7k/1q2N3/8/4N3/8 w - - 0 1",
  "5k2/3R2N1/8/5K2/1q1N4/8/8/8 w - - 0 1",
  "2k2q2/8/1KN5/1R6/4N3/8/8/8 w - - 0 1",
  "2k2q2/8/1KN5/8/1R2N3/8/8/8 w - - 0 1",
  "4N3/5K1k/8/7N/1R6/8/8/7q w - - 0 1",
  "1R6/5q2/8/2n5/2N2N2/8/8/4k2K w - - 0 1",
  "8/8/4N2b/q7/4N3/7R/4k3/6K1 w - - 0 1",
  "2R5/q7/8/8/n2N4/3k4/2N5/4K3 w - - 0 1",
  "8/k7/7R/7p/2NN2q1/3K4/8/8 w - - 0 1",
  "1b6/4q3/1P3n1N/2k1N3/P2p4/2P2R2/2P2PK1/8 w - - 0 1",
  "8/3N4/2R5/5k1K/P2p4/8/1PNq1pP1/8 w - - 0 1",
  "1N1K4/6p1/p5q1/k7/1N1Rp3/8/8/8 w - - 0 1",
  "8/3k1Ppq/6n1/2K2p2/6N1/6R1/6N1/8 w - - 0 1",
  "2k2N2/1p5p/1q6/1P4P1/4N1K1/8/1b6/3R4 w - - 0 1",
  "8/2N5/p2N3p/8/3q4/7k/8/1R5K w - - 0 1",
  "8/3p1qN1/R7/3p4/3N4/3K2k1/8/8 w - - 0 1",
  "7k/7N/3p3R/4P3/1q6/p5N1/2P3P1/K7 w - - 0 1",
  "2N5/2pp4/2k5/8/K7/6qN/8/1R6 w - - 0 1",
  "8/1N3q2/1K1p3p/8/3kp1N1/R7/8/8 w - - 0 1",
  "2N2q1b/4Np2/8/8/4k3/R7/4K3/8 w - - 0 1",
  "4N3/nq6/6R1/4k1N1/8/2p1K3/8/8 w - - 0 1",
  "8/p6p/P3p2P/P3R3/2K5/2p1N3/p4k2/1N6 w - - 0 1",
  "8/8/q7/8/5k2/8/4R1RN/6K1 w - - 0 1",
  "6K1/R7/3q3k/5R2/8/3N4/8/8 w - - 0 1",
  "4K3/2k5/2N5/3R4/1R6/8/4p3/8 b - - 0 1",
  "3q4/R7/8/2k5/K7/8/NR6/8 w - - 0 1",
  "8/6R1/2qN3R/p7/5kp1/1p6/3p4/3K4 w - - 0 1",
  "q7/4p3/2Rp3K/2N5/8/2k5/8/3R4 w - - 0 1",
  "5k2/4pp2/1b6/6N1/2pq4/5P2/1P2R1R1/1K6 w - - 0 1",
  "k7/1qpp4/7R/K7/1N6/8/2R5/8 w - - 0 1",
  "8/8/5q2/2k5/3R4/4R3/7B/K7 w - - 0 1",
  "5R1R/3k4/5B2/8/8/8/2K4p/5q2 w - - 0 1",
  "4R2K/2k5/4B3/8/5b2/3R4/8/4q3 w - - 0 1",
  "8/6K1/R7/B2qk3/R7/3n4/8/7b w - - 0 1",
  "Q7/7q/4p3/K1k5/3p1P1p/2N5/5P2/5b2 w - - 0 1",
  "8/7q/2p1p3/4k1P1/5p2/1K6/Q2P2P1/8 w - - 0 1",
  "4k3/2q1p3/4P3/8/8/3b1P2/3Q3p/7K w - - 0 1",
  "8/8/3b1N2/2p1p3/5k1K/Q7/2P5/3q4 w - - 0 1",
  "1qb5/8/3P1QK1/2p5/2k3p1/2P5/3P3P/1n6 w - - 0 1",
  "8/7q/2K2p2/4p3/2k1P2p/8/3P4/7Q w - - 0 1",
  "7K/8/kp2p3/P7/8/1PP1pQp1/8/q7 w - - 0 1",
  "7q/7p/2pp4/3k2p1/5P2/3K4/8/3Q4 w - - 0 1",
  "8/p3K3/8/2pk3P/q2p4/8/p3P3/5Q2 w - - 0 1",
  "q1b5/8/1p5k/6p1/8/6P1/2QPB2K/8 w - - 0 1",
  "1K6/pp3p2/4p3/8/4Pk2/5P2/P2P1Q2/3q1b2 w - - 0 1",
  "6q1/2p5/5pp1/Q1p5/3P3k/1p3K2/4P3/8 w - - 0 1",
  "6q1/8/3p1pp1/3P4/Qp6/p7/8/4K2k w - - 0 1",
  "6bq/8/p4P2/1p6/1k6/1P6/2P2QK1/8 w - - 0 1",
  "8/3k4/7P/2P1Q3/5p2/1K5b/p6q/8 w - - 0 1",
  "q1b5/8/3P2K1/2k5/5Qpp/2P5/8/8 w - - 0 1",
  "6n1/8/1K1kp2P/8/6Q1/Pp1q4/5P2/8 w - - 0 1",
  "8/4p3/1pkP3Q/5p2/1K3p2/5Pq1/8/8 w - - 0 1",
  "8/2p1p3/K1Pb3q/4p3/3k1p2/5P2/3P4/4Q3 w - - 0 1",
  "8/1Q6/3pqp2/7k/8/8/3P1PK1/8 w - - 0 1",
  "K7/1P6/k1q5/8/8/1Q6/8/8 w - - 0 1",
  "6K1/3p2P1/1p1p2k1/1Pn5/8/7Q/8/6q1 w - - 0 1",
  "8/K1p2p2/4b2P/1p6/4Q3/5p1k/P4Pq1/8 w - - 0 1",
  "1b5q/2P5/8/8/3pp1k1/1K6/Q7/8 w - - 0 1",
  "8/1P6/8/8/4k1np/8/1B1K2p1/8 w - - 0 1",
  "1bK5/p7/NP6/6p1/8/2k5/8/8 w - - 0 1",
  "4n3/2b5/N6P/3K4/7B/pk6/8/8 w - - 0 1",
  "7B/8/1P2K3/8/3p4/2p1k1p1/1P5n/8 w - - 0 1",
  "8/2Pn4/8/3k4/K7/p5p1/8/B7 w - - 0 1",
  "6b1/6p1/5k2/1p5p/P3B3/1P1K3p/8/8 w - - 0 1",
  "2K5/1p6/pPp5/8/8/4k3/6bB/8 w - - 0 1",
  "1B4b1/1P6/8/3pPp2/3k4/8/p3K3/8 w - - 0 1",
  "8/4p3/8/3PkP2/1p4K1/p7/P5B1/8 w - - 0 1",
  "1B6/5p1p/8/4PK1P/p5Pp/4k3/8/8 w - - 0 1",
  "4BK2/8/2P2p1k/8/8/1p5P/1b6/8 w - - 0 1",
  "2K5/6N1/P3p3/4k3/8/7p/3P1b2/1B6 w - - 0 1",
  "8/B7/8/8/p7/1p6/P1P2K2/1k6 w - - 0 1",
  "8/8/8/8/2B5/K3P2p/8/3k4 w - - 0 1",
  "6R1/7K/P1k5/8/2B5/4b3/7p/8 w - - 0 1",
  "2k5/1pp4N/1P1PK2p/8/8/8/2p5/4b3 w - - 0 1",
  "8/3K4/Nk4P1/2p5/5p2/p4P2/3b4/8 w - - 0 1",
  "2K5/4B3/k3P3/p3p3/8/4p3/2P5/2b5 w - - 0 1",
  "1K6/5p2/k3P3/p7/8/3p4/P1N5/8 w - - 0 1",
  "8/6P1/8/1p1N4/b4K2/8/p7/5k2 w - - 0 1",
  "5K2/1P1p4/3p4/p7/B7/8/7p/5kN1 w - - 0 1",
  "4bK2/1P1p4/p7/6p1/B7/8/7p/2N2k2 w - - 0 1",
  "8/8/1p3K2/P7/3p2k1/4b3/2N5/8 w - - 0 1",
  "6K1/8/8/8/2B3k1/1P6/2N4p/7b w - - 0 1",
  "4B2n/6K1/8/8/2N3k1/6P1/1P5p/7b w - - 0 1",
  "8/3p4/8/7p/1KPk4/8/B7/8 w - - 0 1",
  "8/3pp3/8/2P5/1K1k3p/8/6B1/8 w - - 0 1",
  "8/1p3P2/6p1/k4rp1/8/8/6PP/4R2K w - - 0 1",
  "4K3/4P3/4N3/8/8/3p1p2/4k3/8 w - - 0 1",
  "8/1K1k1p1p/1P4p1/3pP1N1/p4P2/8/5P2/8 w - - 0 1",
  "8/5kp1/3p1P2/4P1pP/2p3P1/1q5p/4RP1K/8 w - - 0 1",
  "7R/1k3p1P/3pp3/PK6/8/1p6/p6p/8 w - - 0 1",
  "8/K2np1p1/1P5k/6pP/8/4pN2/4P3/8 w - - 0 1",
  "8/8/8/bp5P/8/B7/8/4k2K w - - 0 1",
  "6K1/8/2p2P2/7p/p7/4k2N/6B1/3b4 w - - 0 1",
  "8/7K/6NB/1p4P1/8/k7/4p3/8 w - - 0 1",
  "4N3/pK6/8/4Pk2/8/4Pp2/2P5/8 w - - 0 1",
  "7K/8/4p3/2p2kPP/8/4P3/2b5/4n3 w - - 0 1",
  "8/1pp5/b7/2P3K1/8/7p/RP6/7k w - - 0 1",
  "1n1k1NNn/2p2pK1/4P3/8/8/8/8/8 w - - 0 1",
  "8/8/8/5p2/PK1k4/8/8/8 b - - 0 1",
  "8/1p1k4/8/2PK3p/2P5/7P/8/8 w - - 0 1",
  "2k5/2P3p1/p1PP3p/P4pp1/8/6K1/8/8 w - - 0 1",
  "8/1p6/4K3/8/8/3k4/6P1/8 w - - 0 1",
  "8/1p6/4K3/8/8/8/4k2P/8 w - - 0 1",
  "7n/6P1/Pk1K4/8/8/2p5/p7/8 w - - 0 1",
  "8/2K5/4P3/3k4/2pp2P1/p6p/4P3/8 w - - 0 1",
  "8/p4p2/4p3/kp2P1P1/5K2/6p1/1P4P1/8 w - - 0 1",
  "8/8/p6p/6p1/3K2P1/3P1k1P/8/8 w - - 0 1",
  "8/8/8/p2K1p2/3P1Pk1/8/8/8 w - - 0 1",
  "8/8/8/p2K1p2/3P1Pk1/8/8/8 w - - 0 1",
  "8/8/4K3/p4p2/5P2/3P4/8/4k3 w - - 0 1",
  "8/1p3p2/p7/8/2k5/4P1pP/2P1K1P1/8 w - - 0 1",
  "8/8/8/2k1p3/4P3/2K5/2P5/8 w - - 0 1",
  "8/8/8/8/8/P4p2/k6K/8 w - - 0 1",
  "8/1p6/8/5k1p/P1P3p1/8/5PK1/8 w - - 0 1",
  "8/8/4p3/pp6/5kPK/5p2/5P2/8 w - - 0 1",
  "8/2pp1p2/p2k1P2/5P2/2K4P/8/8/8 w - - 0 1",
  "8/pKp2p2/1p1p1k1P/5P2/5P2/8/8/8 w - - 0 1",
  "8/8/1p6/8/k7/3K4/5P2/8 w - - 0 1",
  "6K1/8/pp5p/8/7k/3PP3/8/8 w - - 0 1",
  "8/4kP2/3pP3/5K2/3p4/2p5/4P3/8 w - - 0 1",
  "K7/5p2/k7/6p1/P5P1/8/P7/8 w - - 0 1",
  "7k/2p1p2P/4p1P1/5Pp1/2pP4/6K1/6P1/8 w - - 0 1",
  "k1K5/8/5P2/1P6/2p3p1/1p6/8/8 b - - 0 1",
  "8/7p/5K2/5P2/1p6/1k3P2/8/8 w - - 0 1",
  "8/2p2p2/p7/2p5/PP6/3KP3/8/5k2 w - - 0 1",
  "8/2p5/8/8/5P1k/p7/7P/2K5 w - - 0 1",
  "8/1pK5/8/8/8/8/k4P2/8 w - - 0 1",
  "8/8/3p3p/3P2p1/p1k1P3/P1p2K1P/2P5/8 w - - 0 1",
  "8/5k2/5p2/p7/2P1K1P1/8/8/8 w - - 0 1",
  "8/8/p7/5p2/3K1P2/3P1Pk1/8/8 w - - 0 1",
  "8/2kP4/2P5/1p1p3p/8/4K3/8/8 w - - 0 1",
  "8/7p/2pk4/6K1/1P6/5P2/8/8 w - - 0 1",
  "8/pKp3p1/8/7P/5Pk1/8/1P6/8 w - - 0 1",
  "8/pKp3p1/8/7P/5Pk1/8/1P6/8 w - - 0 1",
  "5n1q/8/1p6/k7/P6p/2P5/Q7/7K w - - 0 1",
  "5nq1/1p1p2p1/8/B3p3/k7/5K2/2P2PP1/3Q4 w - - 0 1",
  "4b2q/7p/Q5p1/B1k5/3bp3/8/1PP1K3/8 w - - 0 1",
  "8/5K2/3pp3/8/5k1p/3p3Q/q3P3/8 w - - 0 1",
  "3Q4/6K1/8/7k/8/8/1pq2P2/8 w - - 0 1",
  "6Q1/b7/8/p1pP4/8/K1k5/2PpP3/3q4 w - - 0 1",
  "3K4/3p4/bpkP2BP/8/1p6/1p6/r2PP3/8 w - - 0 1",
  "8/1p1p2p1/1pkp4/5P2/2K5/8/2QPP2q/3n4 w - - 0 1",
  "8/8/1p3P2/2p1k1Kp/6p1/2p5/1PPP4/8 w - - 0 1",
  "8/2p2p2/1p6/3P1k1K/P1P2P2/8/8/8 w - - 0 1",
  "8/8/1p1K4/Pp6/2k1p3/8/1P6/8 w - - 0 1",
  "8/4p2p/8/1K1k4/8/5P2/P7/8 w - - 0 1",
  "8/4K3/2P3p1/3k1p2/4p3/3P2p1/5P2/8 w - - 0 1",
  "8/p3p3/2p1K3/2k5/2p5/7P/1P6/8 w - - 0 1",
  "8/8/Q7/2p2q2/8/Kp6/8/k7 w - - 0 1",
  "Q7/3p3q/3p4/p7/2p5/K7/4P3/k1N5 w - - 0 1",
  "5q2/6p1/1p6/p7/k3p3/8/K3Q3/8 w - - 0 1",
  "5q2/2Q5/1p4p1/p7/k3p3/8/K7/8 w - - 0 1",
  "1Q6/8/5bpq/6kp/6P1/8/6RK/8 w - - 0 1",
  "1qNQ4/2p3p1/1p6/8/1B6/1k6/8/K7 w - - 0 1",
  "8/1p6/5Pp1/7p/7k/3p4/7K/8 w - - 0 1",
  "6K1/8/4p2q/6kn/4p1B1/6P1/4Q3/8 w - - 0 1",
  "5Q2/2K2n2/5qp1/k4p2/1p3P2/1P4P1/8/8 w - - 0 1",
  "7Q/3K4/kq1N4/8/8/8/8/8 w - - 0 1",
  "7q/4N1k1/8/5Qp1/8/6K1/8/8 w - - 0 1",
  "Q7/3N3k/7p/6q1/8/8/7K/8 w - - 0 1",
  "8/8/8/p7/8/kp6/7P/3KN3 w - - 0 1",
  "Q2N3k/5p2/1r4q1/1p4p1/5PP1/1K3p2/8/8 w - - 0 1",
  "8/8/1K1N4/5p2/8/8/6Q1/q1k5 w - - 0 1",
  "7q/4p3/7k/2N5/8/pp2p1Q1/4K3/8 w - - 0 1",
  "8/8/8/4N2P/1p4p1/p7/5K2/k7 w - - 0 1",
  "8/1Pq5/p1pN1p2/k7/5P2/6Q1/6pK/r7 w - - 0 1",
  "6b1/8/1N1P4/k7/5K2/7p/8/8 w - - 0 1",
  "8/p3K3/8/4k3/5pp1/2N5/8/qn3Q2 w - - 0 1",
  "2N5/2P4p/7k/8/8/p7/4K3/8 w - - 0 1",
  "7k/8/2P3n1/8/8/3pN1K1/8/8 w - - 0 1",
  "2n5/6P1/8/8/1K5k/8/3p4/6N1 w - - 0 1",
  "5n2/2Q5/5q1p/1N3p2/7P/8/8/1K1k4 w - - 0 1",
  "8/K3N3/8/4p3/1k6/p4q1n/3P4/2Q5 w - - 0 1",
  "8/8/1p1q4/3p4/1P6/4Nk2/1Q6/7K w - - 0 1",
  "1Q6/5N2/8/1K6/4k1p1/3p4/P4P2/2n3q1 w - - 0 1",
  "7K/4p3/4rk1p/2P3N1/8/2N5/8/8 w - - 0 1",
  "3q4/8/6K1/8/4kb2/8/4N3/4Q3 w - - 0 1",
  "8/6N1/3Kp1q1/4Q3/7k/8/8/8 w - - 0 1",
  "8/3k2P1/8/1K6/2N5/8/p7/8 w - - 0 1",
  "8/2q4p/p7/4pQ2/1pp5/6N1/8/1K4k1 w - - 0 1",
  "8/5q2/3p2p1/5p2/3k4/2N4K/1Q6/8 w - - 0 1",
  "8/1Kb5/P2k4/3N1p2/8/3p2Pp/5P2/8 w - - 0 1",
  "5K2/2Q5/6q1/8/3kN3/8/8/8 w - - 0 1",
  "5r2/8/3P4/6R1/8/3Nkp2/7K/8 w - - 0 1",
  "8/8/8/5k2/4N3/8/2Q3K1/4q3 w - - 0 1",
  "2Q1K3/8/2N2q2/6p1/8/8/2k5/8 w - - 0 1",
  "q7/8/1p1p4/8/3NN3/p3k3/p1K5/Q7 w - - 0 1",
  "8/8/P1k5/8/1K2Npp1/8/8/8 w - - 0 1",
  "8/7p/7p/2kN4/6Q1/8/3K4/7q w - - 0 1",
  "3K4/2pp4/8/P7/1k4p1/8/8/N7 w - - 0 1",
  "3q4/1Q6/K4Nk1/8/8/5p2/8/8 w - - 0 1",
  "8/2K5/P4N2/1p6/8/8/6p1/2n3k1 w - - 0 1",
  "8/q7/4N3/7k/8/8/2Q2p2/5K2 w - - 0 1",
  "8/8/k5pK/2Q5/N4p2/8/8/1q6 w - - 0 1",
  "7k/3r3P/7q/4N1p1/5pK1/2p5/2Q5/8 w - - 0 1",
  "2K5/1pp5/8/8/2Q5/4N3/3q4/6k1 w - - 0 1",
  "8/K7/1p6/3Qp3/p6k/4N3/1q6/8 w - - 0 1",
  "8/q7/8/p3Q1Nk/P2p4/8/1n6/Kn6 w - - 0 1",
  "k7/8/3N4/8/1Q6/5q2/8/K2b4 w - - 0 1",
  "2k5/6K1/8/4N1pQ/8/p5q1/8/8 w - - 0 1",
  "6q1/4Pk2/6n1/1N6/2p5/Q3p3/4K3/8 w - - 0 1",
  "7k/5n1q/4N3/1K6/2p5/4Q3/8/8 w - - 0 1",
  "k7/q1n5/3N4/5pK1/5p2/Q7/8/8 w - - 0 1",
  "8/P7/3p4/4p3/2p5/2K1N3/7p/6k1 w - - 0 1",
  "8/6K1/2PP4/4k3/7N/8/2p5/8 w - - 0 1",
  "8/8/Q7/1N1k4/8/6q1/2K5/8 w - - 0 1",
  "8/5N1K/8/3k4/7Q/5q2/8/8 w - - 0 1",
  "8/1N3k1K/8/5p2/8/5q2/8/4Q3 w - - 0 1",
  "8/5N1K/6PP/5b2/4pk2/5p2/5P2/8 w - - 0 1",
  "8/8/7q/4N3/8/1Q6/3k4/K7 w - - 0 1",
  "1K6/8/5q2/3Q4/k7/4N3/8/8 w - - 0 1",
  "7Q/8/8/8/4kq1N/1K6/8/8 w - - 0 1",
  "8/8/8/8/5k2/3q1N2/Q4K2/8 w - - 0 1",
  "6Q1/8/8/8/4q1N1/5k1K/8/8 w - - 0 1",
  "3q4/1Q2N3/8/8/8/3k4/8/4K3 w - - 0 1",
  "2q5/8/8/8/1N6/8/1k1K1Q2/8 w - - 0 1",
  "8/5q2/1Q6/4k3/1N6/8/3K4/8 w - - 0 1",
  "5q2/8/8/3k4/8/3K4/6N1/2Q5 w - - 0 1",
  "1q6/7k/4N3/8/7K/Q7/8/8 w - - 0 1",
  "1q6/8/5Q2/2k5/8/2N5/4K3/8 w - - 0 1",
  "8/8/8/1Q1N3k/8/6q1/3K4/8 w - - 0 1",
  "5Q2/8/8/7q/1KNk4/8/8/8 w - - 0 1",
  "5k2/2Q5/q7/6K1/8/1N6/8/8 w - - 0 1",
  "8/8/8/7K/3Q4/5k2/q1N5/8 w - - 0 1",
  "8/4K3/8/6Nk/8/8/6Q1/1q6 w - - 0 1",
  "K7/3k4/5Q2/7q/2N5/8/8/8 w - - 0 1",
  "4Q3/8/8/8/N2k2K1/8/8/1q6 w - - 0 1",
  "8/6N1/6P1/6K1/3k4/p7/8/8 w - - 0 1",
  "8/1q6/1N3K2/8/3Q4/k7/8/8 w - - 0 1",
  "1q6/8/8/N1k2K2/4Q3/8/8/1n6 w - - 0 1",
  "1N3k2/7K/1p6/8/6Q1/q7/8/8 w - - 0 1",
  "8/8/8/8/4k3/7Q/3qN3/1Kn5 w - - 0 1",
  "q4N2/8/6n1/2K1k3/8/8/8/5Q2 w - - 0 1",
  "8/1Pq1k3/8/8/2b5/8/2Q5/1K6 w - - 0 1",
  "8/5K2/5N2/6kp/7q/3Q4/8/8 w - - 0 1",
  "8/8/8/4k2P/K3N3/1p6/8/7n w - - 0 1",
  "1q6/2n5/8/8/N2k4/6Q1/3K4/8 w - - 0 1",
  "2q5/8/8/8/3N2p1/3k4/1Q6/4K3 w - - 0 1",
  "8/4N2P/K7/8/8/k7/N3p3/8 w - - 0 1",
  "5q2/5p1K/5k2/8/5NQ1/8/8/8 w - - 0 1",
  "8/6q1/8/p6Q/k7/8/K4N2/8 w - - 0 1",
  "8/8/2p5/4N3/k1K5/7q/4Q3/8 w - - 0 1",
  "8/4N3/1k6/2p5/8/8/6QK/3q4 w - - 0 1",
  "8/6p1/k2K4/8/5N2/8/6Q1/4q3 w - - 0 1",
  "8/6K1/3NP3/8/3k4/2p4n/8/8 w - - 0 1",
  "3q4/5Q2/3p4/8/2N5/1k6/8/3K4 w - - 0 1",
  "8/1P2K3/8/8/2k1pN2/8/5p2/8 w - - 0 1",
  "8/8/5N2/6P1/5k2/5pp1/8/4K3 w - - 0 1",
  "8/8/8/8/1q6/3Q3K/p7/k1N5 w - - 0 1",
  "7K/1P6/8/8/4N2k/8/7p/6r1 w - - 0 1",
  "4K3/1P6/N1k5/8/8/2r5/2p5/8 w - - 0 1",
  "K7/8/8/5q2/3Q4/k6p/4N3/8 w - - 0 1",
  "3N3K/3P4/6k1/6p1/8/1p6/8/8 w - - 0 1",
  "2k5/1N6/3Q4/8/1P6/8/4q3/2K5 w - - 0 1",
  "8/2P5/1KN5/8/8/8/2k2p1b/8 w - - 0 1",
  "6qk/8/8/6N1/3K4/2Q5/5p2/8 w - - 0 1",
  "b7/2K5/8/N2P4/pk6/8/8/8 w - - 0 1",
  "8/1q6/6k1/6N1/6Q1/1p6/1K6/8 w - - 0 1",
  "q7/4K3/8/4k3/1Q6/8/1p2N2p/8 w - - 0 1",
  "4N3/8/4p3/1Q6/2K1k3/6q1/4p3/8 w - - 0 1",
  "8/4p2p/1K6/3k4/8/5N2/5Q2/7q w - - 0 1",
  "QN6/P4q2/1p6/8/8/3k4/8/1K6 w - - 0 1",
  "8/1p4P1/8/8/7p/4k2K/p6N/8 w - - 0 1",
  "4k3/1N6/8/n5Kp/q7/8/1Q6/8 w - - 0 1",
  "3K4/8/p1k3N1/1p6/6Q1/1q6/8/8 w - - 0 1",
  "8/1q6/5Q2/1p2N3/5p2/k7/8/6K1 w - - 0 1",
  "8/8/3k2K1/5pQ1/8/p1q5/8/2N5 w - - 0 1",
  "1Q6/p2N3k/2p5/6q1/8/5K2/8/8 w - - 0 1",
  "8/8/7Q/3k1q1N/8/4P3/8/1n2K3 w - - 0 1",
  "4q3/5pK1/1p6/8/2N3k1/8/1Q6/8 w - - 0 1",
  "7k/3q4/8/8/6N1/8/n5Q1/Kn6 w - - 0 1",
  "4k3/2q1P3/Q7/4N3/8/8/6nK/8 w - - 0 1",
  "2K5/6Q1/3k1p2/3pN3/8/8/8/7q w - - 0 1",
  "7Q/3k2p1/6p1/8/1K2Np2/8/8/5q2 w - - 0 1",
  "8/8/4kN2/6K1/1p6/p2Q4/q7/8 w - - 0 1",
  "8/8/K7/5Qpk/2n4q/8/8/3N4 w - - 0 1",
  "2q4k/K3Q2p/8/8/3p4/5N2/8/8 w - - 0 1",
  "2q5/b7/1p6/1K1k4/3N4/8/8/3Q4 w - - 0 1",
  "8/8/p1Ppk3/5p2/8/8/1K6/3N4 w - - 0 1",
  "7K/8/8/Q4q2/8/5N2/7p/5B1k w - - 0 1",
  "3B4/8/3r4/6Q1/4kqN1/8/8/6K1 w - - 0 1",
  "Q7/4K3/8/2r3k1/8/8/3pp3/7N w - - 0 1",
  "8/8/p7/8/7p/2Q2N2/4q3/5k1K w - - 0 1",
  "1q6/5N2/4K3/8/3k4/p5pr/P1Q5/8 w - - 0 1",
  "q3N3/7p/1Q6/4kpK1/8/1p6/8/8 w - - 0 1",
  "1n6/8/3p4/3K1k2/6p1/8/4Q2N/6q1 w - - 0 1",
  "6q1/5r2/1pp5/2k3N1/P7/P3K2Q/8/8 w - - 0 1",
  "5Q2/1b1q4/1P5N/1p1P4/3k4/8/8/2K5 w - - 0 1",
  "1Q6/8/3N1k2/q2p4/P3p1K1/8/8/n7 w - - 0 1",
  "5n2/6Q1/K1p5/2q3pp/P6k/4N3/3P4/8 w - - 0 1",
  "2KN4/4k2p/7q/8/5p1r/7P/Q7/8 w - - 0 1",
  "8/1r3p2/8/4k1p1/3N4/3P3Q/2P2K2/q7 w - - 0 1",
  "8/Q4N1q/8/4K3/7k/2p5/1p1p4/8 w - - 0 1",
  "5q2/3p2N1/K7/7Q/4k3/p1P5/8/8 w - - 0 1",
  "2N1k3/8/7Q/2p1p3/q1n5/8/4PK2/8 w - - 0 1",
  "6q1/p3p3/3b4/8/2kPNp2/2P4Q/8/K7 w - - 0 1",
  "8/1P6/8/k2K4/4N3/5p2/pp6/6n1 w - - 0 1",
  "8/K7/p7/1q6/1P6/1n1p2NQ/8/4k3 w - - 0 1",
  "1n6/q7/2p5/4p3/2P1k3/7K/8/1N1Q4 w - - 0 1",
  "7q/K3p3/4Nr2/k3p2P/8/7Q/8/8 w - - 0 1",
  "4r1q1/7p/7Q/1K1k1p2/8/3N2P1/5P2/8 w - - 0 1",
  "2q5/p1p4Q/8/2p5/2N5/8/3K1k2/8 w - - 0 1",
  "7q/1pn3kp/3N4/8/8/8/8/1K3Q2 w - - 0 1",
  "7q/K1kp2p1/8/8/3PN2r/8/4Q3/8 w - - 0 1",
  "5b1q/6p1/8/1Q2N3/K3k3/4P3/8/8 w - - 0 1",
  "8/4K3/Q7/3k4/4b3/2P1p3/Nq6/8 w - - 0 1",
  "b1q5/5p2/8/P1k5/2p5/4K3/1Q4N1/8 w - - 0 1",
  "4K3/4N2P/4k3/3p4/5p2/b2P4/6p1/8 w - - 0 1",
  "1n2N3/qp6/8/1k1P4/4K3/3p4/5P2/7Q w - - 0 1",
  "8/8/8/1p4pQ/n1p2kP1/7P/1Pq2PpK/6N1 w - - 0 1",
  "q4k2/8/3p1N2/nP6/5K2/4p3/8/1Q6 w - - 0 1",
  "Q5n1/1p4q1/3p4/3k2N1/6p1/4P3/K7/8 w - - 0 1",
  "2K5/8/2kpN3/1p6/p2b4/P6Q/1q6/8 w - - 0 1",
  "1Q6/6kq/r6p/1pP5/1K1p4/2p2PN1/8/8 w - - 0 1",
  "1K6/8/5p2/3p4/pQbk2Pp/8/2qP3P/6N1 w - - 0 1",
  "K1k5/3p2q1/5N1b/8/2p5/8/3P2n1/Q7 w - - 0 1",
  "K7/8/k2p4/1p6/q3N3/8/1P5Q/1n6 w - - 0 1",
  "1q6/8/1n4N1/p3p3/4k3/1Q6/5K2/8 w - - 0 1",
  "8/5p2/Q7/2K3p1/3pk3/8/7q/4N3 w - - 0 1",
  "1q2N3/3p1Q2/3p3K/p7/b5k1/8/7P/8 w - - 0 1",
  "7b/4p3/1k6/4pQ2/K4N1q/7p/6PP/8 w - - 0 1",
  "2q5/3p4/5k2/rP6/p4Np1/3K4/8/7Q w - - 0 1",
  "8/3P3p/p5p1/2k5/5N2/8/1p3K2/8 w - - 0 1",
  "4n3/7q/1K6/8/3k2N1/2pp4/8/4Q3 w - - 0 1",
  "2q5/8/8/3NPpQ1/3k2p1/6K1/8/8 w - - 0 1",
  "Q6b/4p3/8/2K2N2/3p4/2k5/8/5q2 w - - 0 1",
  "2Q5/2p3p1/8/8/p3N3/6K1/4q3/7k w - - 0 1",
  "1q6/2rb4/2p2N2/5pK1/3k4/5P2/Q2P4/8 w - - 0 1",
  "8/b2p4/6K1/N2k4/3p3p/q7/8/3Q4 w - - 0 1",
  "8/8/8/K4pQ1/1Pb5/p2k1N2/8/q7 w - - 0 1",
  "n6q/8/2KN2k1/6p1/2p5/p7/8/6Q1 w - - 0 1",
  "6K1/3k4/8/5p2/1N1p3p/q7/6Q1/8 w - - 0 1",
  "2K5/8/p2Q4/4p1k1/4p3/2N5/8/6q1 w - - 0 1",
  "2K5/8/N1k5/4p2P/4p1p1/8/8/8 w - - 0 1",
  "8/5K2/Q5p1/4k3/3p4/5p2/Nq5P/8 w - - 0 1",
  "n7/8/3P3K/4pk2/6p1/p1P5/2P3N1/8 w - - 0 1",
  "1q6/3b4/3pk1K1/8/4N3/7p/4P3/7Q w - - 0 1",
  "8/7p/2pp1qpP/p2b4/P7/NPk5/8/2KQ4 w - - 0 1",
  "8/8/K2p4/2bQ4/5k2/pP3N2/2P5/7q w - - 0 1",
  "8/8/2Q4K/5p2/1k1qn1N1/1P3p2/5P2/8 w - - 0 1",
  "8/b1q5/2p5/3p2pQ/1P2k1P1/8/3KP3/1N6 w - - 0 1",
  "3k4/2ppq3/4p2N/3P4/7p/2p5/6Q1/4K3 w - - 0 1",
  "8/4p2K/pp6/5k1P/3bp2P/P4N2/1P4QP/3q4 w - - 0 1",
  "2N1k3/1p1p4/3b4/4p3/8/p2qP3/P2P4/4K2Q w - - 0 1",
  "4N3/3pPq2/1k2p2b/8/7p/1p6/1P6/3K3Q w - - 0 1",
  "2K3Q1/8/4pk2/p2b4/P4qP1/3P4/1b6/6N1 w - - 0 1",
  "Q7/K3pn2/3pN3/k2P2pP/p1P5/2p5/2q5/8 w - - 0 1",
  "7q/3p1K2/7k/1Q3pp1/2p5/4N3/8/8 w - - 0 1",
  "3k4/8/4K2p/3N4/1p4p1/1Q6/7q/8 w - - 0 1",
  "N7/p7/8/q1p5/1p6/k7/8/1K1Q4 w - - 0 1",
  "3Q4/1q3k1p/4N1p1/2n2p2/8/7K/5P1P/8 w - - 0 1",
  "3q4/2p2p2/p1kb4/8/8/2P2N2/K7/7Q w - - 0 1",
  "8/8/1q1p4/1ppp4/8/5N1K/5k2/3Q4 w - - 0 1",
  "5q2/6p1/8/1Q6/4k3/3N3P/4r3/6K1 w - - 0 1",
  "8/3pp3/2b3p1/7q/5k2/8/6PN/2K1Q3 w - - 0 1",
  "8/8/3pp2p/p4n1q/k6p/3P4/P3N2K/4Q3 w - - 0 1",
  "8/8/2kpP3/5p2/1p3N1p/8/4K3/8 w - - 0 1",
  "7n/4Kp2/PN4pB/6Pp/1k1q4/8/2P5/8 w - - 0 1",
  "b7/7K/2p5/2p5/5N2/8/p1pQ4/1k6 w - - 0 1",
  "3Kn1k1/P4N1p/6P1/5N1n/8/8/2p1p3/8 w - - 0 1",
  "q1k5/8/1Q6/8/NK5b/2p5/7p/8 w - - 0 1",
  "2N1KQ2/6pk/8/7p/p6P/8/3p4/6q1 w - - 0 1",
  "1q6/8/3k4/2p4Q/1N6/7p/4K1n1/8 w - - 0 1",
  "8/4p3/8/K2B4/8/8/4Q3/kq6 w - - 0 1",
  "6qk/3Q4/8/8/4B2K/3p4/8/8 w - - 0 1",
  "8/8/3B4/7K/8/8/3Q4/6qk w - - 0 1",
  "1Q6/8/q4p2/8/8/8/5K2/kB6 w - - 0 1",
  "7k/6q1/8/8/4B3/Q7/8/7K w - - 0 1",
  "8/8/8/7K/5B2/8/2Q5/6qk b - - 0 1",
  "8/4Q3/8/6K1/4B3/8/8/2k2q2 w - - 0 1",
  "6qk/2Q5/8/8/p3B2K/8/8/8 w - - 0 1",
  "kq6/3Q4/8/3K4/2B5/8/8/8 w - - 0 1",
  "3B4/4P3/8/8/8/3K4/p7/1k6 w - - 0 1",
  "1k3q2/1B5K/8/8/8/7b/8/1Q6 w - - 0 1",
  "b2k2K1/8/q2B4/8/8/7Q/8/8 w - - 0 1",
  "8/5q2/1Q5K/8/4k3/8/3B4/8 w - - 0 1",
  "1k6/1q6/3K4/1QB5/8/2p5/8/8 w - - 0 1",
  "8/8/p1Q5/8/3k3B/8/4q3/1K6 w - - 0 1",
  "3k1K2/8/6q1/8/8/n4Q2/8/4B3 w - - 0 1",
  "8/k7/2Q5/1K4B1/2pq4/8/8/8 w - - 0 1",
  "8/3k4/7B/1K6/2pq4/5Q2/8/8 w - - 0 1",
  "2Q5/8/8/3k4/1Bq5/5K2/8/8 w - - 0 1",
  "Q7/8/8/5k2/8/6q1/3K2B1/8 w - - 0 1",
  "6Q1/8/8/8/4B3/8/3k1K2/q7 w - - 0 1",
  "2qB4/8/4k3/8/4K3/8/8/6Q1 w - - 0 1",
  "7Q/5B2/8/k7/4p3/4K3/8/1q6 w - - 0 1",
  "4q1B1/8/8/8/4k3/1Q6/7K/8 w - - 0 1",
  "8/5B2/q7/8/4k3/8/5K2/3Q4 w - - 0 1",
  "2q5/6p1/8/8/Q7/8/B2K3k/8 w - - 0 1",
  "8/8/4k3/6K1/q7/3B4/8/6Q1 w - - 0 1",
  "2q5/p7/8/8/B4k2/8/3K4/6Q1 w - - 0 1",
  "5B2/8/7p/7q/3k4/6p1/Q7/5K2 w - - 0 1",
  "4Q3/3B4/8/7q/7k/8/8/5K2 w - - 0 1",
  "8/4Q3/2B5/8/3k4/8/3q4/5K2 w - - 0 1",
  "8/8/3B4/1k6/8/1K5Q/8/6q1 w - - 0 1",
  "1Q6/7q/8/8/8/p4B2/2k5/4K3 w - - 0 1",
  "3q4/1K5B/4k3/5p2/8/8/7Q/8 w - - 0 1",
  "8/8/p6k/8/6K1/q7/5B2/1Q6 w - - 0 1",
  "1k6/7B/8/p5Q1/2K5/8/8/3q4 w - - 0 1",
  "8/1B3k2/8/6K1/q7/8/8/6Q1 w - - 0 1",
  "4q3/8/B2Q4/8/8/1k6/3K4/8 w - - 0 1",
  "8/1K1k4/8/8/3B2p1/8/6Q1/2q5 w - - 0 1",
  "2K5/8/5B2/3k4/q7/4p3/8/1Q6 w - - 0 1",
  "8/2p4K/2B5/8/6k1/1Q6/8/q7 w - - 0 1",
  "5k2/8/6K1/1Q6/7p/1Bq5/8/8 w - - 0 1",
  "8/4q2B/1Q6/8/2k5/8/8/3K4 w - - 0 1",
  "3q4/8/8/7k/8/B7/4K3/1Q6 w - - 0 1",
  "6k1/8/8/2Q5/7K/1q5B/8/8 w - - 0 1",
  "8/8/7k/4Q3/6K1/3q1B2/8/8 w - - 0 1",
  "B3K3/8/8/P1p5/8/8/2b4k/8 w - - 0 1",
  "B7/7K/P7/8/2p5/6k1/8/5b2 w - - 0 1",
  "8/8/8/K2k4/Q6B/8/8/7q w - - 0 1",
  "k7/3p1B2/7K/4Q3/8/8/2q5/8 w - - 0 1",
  "7q/k2K1p2/8/B7/6Q1/8/8/8 w - - 0 1",
  "K7/5k2/7B/8/1Q6/p7/q7/8 w - - 0 1",
  "8/5K2/8/7k/p6q/8/3Q4/6B1 w - - 0 1",
  "8/8/8/8/5q1B/2k5/Q7/3K4 w - - 0 1",
  "7Q/8/8/8/B1q5/5k2/8/4K3 w - - 0 1",
  "8/8/8/Q1p4K/3B4/8/6k1/2q5 w - - 0 1",
  "4K2k/4B3/8/8/8/4Q3/1q6/8 w - - 0 1",
  "4K2k/4B3/1b3P2/8/8/8/p7/8 w - - 0 1",
  "8/1q6/3B4/8/2Q5/4k2K/4p3/8 w - - 0 1",
  "2k5/4K3/8/8/4B2P/5p2/6n1/8 w - - 0 1",
  "8/8/8/k7/1rB2QK1/8/2q5/8 w - - 0 1",
  "8/5P2/B4K2/8/4k3/8/7p/1r6 w - - 0 1",
  "Q7/8/5r2/6q1/3k4/8/2K4B/8 w - - 0 1",
  "3b4/4P3/8/8/1K6/8/7p/5B1k w - - 0 1",
  "8/1Q6/8/7q/1K6/7B/1k6/8 w - - 0 1",
  "8/K2k4/8/4B2p/8/8/2Q5/7q w - - 0 1",
  "B6q/8/1k6/8/5Q2/K7/8/8 w - - 0 1",
  "5q2/8/8/4B3/7k/2Q4p/7K/8 w - - 0 1",
  "8/1K6/4k2P/4B3/4p3/5p2/8/8 w - - 0 1",
  "1q6/p7/B7/8/7K/5k2/8/Q7 w - - 0 1",
  "3q4/8/8/8/1B3k2/7Q/4K3/8 w - - 0 1",
  "7K/3kB3/5Q2/8/8/8/5q2/7n w - - 0 1",
  "k2K4/8/6P1/2B5/5P2/p7/4p2b/8 w - - 0 1",
  "8/P7/8/6q1/r7/8/5Q2/4BK1k w - - 0 1",
  "8/5B2/q7/4kp1Q/8/5K2/8/7n w - - 0 1",
  "8/8/4b1pq/K3kp2/6P1/Q7/5PB1/8 w - - 0 1",
  "8/5pB1/3q4/4pPp1/2Pk2P1/5K2/p7/1bQ5 w - - 0 1",
  "8/2p2B2/5PK1/3Pk3/8/7p/8/8 w - - 0 1",
  "q7/k1BQ4/3K4/p5p1/8/8/8/8 w - - 0 1",
  "1K4k1/2p5/8/4p3/4Q3/3B4/8/3q4 w - - 0 1",
  "3k4/4p1q1/1K6/7B/3p4/8/8/3Q4 w - - 0 1",
  "8/nq6/8/8/B2Qp3/7k/8/6K1 w - - 0 1",
  "6k1/3Bn1p1/8/6q1/8/8/5K2/7Q w - - 0 1",
  "6q1/2K5/5Q2/3k4/8/6p1/2B5/5b2 w - - 0 1",
  "8/7k/1p5q/4Q3/1pK3B1/8/8/r7 w - - 0 1",
  "6q1/1p6/8/6Bk/Q7/3K4/8/6b1 w - - 0 1",
  "1Q6/4p3/4K3/pB6/8/8/1k6/2q5 w - - 0 1",
  "q4B2/8/8/8/4p3/pk6/6Q1/4K3 w - - 0 1",
  "b7/q7/8/8/8/p6B/Q7/5K1k w - - 0 1",
  "8/8/1K4p1/2p3k1/8/8/8/3Q1B1q w - - 0 1",
  "8/3b2Bq/8/7p/6k1/8/6K1/Q7 w - - 0 1",
  "8/1K1P4/5B2/8/pkb5/8/5p2/8 w - - 0 1",
  "8/4p3/4p3/7K/8/6q1/1BQ5/6k1 w - - 0 1",
  "8/5pP1/5K2/B7/6k1/6n1/7p/8 w - - 0 1",
  "7q/8/3p2B1/8/7p/5k2/8/4Q1K1 w - - 0 1",
  "8/3Q3p/8/8/3pk3/6K1/q2B4/8 w - - 0 1",
  "k3K3/7b/8/1pP5/8/1p5B/8/8 w - - 0 1",
  "8/3p4/2k3K1/8/3p4/B2Q4/8/q7 w - - 0 1",
  "1B6/1P1K1n2/8/8/8/p4k1p/8/8 w - - 0 1",
  "8/8/Q7/1B6/p5p1/8/8/1K1kq3 w - - 0 1",
  "Q3B3/8/4q3/4p1b1/8/8/2K1k3/8 w - - 0 1",
  "3k4/Qp6/8/2p3K1/B1q5/8/8/8 w - - 0 1",
  "8/1b6/8/8/4p3/8/pk3KB1/7Q w - - 0 1",
  "4B3/5P1P/6n1/8/8/7K/4p3/2k5 w - - 0 1",
  "8/1KQ5/3B4/3kp3/3p3q/8/8/8 w - - 0 1",
  "8/4Q3/p7/5k2/8/K2p4/6q1/4B3 w - - 0 1",
  "QBkq3n/7K/8/8/8/2p5/8/8 w - - 0 1",
  "n3q1k1/p7/Q4K2/1p3B1p/8/8/8/8 w - - 0 1",
  "6k1/6p1/5qBb/5p1K/7P/8/8/Q7 w - - 0 1",
  "b7/4QBqP/1p5k/6p1/4p3/8/6K1/8 w - - 0 1",
  "8/1p2K1k1/6q1/8/8/3p4/5B2/1n4Q1 w - - 0 1",
  "1k6/8/K4p2/2Q1b3/4P3/7q/8/6B1 w - - 0 1",
  "8/6B1/1K3bp1/4qB2/8/4k3/8/5Q2 w - - 0 1",
  "8/3Q4/b7/4k1P1/2p4q/8/6B1/6K1 w - - 0 1",
  "7b/5P2/1p4k1/2q5/K7/5B2/8/5Q2 w - - 0 1",
  "4Q3/3p4/4b3/5k2/B1p5/5pK1/1q2P3/8 w - - 0 1",
  "7k/Q7/8/3B4/1p5q/2pP4/Kb6/8 w - - 0 1",
  "5B2/8/4p2p/p5q1/2k4n/4p3/4K3/Q7 w - - 0 1",
  "8/2BQ4/3p4/3p1p1k/1q6/8/5p2/5K2 w - - 0 1",
  "2Q5/8/3q2p1/3pk1B1/2p5/3P4/2K5/8 w - - 0 1",
  "q5b1/2p1p3/B7/3p4/p2k4/6K1/1P1P4/7Q w - - 0 1",
  "3q4/7Q/2p1p3/3p4/3k4/8/2K5/4B3 w - - 0 1",
  "8/3q1p2/2p1bk2/B7/8/6Q1/4P3/2K5 w - - 0 1",
  "2n5/8/4p1pB/Q7/3qk2P/8/4K3/8 w - - 0 1",
  "8/7b/K1k1p3/2Bp2q1/4p3/P7/P4Q2/8 w - - 0 1",
  "7q/1Q6/3Bp2p/b1p3k1/8/5pK1/8/8 w - - 0 1",
  "k7/8/5p2/3p4/6Q1/KB6/4pq2/8 w - - 0 1",
  "q7/p4n2/B2pk3/8/7Q/8/3K4/8 w - - 0 1",
  "7q/7p/1p5B/5p2/4k3/1Q6/8/5K2 w - - 0 1",
  "2Q3K1/1p6/6k1/4p3/4qp2/2B5/8/8 w - - 0 1",
  "7Q/8/1q1p4/3p4/2p1k3/6K1/B7/8 w - - 0 1",
  "q7/3k4/B2p4/8/2P5/3Q1p2/b7/6K1 w - - 0 1",
  "B7/8/5k1K/8/q1Pp4/8/2n4Q/8 w - - 0 1",
  "8/1Pp4K/5k2/8/4p1B1/2p5/6p1/8 w - - 0 1",
  "k7/3p2Q1/p7/5qP1/P7/8/1K6/5bB1 w - - 0 1",
  "q6B/5k2/8/8/p3P3/1b1p1PK1/8/2Q5 w - - 0 1",
  "8/8/3p3q/K6p/2kB1p2/8/6Q1/8 w - - 0 1",
  "8/2K5/4B3/8/r1p1k3/7Q/2Pq1P2/8 w - - 0 1",
  "8/B7/7q/1K1k4/8/3pp3/8/3Q4 w - - 0 1",
  "qB6/8/p7/8/P4p2/3p1k1n/P1b5/4K1Q1 w - - 0 1",
  "5n1n/1p1p3q/3P4/1p6/1p1B2Q1/1P1p4/7k/K7 w - - 0 1",
  "K7/1p4p1/B7/8/k7/5p1P/1Q5b/6q1 w - - 0 1",
  "8/8/K7/8/2B4p/2k2p2/7b/5Qq1 w - - 0 1",
  "8/n5q1/B7/5pp1/P4k2/8/2pK4/1b5Q w - - 0 1",
  "5B2/7Q/p7/2p1pp1p/5k1q/7P/4K3/8 w - - 0 1",
  "1B6/p6p/p7/8/7q/K1k5/6Q1/8 w - - 0 1",
  "1Q3n2/p7/8/1B3p2/3k4/q7/3Kp3/8 w - - 0 1",
  "8/2p4p/8/4B2P/6q1/4k3/1Q6/5K2 w - - 0 1",
  "8/Q1p4p/8/4B2P/6q1/4Pk2/8/5K2 w - - 0 1",
  "8/8/4p3/2q2bB1/8/3k4/K2P4/4Q3 w - - 0 1",
  "1K4Bn/8/8/8/8/6p1/1k4p1/4Q2q w - - 0 1",
  "8/2p3B1/1P6/p2n4/p7/K6p/8/5k2 w - - 0 1",
  "8/8/4n2p/2Q5/B3k2p/8/2p4K/2q5 w - - 0 1",
  "7q/1Q1p4/2p2ppP/2P5/5nK1/4kP2/8/4B3 w - - 0 1",
  "r3q3/p7/1p3p2/1k4p1/8/Q4P2/P1P2K2/3B4 w - - 0 1",
  "7K/4Q3/b7/8/6B1/2p5/q4P2/7k w - - 0 1",
  "7K/p7/4p3/8/2b3B1/2P1Q3/q4P2/7k w - - 0 1",
  "4K3/p5p1/8/2k5/5p2/8/p2Q4/qB6 w - - 0 1",
  "B1K5/p1p5/1P6/8/p2N4/p2kb3/8/8 w - - 0 1",
  "1q6/1p6/7k/1p6/6K1/Q2p4/B7/8 w - - 0 1",
  "7Q/8/3pk2p/7P/8/p2q1B2/2p2P2/1bK5 w - - 0 1",
  "3Q4/p2B3p/2pkp3/6p1/7q/2P5/2p3P1/2Kn4 w - - 0 1",
  "1Q6/1p3pbp/p1k5/8/1P1p1P1K/3q4/8/3B4 w - - 0 1",
  "8/8/1kP2Qb1/p7/P4K2/1q6/8/2B5 w - - 0 1",
  "5qn1/4p3/2Q3K1/2p1B3/2k5/5p2/8/8 w - - 0 1",
  "8/8/3p4/B1kq1b2/8/8/4Q2P/2K5 w - - 0 1",
  "1q6/2b2p1p/7k/8/1p1Q4/8/1K3B2/8 w - - 0 1",
  "8/qp1p1p1p/p4k2/B6Q/8/1p6/1K6/n7 w - - 0 1",
  "3q3b/B7/8/5p1Q/p2p1P2/1k1P4/8/2K5 w - - 0 1",
  "B7/2Q3K1/8/1p4k1/8/2p4p/8/5q2 w - - 0 1",
  "8/p3B3/4P3/2p4K/8/2p4n/8/3N3k w - - 0 1",
  "3n4/p2pp1q1/K2k1n2/3p1P2/5P2/4Q3/7B/8 w - - 0 1",
  "8/n3Kp2/2Q2p2/4k3/6p1/6p1/q5P1/2B5 w - - 0 1",
  "5B2/6pq/p7/8/8/1k6/8/2K1nQ2 w - - 0 1",
  "5Bbk/q7/8/p7/8/K7/5P2/6Q1 w - - 0 1",
  "4n3/4P1Bp/N2p3K/p1P1p3/4k3/5p2/8/8 w - - 0 1",
  "6q1/2p3p1/6K1/5Q2/3p1B2/8/8/5k2 w - - 0 1",
  "7q/6p1/2Q3p1/2B5/K7/2k4p/8/8 w - - 0 1",
  "Q7/8/1p2p3/1B6/p5p1/8/7q/1K1k4 w - - 0 1",
  "7k/q7/2p1Q3/8/3pp1B1/8/6K1/8 w - - 0 1",
  "8/Kp6/1p1k4/8/p1p5/q6B/1n6/6Q1 w - - 0 1",
  "8/8/q1k1K1B1/6p1/1Q1p4/8/5p2/8 w - - 0 1",
  "8/8/1p6/1qp5/4QB2/2p5/5K2/3k4 w - - 0 1",
  "6k1/1K6/3B4/1p6/1p5Q/4q3/8/n7 w - - 0 1",
  "8/8/3k1Bp1/1q1p3p/p7/4Q3/8/K7 w - - 0 1",
  "8/1K1p4/3p4/2pkP3/8/2QB4/q7/8 w - - 0 1",
  "7Q/5k2/q3pp2/p5p1/2p5/8/4B3/4K3 w - - 0 1",
  "8/6p1/1Qp5/5p2/8/1B3p1q/3k4/K7 w - - 0 1",
  "1B6/7P/8/1p6/8/5k2/p2K2p1/4n3 w - - 0 1",
  "3n4/8/K1kPP1q1/8/8/7Q/3p4/3B4 w - - 0 1",
  "8/1p5p/4K3/2p1B3/8/1p5k/4Q3/7q w - - 0 1",
  "8/3p4/8/8/B7/q1Pk4/4b2Q/1K6 w - - 0 1",
  "8/8/R7/4r1p1/7n/8/7R/1K1k4 w - - 0 1",
  "8/8/4R3/2k5/4n1K1/4r3/7R/8 w - - 0 1",
  "8/1R6/5k2/8/2n1K3/6r1/8/7R w - - 0 1",
  "2R5/4k3/1n6/8/3K1R2/4r3/8/8 w - - 0 1",
  "4r3/5k2/1n6/8/8/6R1/8/6RK w - - 0 1",
  "8/k7/r7/8/7n/6R1/b2R4/7K w - - 0 1",
  "8/5k2/6r1/8/2n5/R4K2/1R6/8 w - - 0 1",
  "5k1r/R5R1/3n4/4p3/8/8/6K1/8 w - - 0 1",
  "2k5/8/rn6/6R1/7R/1K6/8/8 w - - 0 1",
  "6k1/8/1rn5/3R4/3R4/2K5/8/8 w - - 0 1",
  "8/p1k5/5p2/8/4R1K1/8/3rn3/5R2 w - - 0 1",
  "8/R1p5/4p3/4n3/4r3/8/7R/1K1k4 w - - 0 1",
  "2R5/8/5R2/1k6/3nK3/8/3r4/8 w - - 0 1",
  "3r1k2/8/n7/8/8/1R6/4K3/1R6 w - - 0 1",
  "8/8/6R1/k4n2/8/8/5r2/4R2K w - - 0 1",
  "4r3/4n3/8/8/4k3/5R2/4K3/5R2 w - - 0 1",
  "8/2RR4/8/8/4k1K1/8/r2n4/8 w - - 0 1",
  "8/5p1n/1k6/2R5/4p3/8/1r6/2R1K3 w - - 0 1",
  "3k4/7r/2K5/R4R2/8/6b1/8/8 w - - 0 1",
  "8/8/3b4/8/R6R/4k3/6r1/4K3 w - - 0 1",
  "8/8/7R/k4b2/8/6R1/5r2/3K4 w - - 0 1",
  "4k3/7R/4r3/6K1/6R1/8/1b6/8 w - - 0 1",
  "6b1/3kr3/8/8/3K4/8/8/R4R2 w - - 0 1",
  "4r3/RK6/3k4/8/7b/1R6/8/8 w - - 0 1",
  "r7/3R4/2K4p/1p2b3/6R1/8/8/7k w - - 0 1",
  "3b4/1K3Rp1/8/k7/8/8/r7/1R6 w - - 0 1",
  "3k1r2/4R1R1/8/8/8/8/8/1b2K3 w - - 0 1",
  "5kbr/1R6/8/8/8/p7/8/R3K3 w Q - 0 1",
  "8/3k1b1K/2rp4/8/8/8/3R4/6R1 w - - 0 1",
  "8/6k1/3K2b1/8/7r/6R1/8/R7 w - - 0 1",
  "8/r3b3/k7/8/8/8/KR6/5R2 w - - 0 1",
  "8/r7/k7/4n3/8/8/KR6/6R1 w - - 0 1",
  "4R3/8/8/8/5k1r/R7/2b3K1/8 w - - 0 1",
  "2b1k3/8/8/r6P/8/1R6/7K/3R4 w - - 0 1",
  "1r6/8/2k5/R7/K5b1/8/5R2/8 w - - 0 1",
  "3r4/8/3b1k1K/R7/8/8/6R1/8 w - - 0 1",
  "1br5/3k1K2/4R3/1R6/8/8/8/8 w - - 0 1",
  "5r2/5b2/8/6k1/8/4K3/3R4/5R2 w - - 0 1",
  "2kr4/3b4/8/8/8/8/8/R1KR4 w - - 0 1",
  "2R1K3/R7/6p1/P7/1k3r2/8/3p3b/8 w - - 0 1",
  "8/5p2/8/5k2/5r2/2R2b2/3K4/R7 w - - 0 1",
  "4k3/7R/4r3/7K/7R/8/1b6/8 w - - 0 1",
  "1r1k1K2/6R1/8/8/2b5/R6p/8/8 w - - 0 1",
  "8/4R1R1/3p3r/8/1p6/3p3k/b7/5K2 w - - 0 1",
  "8/7p/4p3/4Pp2/b4r2/8/1R3pR1/5K1k w - - 0 1",
  "1r5b/4P2R/p3k3/8/8/8/2K5/5B2 w - - 0 1",
  "3k4/5Pbr/1KB5/8/1P6/8/7p/7R w - - 0 1",
  "6k1/1B5p/1p6/3n4/3r4/7P/5KP1/2R5 w - - 0 1",
  "5n2/8/p7/1r4p1/3p4/7k/1PB2P1P/1K2R3 w - - 0 1",
  "4R3/2p5/2Pk4/6N1/8/r1p4B/1p2bP2/1K6 w - - 0 1",
  "kr6/4P3/1pb5/p5p1/P4p2/P3R3/5P2/2K2B2 w - - 0 1",
  "4r1k1/5b2/4P3/8/8/4KB2/6P1/2R5 w - - 0 1",
  "3n3k/6r1/6p1/8/6K1/2R4P/8/4B3 w - - 0 1",
  "1r3k2/8/3b2p1/3P4/1p6/6P1/K4B2/7R w - - 0 1",
  "7k/5p1p/7R/3r4/1P6/8/4P2b/2B2K2 w - - 0 1",
  "R7/3p1p1b/6p1/3P4/3k3B/8/P3rP2/2K5 w - - 0 1",
  "6r1/6b1/8/8/8/p1P5/P3B1R1/4k1K1 w - - 0 1",
  "6k1/8/rb5p/8/7K/1P6/8/4RB2 w - - 0 1",
  "1n6/8/P4p2/5k1K/6p1/rN1p4/2P4P/4R3 w - - 0 1",
  "8/4P3/k7/3p4/3Nr3/8/6p1/3R2Kb w - - 0 1",
  "8/4P3/4r3/k7/8/4N3/6p1/1R4Kb w - - 0 1",
  "3N4/8/4P3/8/k6p/6p1/4r1Pb/5R1K w - - 0 1",
  "8/4Pp2/8/k4N2/4r3/6p1/6Pb/5R1K w - - 0 1",
  "8/p6p/4P3/k7/3Nr1p1/6p1/6Kb/5R2 w - - 0 1",
  "R3b3/N1r2p2/7B/k7/8/8/8/6K1 w - - 0 1",
  "r3k3/p5pp/5p2/1K2n3/P4PN1/8/1R4P1/8 w q - 0 1",
  "7k/1p6/4K3/3RN3/8/8/8/4r1n1 w - - 0 1",
  "3B4/6pn/6r1/1KN5/8/6p1/5k2/R7 w - - 0 1",
  "8/7n/8/3k3N/8/1p3r2/1P6/R3K3 w Q - 0 1",
  "8/6k1/4r3/2R5/B7/6Nb/5K2/8 w - - 0 1",
  "8/6b1/3r4/R7/4k3/8/4K3/5NN1 w - - 0 1",
  "3k4/1prp4/1p4p1/8/2N1R3/PPP1Kp2/5Pb1/8 w - - 0 1",
  "8/1k2N3/2Rb4/3r4/2p5/3N4/3P4/2K5 w - - 0 1",
  "4kb2/1p1R4/1r6/4p1N1/1P6/8/P5N1/1K6 w - - 0 1",
  "6B1/3K3p/7r/6R1/8/6B1/6n1/7k w - - 0 1",
  "4r3/2n5/8/2BR2P1/2k5/8/K4N2/8 w - - 0 1",
  "5r2/5N2/5R2/k4P2/N5K1/8/8/6b1 w - - 0 1",
  "3k4/1K1b4/8/2rN4/8/8/8/3B3R w - - 0 1",
  "3Bb3/1p1k4/2r5/8/1R4p1/2PpK1R1/2p3P1/8 w - - 0 1",
  "3k4/1n6/p7/1N6/5r2/P7/1R6/N2K4 w - - 0 1",
  "4k1r1/8/8/3p1K2/8/3P2p1/2R2pP1/5Bb1 w - - 0 1",
  "3r3r/2k5/K7/8/2B5/3R4/8/5Rb1 w - - 0 1",
  "8/5B2/3n4/R6R/3r1r2/4k3/8/4K3 w - - 0 1",
  "4rkn1/2R5/4r3/8/5N1R/8/8/6K1 w - - 0 1",
  "2kr4/R4R2/3b3K/3r2N1/8/8/8/8 w - - 0 1",
  "6r1/6k1/4nR2/3N4/4r3/8/8/5R1K w - - 0 1",
  "7r/5k1n/8/2Q2K2/8/8/8/8 w - - 0 1",
  "8/7Q/4b2R/8/5n2/2K4p/8/4kr2 w - - 0 1",
  "8/8/8/1r6/k7/n1K5/7Q/8 w - - 0 1",
  "3kr3/4n3/7Q/8/1K6/8/8/8 w - - 0 1",
  "8/8/n7/8/8/1k6/6r1/QK6 w - - 0 1",
  "1k6/8/7Q/8/4n3/5p2/6r1/4K3 w - - 0 1",
  "8/Q7/8/5K2/8/7k/8/2r2n2 w - - 0 1",
  "k1b5/7r/1PK5/1Q6/8/8/8/8 w - - 0 1",
  "8/1k6/8/Q7/7p/6p1/6pr/6Kb w - - 0 1",
  "1K6/8/2R2P2/8/8/5b2/6r1/7k w - - 0 1",
  "3k4/2r1b3/1Q2K3/8/8/8/8/8 w - - 0 1",
  "4kq2/6pb/6r1/1N3QPK/8/8/8/8 w - - 0 1",
  "1k6/2br4/8/1K6/8/7b/1Q6/8 w - - 0 1",
  "1r5k/3n1p2/4p1b1/8/8/6Q1/7K/2B5 w - - 0 1",
  "4br2/2P1p2K/3P4/8/8/8/8/k7 w - - 0 1",
  "1r2b3/8/8/4K3/8/8/1k6/6Q1 w - - 0 1",
  "8/8/2p1b3/8/8/3Q4/4K3/k1r5 w - - 0 1",
  "3b3Q/2p5/k7/P7/2K5/8/3r4/8 w - - 0 1",
  "5b2/8/k7/4p3/8/1K4Q1/8/3r4 w - - 0 1",
  "3Q4/1r6/8/8/5b1K/8/8/7k b - - 0 1",
  "7k/8/8/2K5/7r/8/7b/2Q5 w - - 0 1",
  "3b3k/Q7/8/8/6r1/8/8/4K3 w - - 0 1",
  "5Q2/1n6/8/3b4/1K6/8/6r1/7k w - - 0 1",
  "7k/8/2b1K3/8/5Q2/6n1/7r/8 w - - 0 1",
  "7k/6rq/5Q2/8/1K6/8/8/6R1 w - - 0 1",
  "6rk/5Q1q/8/1K4R1/8/8/8/8 w - - 0 1",
  "6rk/5Q1q/8/K7/8/8/8/5R2 w - - 0 1",
  "kq6/1r6/3R4/7p/p7/P7/7Q/7K w - - 0 1",
  "1q6/1p6/3r4/Q2P2p1/5k2/8/3P1K2/7R w - - 0 1",
  "8/6q1/2k2r2/8/1K6/8/4R3/5Q2 w - - 0 1",
  "8/1qr5/8/2p1R3/3k4/8/4K2Q/8 w - - 0 1",
  "8/8/1n5q/5rp1/4k3/P1K2pPP/Q6R/8 w - - 0 1",
  "8/6pq/K7/2k5/P2pr3/8/RQ6/8 w - - 0 1",
  "1q1r4/4k3/8/2R3K1/8/8/8/2Q5 w - - 0 1",
  "2R2Q2/6pk/1p3q2/7p/1p1P4/8/5PPK/1r6 w - - 0 1",
  "b1k5/1q6/8/8/3p4/6p1/RQ6/6K1 w - - 0 1",
  "k4q2/8/8/2p5/8/2K4R/5r2/4Q3 w - - 0 1",
  "4k3/2r4q/3Q2p1/6R1/5P2/8/8/6K1 w - - 0 1",
  "5r1k/7q/8/8/8/8/2QR4/3K4 w - - 0 1",
  "1r4B1/P5K1/1q6/8/8/B4b2/R2b3k/4N3 w - - 0 1",
  "k4r1q/8/K5P1/1n1P4/5B2/8/4R3/7B w - - 0 1",
  "1k5r/pP3ppp/1p1q4/8/Q7/8/1P4P1/K1R5 w - - 0 1",
  "1k1r4/pP2q3/8/Q7/8/6bP/6P1/2R4K w - - 0 1",
  "2k2q2/2P5/pP2P3/2r1P3/8/4K3/1Q6/8 w - - 0 1",
  "2k1bN2/2r5/1qP5/1p1R4/1p1p1p2/1P3Q2/8/1K6 w - - 0 1",
  "8/2p4q/P1p4r/7p/k4p2/3P1P1K/5QP1/8 w - - 0 1",
  "7K/1bb5/1p4P1/2P1p1pk/4P3/B7/6P1/8 w - - 0 1",
  "k2r1q2/2b2p1Q/7R/pK6/2N5/1P6/8/8 w - - 0 1",
  "r7/5p2/8/p6P/2kP1P2/Q7/4N1q1/1K3n2 w - - 0 1",
  "8/N2kPp2/8/2p5/2q1pQP1/2P5/3p4/5nK1 w - - 0 1",
  "2b1k3/2p1p3/8/4P1N1/8/4q3/6P1/Q6K w - - 0 1",
  "2b1N3/2p1pk2/8/4P3/4N2Q/1p2q3/1P6/K7 w - - 0 1",
  "8/2p2k2/4p1NP/p5p1/8/b7/P4P1P/1K1b2N1 w - - 0 1",
  "4r3/2PkN2q/5pN1/2K5/6P1/4R3/8/8 w - - 0 1",
  "8/8/5Q2/6N1/7p/1b5P/2q5/4k1K1 w - - 0 1",
  "6Q1/8/p1rq4/5r2/k5NR/8/B7/7K w - - 0 1",
  "k1K5/1p2p3/4P3/1b6/6r1/3RN3/8/8 w - - 0 1",
  "1B3k2/1P2p2K/5q2/8/8/3p3R/R7/8 w - - 0 1",
  "4Q1B1/1b6/q1p2p1p/1r3P2/5P1k/4PK2/8/8 w - - 0 1",
  "8/8/8/8/5bp1/1RNK3p/6p1/4k1r1 w - - 0 1",
  "6n1/2p5/r6p/3Q1b1p/2K5/p1b1p1p1/kp3p2/q4r1n w - - 0 1",
  "8/7p/7p/p4n1p/b3Q2p/K2p3p/p1r5/rk5n w - - 0 1",
  "5q1k/Q7/n1P3R1/3bpp2/3n4/2p5/1pP3RP/7K w - - 0 1",
  "6R1/5Bpk/4p2p/2Rp3P/2p5/1p6/p1b4K/1q6 w - - 0 1",
  "8/3K4/6n1/P2k2p1/2r5/2P2N1P/1q1ppN1P/5n1B w - - 0 1",
];
